(function () {
  var config = window.KKHeadlessCollection || {};
  var language = window.Theme && window.Theme.language ? window.Theme.language : {};
  var states = new WeakMap();
  var metafieldValuesCache = new WeakMap();
  var colorPatternValuesCache = new WeakMap();
  var productSearchTextCache = new WeakMap();
  var activeState = null;
  var apiReady = Boolean(config.enabled && config.storefrontToken && config.storeDomain);
  var MULTICOLOR_SWATCH_IMAGE = 'https://cdn.shopify.com/s/files/1/0561/7562/4355/files/multicolor.png?v=1779692182';
  var MULTICOLOR_SWATCH_STYLE = 'background: #fff url("' + MULTICOLOR_SWATCH_IMAGE + '") center/cover no-repeat;';
  var INDEX_VIEW = 'kk-index';
  var VENDOR_LOGO_VIEW = 'kk-vendor-logos';
  var INDEX_CACHE_TTL = 10 * 60 * 1000;
  var INDEX_CACHE_DB_NAME = 'kiekkokingi-headless-collection';
  var INDEX_CACHE_DB_VERSION = 1;
  var INDEX_CACHE_STORE_NAME = 'collection-indexes';
  var INDEX_CACHE_SCHEMA_VERSION = 5;
  var INDEX_CACHE_HEDGE_DELAY = 200;
  var INDEX_CACHE_READ_TIMEOUT = 2000;
  var INDEX_PAGE_SIZE = 250;
  var VENDOR_LOGO_START_DELAY = 250;
  var EARLY_FILTER_RENDER_COUNT = 50;
  var PARTIAL_FILTER_UPDATE_INTERVAL = 250;
  var INDEX_PARALLEL_BATCH = 4;
  var INDEX_WORK_SLICE_MS = 8;
  var CONTEXTUAL_SYNC_PRODUCT_LIMIT = 500;
  var USED_DISCS_COLLECTION_HANDLE = 'used-discs';
  var WEIGHT_FACET_KEY = 'my_fields.paino';
  var WEIGHT_FILTER_PARAM = 'filter.p.m.my_fields.paino';
  var PRODUCT_IMAGE_WIDTHS = [180, 260, 384, 520, 768];
  var PRODUCT_IMAGE_SIZES = '(max-width: 679px) 50vw, (max-width: 1023px) 33vw, (max-width: 1599px) 25vw, 320px';
  var collectionImagePriorityClaimed = Boolean(document.querySelector('[data-kk-collection-lcp-image]'));
  var indexCacheDatabasePromise = null;
  var indexCachePruneStarted = false;
  var legacyIndexCacheCleaned = false;
  var vendorLogoRequestPromises = Object.create(null);
  var activeFilterPointers = new Map();
  var mainThreadYieldQueue = [];
  var mainThreadYieldChannel = null;
  var JUDGE_ME_BADGE_SELECTOR = '.productgrid--item .jdgm-preview-badge';
  var JUDGE_ME_PENDING_BADGE_SELECTOR = '.productgrid--item .jdgm-preview-badge:not(.jdgm--done-setup)';
  var JUDGE_ME_REFRESH_DELAY = 250;
  var JUDGE_ME_REFRESH_MAX_ATTEMPTS = 20;
  var JUDGE_ME_BASE_SCRIPT_PATH = 'widget/base.js';
  var JUDGE_ME_COMMON_SCRIPT_PATH = 'widget/common.js';
  var JUDGE_ME_BADGE_SCRIPT_PATH = 'widget/main.js';
  var JUDGE_ME_LEGACY_SCRIPT_PATH = 'shopify_v2.js';
  var JUDGE_ME_APPEND_WATCH_TIMEOUT = 20000;
  var HEADLESS_VENDOR_GROUP_LABELS = {
    streamline: 'Streamline Discs',
    streamlinediscs: 'Streamline Discs',
    latitude64: 'Latitude 64\u00b0',
    mvp: 'MVP Disc Sports',
    mvpdiscsports: 'MVP Disc Sports'
  };
  var judgeMeRefreshTimer = null;
  var judgeMeRefreshAttempts = 0;
  var judgeMeDoneSetupListening = false;
  var judgeMeAppendObserver = null;
  var judgeMeAppendTimeout = null;
  var COLOR_SWATCH_STYLES = {
    beige: 'background: #d8c5a0;',
    black: 'background: #000;',
    bla: 'background: #006bdc;',
    blue: 'background: #006bdc;',
    bronze: 'background: #c47a32;',
    brons: 'background: #c47a32;',
    brun: 'background: #a8663d;',
    brown: 'background: #a8663d;',
    clear: 'background: #fff;',
    flerfargad: MULTICOLOR_SWATCH_STYLE,
    gold: 'background: #d9a300;',
    genomskinlig: 'background: #fff;',
    gra: 'background: #8f8f8f;',
    gray: 'background: #8f8f8f;',
    green: 'background: #08b84f;',
    grey: 'background: #8f8f8f;',
    gron: 'background: #08b84f;',
    guld: 'background: #d9a300;',
    gul: 'background: #ffe300;',
    harmaa: 'background: #8f8f8f;',
    hopea: 'background: #b8b8b8;',
    keltainen: 'background: #ffe300;',
    kirkas: 'background: #fff;',
    kulta: 'background: #d9a300;',
    lapinakyva: 'background: #fff;',
    lila: 'background: #a24bd7;',
    monivarinen: MULTICOLOR_SWATCH_STYLE,
    multicolor: MULTICOLOR_SWATCH_STYLE,
    multi: MULTICOLOR_SWATCH_STYLE,
    musta: 'background: #000;',
    orange: 'background: #ff8900;',
    oranssi: 'background: #ff8900;',
    pink: 'background: #ffc2d7;',
    pinkki: 'background: #ffc2d7;',
    pronssi: 'background: #c47a32;',
    punainen: 'background: #ff2525;',
    red: 'background: #ff2525;',
    rod: 'background: #ff2525;',
    rosa: 'background: #ffc2d7;',
    'rose gold': 'background: #b76e79;',
    rosegold: 'background: #b76e79;',
    roseguld: 'background: #b76e79;',
    ruskea: 'background: #a8663d;',
    ruusukulta: 'background: #b76e79;',
    silver: 'background: #b8b8b8;',
    sininen: 'background: #006bdc;',
    svart: 'background: #000;',
    transparent: 'background: #fff;',
    valkoinen: 'background: #fff;',
    vihrea: 'background: #08b84f;',
    violett: 'background: #a24bd7;',
    violetti: 'background: #a24bd7;',
    violet: 'background: #a24bd7;',
    vit: 'background: #fff;',
    white: 'background: #fff;',
    yellow: 'background: #ffe300;'
  };
  var COLOR_GROUPS = [
    {
      key: 'beige',
      labels: { fi: 'Beige', sv: 'Beige', en: 'Beige' },
      aliases: ['beige']
    },
    {
      key: 'gray',
      labels: { fi: 'Harmaa', sv: 'Gr\u00e5', en: 'Gray' },
      aliases: ['harmaa', 'harmaat', 'siniharmaa', 'gray', 'grey', 'gra', 'graa', 'blue gray', 'bluegray']
    },
    {
      key: 'silver',
      labels: { fi: 'Hopea', sv: 'Silver', en: 'Silver' },
      aliases: ['hopea', 'silver']
    },
    {
      key: 'yellow',
      labels: { fi: 'Keltainen', sv: 'Gul', en: 'Yellow' },
      aliases: ['keltainen', 'yellow', 'gul']
    },
    {
      key: 'gold',
      labels: { fi: 'Kulta', sv: 'Guld', en: 'Gold' },
      aliases: ['kulta', 'gold', 'guld', 'oro']
    },
    {
      key: 'transparent',
      labels: { fi: 'L\u00e4pin\u00e4kyv\u00e4', sv: 'Genomskinlig', en: 'Transparent' },
      aliases: ['lapinakyva', 'transparent', 'transparentti', 'clear', 'kirkas', 'genomskinlig']
    },
    {
      key: 'multicolor',
      labels: { fi: 'Moniv\u00e4rinen', sv: 'Flerf\u00e4rgad', en: 'Multicolor' },
      aliases: [
        'elain',
        'animal',
        'animal print',
        'geometrinen',
        'geometric',
        'monivarinen',
        'multicolor',
        'multi color',
        'multi',
        'flerfargad',
        'naamiointi',
        'camouflage',
        'camo',
        'raidallinen',
        'striped',
        'stripe',
        'raidat',
        'kuvio',
        'pattern',
        'print',
        'random',
        'sateenkaari',
        'rainbow',
        'tie dye',
        'tiedye',
        'marmori',
        'marble',
        'swirl',
        'splatter'
      ]
    },
    {
      key: 'black',
      labels: { fi: 'Musta', sv: 'Svart', en: 'Black' },
      aliases: ['musta', 'black', 'svart']
    },
    {
      key: 'orange',
      labels: { fi: 'Oranssi', sv: 'Orange', en: 'Orange' },
      aliases: ['oranssi', 'orange']
    },
    {
      key: 'pink',
      labels: { fi: 'Pinkki', sv: 'Rosa', en: 'Pink' },
      aliases: ['pinkki', 'pink', 'vaaleanpunainen', 'rosa', 'light pink', 'lightpink']
    },
    {
      key: 'bronze',
      labels: { fi: 'Pronssi', sv: 'Brons', en: 'Bronze' },
      aliases: ['pronssi', 'bronze', 'brons']
    },
    {
      key: 'red',
      labels: { fi: 'Punainen', sv: 'R\u00f6d', en: 'Red' },
      aliases: ['punainen', 'red', 'rod', 'punaviini', 'burgundy', 'wine red', 'winered']
    },
    {
      key: 'brown',
      labels: { fi: 'Ruskea', sv: 'Brun', en: 'Brown' },
      aliases: ['ruskea', 'brown', 'brun']
    },
    {
      key: 'rose_gold',
      labels: { fi: 'Ruusukulta', sv: 'Ros\u00e9guld', en: 'Rose gold' },
      aliases: ['ruusukulta', 'rose gold', 'rosegold', 'roseguld']
    },
    {
      key: 'blue',
      labels: { fi: 'Sininen', sv: 'Bl\u00e5', en: 'Blue' },
      aliases: ['sininen', 'siniharmaa', 'tummansininen', 'turkoosi', 'turquoise', 'turkos', 'blue', 'dark blue', 'darkblue', 'navy', 'bla', 'blue gray', 'bluegray']
    },
    {
      key: 'white',
      labels: { fi: 'Valkoinen', sv: 'Vit', en: 'White' },
      aliases: ['valkoinen', 'white', 'vit', 'glow']
    },
    {
      key: 'green',
      labels: { fi: 'Vihre\u00e4', sv: 'Gr\u00f6n', en: 'Green' },
      aliases: ['vihrea', 'green', 'gron']
    },
    {
      key: 'violet',
      labels: { fi: 'Violetti', sv: 'Lila', en: 'Violet' },
      aliases: ['violetti', 'violet', 'violett', 'purple', 'lila']
    }
  ];

  var gridLaunchCountdownTimer = null;
  var GRID_LAUNCH_OPEN_THRESHOLD_MS = 90 * 86400 * 1000;

  function padGridLaunchNumber(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function formatGridLaunchCountdown(diffMs, dayOne, dayMany) {
    var total = Math.max(0, Math.floor(diffMs / 1000));
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var time = padGridLaunchNumber(hours) + ':' + padGridLaunchNumber(minutes) + ':' + padGridLaunchNumber(seconds);
    var dayLabel = days === 1 ? (dayOne || 'päivä') : (dayMany || 'päivää');

    return days > 0 ? days + ' ' + dayLabel + ' ' + time : time;
  }

  function updateGridLaunchCountdowns() {
    var countdowns = document.querySelectorAll('[data-grid-launch-countdown]');
    var activeCount = 0;

    countdowns.forEach(function (countdown) {
      var target = parseInt(countdown.getAttribute('data-target'), 10);
      var timeEl = countdown.querySelector('[data-grid-launch-time]');
      var dayOne = countdown.getAttribute('data-day-one') || 'päivä';
      var dayMany = countdown.getAttribute('data-day-many') || 'päivää';
      var openText = countdown.getAttribute('data-open-text') || 'Ajankohta avoin';
      var diffMs;

      if (!isFinite(target)) {
        countdown.hidden = true;
        return;
      }

      diffMs = (target * 1000) - Date.now();

      if (diffMs <= 0) {
        countdown.hidden = true;
        countdown.setAttribute('aria-hidden', 'true');
        return;
      }

      activeCount += 1;
      countdown.hidden = false;
      countdown.setAttribute('aria-hidden', 'false');

      if (timeEl) {
        timeEl.textContent = diffMs > GRID_LAUNCH_OPEN_THRESHOLD_MS ?
          openText :
          formatGridLaunchCountdown(diffMs, dayOne, dayMany);
      }
    });

    return activeCount;
  }

  function scheduleGridLaunchCountdowns() {
    window.clearTimeout(gridLaunchCountdownTimer);
    gridLaunchCountdownTimer = null;

    if (document.hidden || updateGridLaunchCountdowns() === 0) {
      return;
    }

    gridLaunchCountdownTimer = window.setTimeout(scheduleGridLaunchCountdowns, 1000);
  }

  function initGridLaunchCountdowns() {
    if (!gridLaunchCountdownTimer) {
      scheduleGridLaunchCountdowns();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridLaunchCountdowns);
  } else {
    initGridLaunchCountdowns();
  }

  document.addEventListener('shopify:section:load', initGridLaunchCountdowns);
  document.addEventListener('visibilitychange', initGridLaunchCountdowns);

  if (!apiReady) {
    return;
  }

  function t(key, fallback) {
    return typeof language[key] === 'string' && language[key] !== '' ? language[key] : fallback;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value == null ? '' : value).replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function normalizeWeightValue(value) {
    var raw = String(value == null ? '' : value).trim();
    var parsed;

    if (!/^\d+$/.test(raw)) {
      return '';
    }

    parsed = Number(raw);
    return Number.isSafeInteger(parsed) ? String(parsed) : '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function decodeBase64Url(value) {
    var normalized = String(value || '').replace(/-/g, '+').replace(/_/g, '/');

    while (normalized.length % 4) {
      normalized += '=';
    }

    try {
      return decodeURIComponent(Array.prototype.map.call(atob(normalized), function (character) {
        return '%' + ('00' + character.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (error) {
      return '';
    }
  }

  function encodeBase64Url(value) {
    try {
      return btoa(unescape(encodeURIComponent(value)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    } catch (error) {
      return '';
    }
  }

  function stableFilterKey(input) {
    return JSON.stringify(normalizeHeadlessFilterInput(input || {}));
  }

  function parseFilterInput(value) {
    try {
      return normalizeHeadlessFilterInput(JSON.parse(value || '{}'));
    } catch (error) {
      return {};
    }
  }

  function getMoneyFormatter(currencyCode) {
    try {
      return new Intl.NumberFormat(config.moneyLocale || document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currencyCode || config.currencyCode || 'EUR'
      });
    } catch (error) {
      return null;
    }
  }

  function formatMoney(amount, currencyCode) {
    var formatter = getMoneyFormatter(currencyCode);
    var numeric = toNumber(amount, 0);

    return formatter ? formatter.format(numeric) : numeric.toFixed(2) + ' ' + (currencyCode || config.currencyCode || 'EUR');
  }

  function getCurrencySymbol(currencyCode) {
    var formatted = formatMoney(0, currencyCode || config.currencyCode);
    var symbol = formatted.replace(/[\d\s., ]/g, '').trim();

    return symbol || currencyCode || config.currencyCode || '';
  }

  function getLocalizedRootUrl() {
    var root = config.rootUrl || (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';

    if (root.charAt(root.length - 1) !== '/') {
      root += '/';
    }

    return root;
  }

  function buildProductUrl(handle) {
    return getLocalizedRootUrl() + 'products/' + handle;
  }

  function yieldToMainThread() {
    if (window.scheduler && typeof window.scheduler.yield === 'function') {
      return window.scheduler.yield();
    }

    if (typeof window.MessageChannel === 'function') {
      if (!mainThreadYieldChannel) {
        mainThreadYieldChannel = new window.MessageChannel();
        mainThreadYieldChannel.port1.onmessage = function () {
          var resolve = mainThreadYieldQueue.shift();
          if (resolve) resolve();
        };
      }

      return new Promise(function (resolve) {
        mainThreadYieldQueue.push(resolve);
        mainThreadYieldChannel.port2.postMessage(0);
      });
    }

    return new Promise(function (resolve) {
      window.setTimeout(resolve, 0);
    });
  }

  function processItemsInSlices(items, iteratee, shouldContinue) {
    var index = 0;

    return new Promise(function (resolve, reject) {
      function processSlice() {
        var startedAt = window.performance && typeof window.performance.now === 'function' ?
          window.performance.now() : Date.now();

        try {
          if (shouldContinue && !shouldContinue()) {
            resolve(false);
            return;
          }

          while (index < items.length) {
            iteratee(items[index], index);
            index += 1;

            if (
              index < items.length &&
              (window.performance && typeof window.performance.now === 'function' ? window.performance.now() : Date.now()) - startedAt >= INDEX_WORK_SLICE_MS
            ) {
              yieldToMainThread().then(processSlice, reject);
              return;
            }
          }

          resolve(true);
        } catch (error) {
          reject(error);
        }
      }

      processSlice();
    });
  }

  function getNativeIndexSort(sortBy) {
    return sortBy === 'manual' || sortBy === 'best-selling' ? sortBy : '';
  }

  function buildLiquidIndexUrl(handle, page, sortBy) {
    var params = new URLSearchParams();

    params.set('view', INDEX_VIEW);
    params.set('page', page);

    if (sortBy) {
      params.set('sort_by', sortBy);
    }

    return getLocalizedRootUrl() + 'collections/' + encodeURIComponent(handle) + '?' + params.toString();
  }

  function buildVendorLogoUrl(handle) {
    var params = new URLSearchParams();

    params.set('view', VENDOR_LOGO_VIEW);
    return getLocalizedRootUrl() + 'collections/' + encodeURIComponent(handle) + '?' + params.toString();
  }

  function normalizeVendorLogoKey(value) {
    var normalized = String(value || '').trim().toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized.replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '');
  }

  function canonicalizeHeadlessVendorName(value) {
    var vendorName = String(value || '').trim();
    var vendorKey = normalizeVendorLogoKey(vendorName);
    var canonicalName = Object.prototype.hasOwnProperty.call(HEADLESS_VENDOR_GROUP_LABELS, vendorKey)
      ? HEADLESS_VENDOR_GROUP_LABELS[vendorKey]
      : '';

    return canonicalName || vendorName;
  }

  function isWeightMetafieldInput(input) {
    return Boolean(
      input &&
      input.productMetafield &&
      input.productMetafield.namespace === 'my_fields' &&
      input.productMetafield.key === 'paino'
    );
  }

  function isWeightFacetEnabled(state) {
    return Boolean(state && state.handle === USED_DISCS_COLLECTION_HANDLE);
  }

  function normalizeHeadlessFilterInput(input) {
    var normalizedInput;
    var normalizeVendor;
    var normalizeWeight;

    if (!input || typeof input !== 'object') {
      return {};
    }

    normalizeVendor = Object.prototype.hasOwnProperty.call(input, 'productVendor');
    normalizeWeight = isWeightMetafieldInput(input);

    if (!normalizeVendor && !normalizeWeight) return input;

    normalizedInput = {};
    Object.keys(input).forEach(function (key) {
      normalizedInput[key] = input[key];
    });

    if (normalizeVendor) {
      normalizedInput.productVendor = canonicalizeHeadlessVendorName(input.productVendor);
    }

    if (normalizeWeight) {
      normalizedInput.productMetafield = {};
      Object.keys(input.productMetafield).forEach(function (key) {
        normalizedInput.productMetafield[key] = input.productMetafield[key];
      });
      normalizedInput.productMetafield.value = normalizeWeightValue(input.productMetafield.value);
    }

    return normalizedInput;
  }

  function getHeadlessVendorLogoKeys(value) {
    var canonicalName = canonicalizeHeadlessVendorName(value);
    var aliases = [canonicalName];
    var keys = [];

    if (canonicalName === 'Streamline Discs') {
      aliases.push('Streamline');
    } else if (canonicalName === 'Latitude 64\u00b0') {
      aliases.push('Latitude 64');
    } else if (canonicalName === 'MVP Disc Sports') {
      aliases.push('MVP');
    }

    aliases.forEach(function (alias) {
      var key = normalizeVendorLogoKey(alias);

      if (key && keys.indexOf(key) === -1) {
        keys.push(key);
      }
    });

    return keys;
  }

  function normalizeVendorLogoUrl(value) {
    var url = String(value || '').trim();

    if (!url || (!/^(?:https?:)?\/\//i.test(url) && url.charAt(0) !== '/')) {
      return '';
    }

    return url;
  }

  function buildVendorLogoMap(payload) {
    var map = new Map();
    var vendors = payload && Array.isArray(payload.vendors) ? payload.vendors : [];

    vendors.forEach(function (vendor) {
      var logoUrl = normalizeVendorLogoUrl(vendor && vendor.logo);

      if (!logoUrl) {
        return;
      }

      [vendor.name, vendor.handle].forEach(function (value) {
        var key = normalizeVendorLogoKey(value);

        if (key && !map.has(key)) {
          map.set(key, { url: logoUrl });
        }
      });
    });

    return map;
  }

  function fetchVendorLogos(state) {
    var cacheKey = getLocalizedRootUrl() + '|' + (config.language || '') + '|' + (state.handle || '__all__');

    if (vendorLogoRequestPromises[cacheKey]) {
      return vendorLogoRequestPromises[cacheKey];
    }

    vendorLogoRequestPromises[cacheKey] = fetch(buildVendorLogoUrl(state.handle), {
      credentials: 'same-origin',
      priority: 'low'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Vendor logo view failed: ' + response.status);
      }

      return response.json();
    }).then(buildVendorLogoMap).catch(function () {
      // Logos are decorative. A missing view or unpublished metaobject must not
      // delay or disable the actual collection filters.
      return new Map();
    });

    return vendorLogoRequestPromises[cacheKey];
  }

  function getBootstrappedIndexPage(state, page, sortBy) {
    var registry = window.KKHeadlessIndexBootstrap;
    var requestUrl = buildLiquidIndexUrl(state.handle, page, sortBy);
    var entry = registry && registry.requests && registry.requests[requestUrl];

    if (!entry || entry.consumed) {
      return null;
    }

    entry.consumed = true;
    return entry;
  }

  function abortBootstrappedIndex(state) {
    var registry = window.KKHeadlessIndexBootstrap;

    if (!registry || !registry.requests) {
      return;
    }

    Object.keys(registry.requests).forEach(function (requestUrl) {
      var entry = registry.requests[requestUrl];

      if (entry && entry.handle === state.handle && entry.controller) {
        entry.controller.abort();
      }
    });
  }

  function createIndexAbortError() {
    var error = new Error('Index processing aborted');

    error.name = 'AbortError';
    return error;
  }

  function fetchLiquidPage(state, page, retriesLeft, signal, shouldContinue) {
    var sortBy = state.indexSortBy || getNativeIndexSort(state.sortBy);
    var bootstrapEntry;

    if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
      return Promise.reject(createIndexAbortError());
    }

    if (retriesLeft === undefined) {
      retriesLeft = 3;
    }

    bootstrapEntry = getBootstrappedIndexPage(state, page, sortBy);
    if (bootstrapEntry) {
      if (signal && bootstrapEntry.controller) {
        if (signal.aborted) {
          bootstrapEntry.controller.abort();
        } else if (typeof signal.addEventListener === 'function') {
          signal.addEventListener('abort', function () {
            bootstrapEntry.controller.abort();
          }, { once: true });
        }
      }

      return bootstrapEntry.promise.then(function (result) {
        if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
          throw createIndexAbortError();
        }

        if (result && result.ok && result.payload) {
          return result.payload;
        }

        return fetchLiquidPage(state, page, retriesLeft, signal, shouldContinue);
      });
    }

    return fetch(buildLiquidIndexUrl(state.handle, page, sortBy), {
      credentials: 'same-origin',
      signal: signal
    }).then(function (response) {
      if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
        throw createIndexAbortError();
      }
      if (!response.ok) {
        throw new Error('Index page ' + page + ' failed: ' + response.status);
      }
      return response.text();
    }).then(function (text) {
      return JSON.parse(text);
    }).catch(function (error) {
      if (error && error.name === 'AbortError') {
        throw error;
      }

      if (retriesLeft > 0) {
        var delay = 400 * (4 - retriesLeft);
        return new Promise(function (resolve) {
          window.setTimeout(resolve, delay);
        }).then(function () {
          return fetchLiquidPage(state, page, retriesLeft - 1, signal, shouldContinue);
        });
      }
      throw error;
    });
  }

  function runWithConcurrency(items, concurrency, worker) {
    var nextIndex = 0;
    var workers = [];
    var workerCount = Math.min(Math.max(1, concurrency), items.length);
    var workerIndex;

    function runNext() {
      var item;

      if (nextIndex >= items.length) {
        return Promise.resolve();
      }

      item = items[nextIndex];
      nextIndex += 1;

      return Promise.resolve().then(function () {
        return worker(item);
      }).then(runNext);
    }

    for (workerIndex = 0; workerIndex < workerCount; workerIndex++) {
      workers.push(runNext());
    }

    return Promise.all(workers);
  }

  function metafieldFromLiquid(value) {
    if (value == null) {
      return null;
    }

    if (Array.isArray(value)) {
      return { value: JSON.stringify(value) };
    }

    return { value: String(value) };
  }

  function weightMetafieldFromLiquid(value) {
    var normalized = normalizeWeightValue(value);

    return normalized === '' ? null : { value: normalized };
  }

  function normalizeLiquidProduct(raw, currencyCode) {
    var currency = currencyCode || 'EUR';
    var judgeMeProductId = raw.ji == null ? raw.i : raw.ji;
    var priceMin = toNumber(raw.pmin, 0) / 100;
    var priceMax = toNumber(raw.pmax, raw.pmin) / 100;
    var compareMin = toNumber(raw.cmin, 0) / 100;
    var compareAtRange = compareMin > priceMin ? {
      minVariantPrice: { amount: String(compareMin), currencyCode: currency }
    } : null;

    return {
      sourceOrder: toNumber(raw.so, 0),
      id: judgeMeProductId ? 'gid://shopify/Product/' + judgeMeProductId : '',
      legacyId: judgeMeProductId == null ? '' : String(judgeMeProductId),
      handle: raw.h,
      title: raw.t,
      vendor: raw.v,
      tags: raw.tg || [],
      availableForSale: Boolean(raw.av),
      createdAtTimestamp: toNumber(raw.cts, 0),
      priceRange: {
        minVariantPrice: { amount: String(priceMin), currencyCode: currency },
        maxVariantPrice: { amount: String(priceMax), currencyCode: currency }
      },
      compareAtPriceRange: compareAtRange,
      featuredImage: raw.img && raw.img.u ? {
        url: raw.img.u,
        altText: raw.img.a || '',
        width: Math.max(0, Math.floor(toNumber(raw.img.w, 0))),
        height: Math.max(0, Math.floor(toNumber(raw.img.h, 0)))
      } : null,
      muovi: metafieldFromLiquid(raw.mu),
      kunto: metafieldFromLiquid(raw.ku),
      paino: weightMetafieldFromLiquid(raw.we),
      colorPattern: metafieldFromLiquid(raw.co),
      profile: metafieldFromLiquid(raw.pr),
      nopeus: metafieldFromLiquid(raw.sp),
      liito: metafieldFromLiquid(raw.gl),
      vakaus: metafieldFromLiquid(raw.tu),
      feidi: metafieldFromLiquid(raw.fa),
      judgeMeBadgeHtml: raw.jb == null ? '' : String(raw.jb),
      badgeText: raw.bt == null ? '' : String(raw.bt),
      badgeColor: raw.bc == null ? '' : String(raw.bc),
      releaseTimestamp: toNumber(raw.rts, 0)
    };
  }

  function resetIncrementalIndexData(state) {
    state.indexFacetDefinitions = getFacetDefinitions(state);
    state.indexProductHandles = new Map();
    state.indexFacetCounts = new Map();
    state.indexPriceMin = null;
    state.indexPriceMax = 0;
    state.indexAccumulatorReady = false;

    state.indexFacetDefinitions.forEach(function (definition) {
      state.indexFacetCounts.set(definition.key, new Map());
    });
  }

  function trackIncrementalIndexProduct(state, product) {
    var handle = String(product && product.handle || '');
    var minPrice;
    var maxPrice;

    if (!handle || state.indexProductHandles.has(handle)) {
      return false;
    }

    state.indexProductHandles.set(handle, product);
    minPrice = getProductMinPrice(product);
    maxPrice = getProductMaxPrice(product);

    if (minPrice > 0) {
      state.indexPriceMin = state.indexPriceMin === null ? minPrice : Math.min(state.indexPriceMin, minPrice);
    }
    state.indexPriceMax = Math.max(state.indexPriceMax, maxPrice);

    state.indexFacetDefinitions.forEach(function (definition) {
      var counts = state.indexFacetCounts.get(definition.key);

      definition.values(product).forEach(function (value) {
        if (value === '') return;
        counts.set(value, (counts.get(value) || 0) + 1);
      });
    });

    return true;
  }

  function rebuildIncrementalIndexData(state, products, requestGeneration) {
    var accumulator = { handle: state.handle };

    resetIncrementalIndexData(accumulator);

    return processItemsInSlices(products, function (product) {
      trackIncrementalIndexProduct(accumulator, product);
    }, function () {
      return !state.destroyed && requestGeneration === state.indexGeneration && (!state.root || state.root.isConnected);
    }).then(function (completed) {
      if (completed) {
        // Publish the rebuilt snapshot as one unit. The caller commits the
        // matching product array and flips indexAccumulatorReady immediately
        // afterwards, so a cache hedge can never expose cached counters beside
        // an older network-partial product list.
        state.indexFacetDefinitions = accumulator.indexFacetDefinitions;
        state.indexProductHandles = accumulator.indexProductHandles;
        state.indexFacetCounts = accumulator.indexFacetCounts;
        state.indexPriceMin = accumulator.indexPriceMin;
        state.indexPriceMax = accumulator.indexPriceMax;
      }
      return completed;
    });
  }

  function appendLiquidProducts(state, products, payload, requestGeneration, signal, shouldContinue) {
    var rawProducts;
    var vendorReferences = new Map();

    if (requestGeneration !== state.indexGeneration || (shouldContinue && !shouldContinue())) {
      return Promise.resolve(false);
    }

    if (payload && payload.currency) {
      state.currencyCode = payload.currency;
    }

    ((payload && payload.vendorRefs) || []).forEach(function (reference) {
      var key = normalizeVendorLogoKey(reference && reference.vendor);
      var handle = String(reference && reference.handle || '').trim();

      if (key && handle && !vendorReferences.has(key)) {
        vendorReferences.set(key, handle);
      }
    });

    rawProducts = (payload && payload.products) || [];

    return processItemsInSlices(rawProducts, function (raw) {
      var product = normalizeLiquidProduct(raw, state.currencyCode);
      var vendorKey = normalizeVendorLogoKey(product.vendor);

      if (vendorReferences.has(vendorKey)) {
        product.vendorReferenceHandle = vendorReferences.get(vendorKey);
        state.vendorLogoAliases.set(vendorKey, normalizeVendorLogoKey(product.vendorReferenceHandle));
        vendorReferences.delete(vendorKey);
      }

      if (trackIncrementalIndexProduct(state, product)) {
        products.push(product);
      }
    }, function () {
      return requestGeneration === state.indexGeneration &&
        !(signal && signal.aborted) &&
        !state.destroyed &&
        (!shouldContinue || shouldContinue());
    }).then(function (completed) {
      if (!completed || requestGeneration !== state.indexGeneration || (signal && signal.aborted)) {
        return false;
      }

      state.indexProducts = products;
      renderIndexLoading(state, products.length);
      maybeRenderPartialIndex(state, products);
      return true;
    });
  }

  function canonicalizeIndexProducts(products, expectedItems) {
    var seen = Object.create(null);
    var canonical = [];

    products.forEach(function (product) {
      var key;

      if (!product) return;
      if (expectedItems && toNumber(product.sourceOrder, 0) >= expectedItems) return;

      key = String(product.handle || '');
      if (!key || seen[key]) return;

      seen[key] = true;
      canonical.push(product);
    });

    canonical.sort(function (a, b) {
      return toNumber(a.sourceOrder, 0) - toNumber(b.sourceOrder, 0);
    });

    return canonical;
  }

  function maybeRenderPartialIndex(state, products) {
    var initialRender;

    if (state.indexLoaded || products.length < EARLY_FILTER_RENDER_COUNT) {
      return;
    }

    state.indexProducts = products;
    state.partialFilterGeneration += 1;
    state.root.classList.add('kk-headless-collection--partial-index');

    if (state.partialRenderTimer) {
      return;
    }

    initialRender = !state.partialRendered;
    state.partialRenderTimer = window.setTimeout(function () {
      var requestGeneration = state.indexGeneration;
      var workGeneration = state.filterWorkGeneration;
      var partialGeneration = state.partialFilterGeneration;

      state.partialRenderTimer = null;
      if (state.indexLoaded || requestGeneration !== state.indexGeneration || (state.root && !state.root.isConnected)) return;
      prepareContextualFilterSnapshot(state, workGeneration, function () {
        return partialGeneration === state.partialFilterGeneration && !state.indexLoaded;
      }).then(function (contextualSnapshot) {
        if (
          state.destroyed ||
          state.indexLoaded ||
          requestGeneration !== state.indexGeneration ||
          workGeneration !== state.filterWorkGeneration ||
          partialGeneration !== state.partialFilterGeneration ||
          (state.root && !state.root.isConnected)
        ) return;

        buildFilters(state, { partial: true, contextualSnapshot: contextualSnapshot });

        if (state.partialRendered) {
          updateFilterCountsInPlace(state);
        } else {
          state.partialRendered = true;
          renderFilters(state);
        }
      }).catch(function (error) {
        console.warn('[KiekkoKingi] Partial filter refresh failed:', error);
      });
    }, initialRender ? 0 : PARTIAL_FILTER_UPDATE_INTERVAL);
  }

  function getLegacyFilterValueCounts(state) {
    var legacyValueCounts = new Map();

    (state.filters || []).forEach(function (filter) {
      if (filter.type === 'PRICE_RANGE') return;
      (filter.values || []).forEach(function (value) {
        legacyValueCounts.set(stableFilterKey(parseFilterInput(value.input)), value.count || 0);
      });
    });

    return legacyValueCounts;
  }

  function updateRenderedFilterInput(state, input, facetValueCounts, legacyValueCounts) {
    var parsed = parseFilterInput(input.value);
    var facetKey = inputFacetKey(parsed);
    var facetCounts = facetValueCounts && facetValueCounts.get(facetKey);
    var valueKey = stableFilterKey(parsed);
    var count;
    var checked;
    var disabled;
    var item;
    var countEl;
    var label;

    if (facetValueCounts) {
      if (!facetCounts) return;
      count = facetCounts.has(valueKey) ? toNumber(facetCounts.get(valueKey), 0) : 0;
    } else {
      if (!legacyValueCounts || !legacyValueCounts.has(valueKey)) return;
      count = toNumber(legacyValueCounts.get(valueKey), 0);
    }
    checked = state.selected && typeof state.selected.has === 'function' ?
      state.selected.has(valueKey) : input.checked;
    disabled = !checked && count === 0;
    item = input.closest('.kk-facet__item');
    countEl = item && item.querySelector('.kk-facet__count');

    if (input.checked !== checked) input.checked = checked;
    if (input.disabled !== disabled) input.disabled = disabled;

    if (countEl && state.showProductCounts) {
      if (countEl.textContent !== '(' + count + ')') countEl.textContent = '(' + count + ')';
    }

    if (item) {
      label = item.querySelector('.kk-facet__label');
      if (item.getAttribute('data-kk-headless-option-count') !== String(count)) {
        item.setAttribute('data-kk-headless-option-count', String(count));
      }
      item.classList.toggle('filter-item--active', checked);
      item.classList.toggle('filter-item--inactive', !checked);
      item.classList.toggle('filter-item--disabled', disabled);
      item.classList.toggle('kk-headless-filter-option--zero', disabled);
      item.toggleAttribute('data-kk-headless-zero-option', disabled);
      if (label) {
        label.classList.toggle('filter-item__label--disabled', disabled);
      }
    }
  }

  function getFilterCountContainers(state) {
    var containers = [];
    var sidebar = getSidebar(state);
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');

    if (sidebar) containers.push(sidebar);
    if (modalContent && containers.indexOf(modalContent) === -1) containers.push(modalContent);
    return containers;
  }

  function updateFilterCountsInPlace(state) {
    var containers = getFilterCountContainers(state);
    var facetValueCounts = state.facetValueCounts;
    var legacyValueCounts = null;
    var reorderDeferred = false;

    if (state.filterListPointerCount > 0) {
      state.pendingFilterCountUpdate = true;
      return;
    }

    state.pendingFilterCountUpdate = false;

    if (!facetValueCounts || typeof facetValueCounts.get !== 'function') {
      legacyValueCounts = getLegacyFilterValueCounts(state);
    }

    containers.forEach(function (container) {
      if (!container) return;

      container.querySelectorAll('[data-kk-headless-filter-input]').forEach(function (input) {
        updateRenderedFilterInput(state, input, facetValueCounts, legacyValueCounts);
      });

      reorderDeferred = reorderCountSortedFilterOptions(state, container) || reorderDeferred;
      syncFilterOptionLimits(state, container);
      updateContextualDiscRangesInPlace(state, container);
      container.querySelectorAll('[data-kk-headless-filter-search]').forEach(function (searchInput) {
        handleFilterSearch({ target: searchInput });
      });
    });

    state.pendingFilterReorder = reorderDeferred;
  }

  function isMobileFilterViewport() {
    return !window.matchMedia || window.matchMedia('(max-width: 859px)').matches;
  }

  function isCountSortedListFilter(filter) {
    var facetKey;

    if (!filter || filter.type === 'PRICE_RANGE' || isDiscRangeFilter(filter)) return false;
    facetKey = filter.facetKey || filter.key || filter.id || '';
    return !resolveCustomOrder(CUSTOM_VALUE_ORDER[facetKey]);
  }

  function getCurrentFilterOptionCount(state, option) {
    var input = option && option.querySelector('[data-kk-headless-filter-input]');
    var parsed;
    var facetCounts;
    var valueKey;

    if (!input) return -1;
    parsed = parseFilterInput(input.value);
    facetCounts = state.facetValueCounts && state.facetValueCounts.get(inputFacetKey(parsed));
    valueKey = stableFilterKey(parsed);

    if (!facetCounts || !facetCounts.has(valueKey)) return -1;
    return toNumber(facetCounts.get(valueKey), 0);
  }

  function getCountSortedFiltersByKey(state) {
    var filtersByKey = new Map();

    (state.filters || []).forEach(function (filter) {
      var facetKey;

      if (!isCountSortedListFilter(filter)) return;
      facetKey = filter.facetKey || filter.id || filter.key || normalizeFilterLabel(filter);
      if (facetKey) filtersByKey.set(String(facetKey), filter);
    });

    return filtersByKey;
  }

  function reorderCountSortedFilterFacet(state, facet, filtersByKey) {
    var facetKey = getRenderedFacetKey(facet);
    var list = facet.querySelector('[data-kk-headless-filter-list]');
    var options;
    var sorted;
    var toggle;
    var toggleItem;
    var scrollTop;
    var changed;
    var orderedNodes;

    if (!list || !filtersByKey.has(facetKey)) return false;

    if (list.contains(document.activeElement)) {
      return true;
    }

    options = Array.prototype.slice.call(list.querySelectorAll('[data-kk-headless-filter-option]'));
    sorted = options.map(function (option, index) {
      return {
        count: getCurrentFilterOptionCount(state, option),
        index: index,
        option: option
      };
    }).sort(function (a, b) {
      return b.count - a.count || a.index - b.index;
    });
    changed = sorted.some(function (entry, index) {
      return entry.option !== options[index];
    });
    toggle = list.querySelector('[data-kk-headless-toggle-more]');
    toggleItem = toggle && toggle.closest('.filter-item');
    scrollTop = list.scrollTop;

    if (changed) {
      orderedNodes = sorted.map(function (entry) {
        return entry.option;
      });
      if (toggleItem) orderedNodes.push(toggleItem);

      if (typeof list.replaceChildren === 'function') {
        // One compound child-list mutation avoids making Langify walk the
        // same facet once for every moved option. Existing keyed nodes are
        // retained, and focus/pointer guards above keep active controls put.
        list.replaceChildren.apply(list, orderedNodes);
      } else {
        sorted.forEach(function (entry) {
          list.insertBefore(entry.option, toggleItem || null);
        });
      }
      list.scrollTop = scrollTop;
    }

    sorted.forEach(function (entry, index) {
      if (entry.option.getAttribute('data-kk-headless-source-index') !== String(index)) {
        entry.option.setAttribute('data-kk-headless-source-index', String(index));
      }
    });

    return false;
  }

  function reorderCountSortedFilterOptions(state, container) {
    var filtersByKey = getCountSortedFiltersByKey(state);
    var deferred = false;

    if (!container) return false;

    container.querySelectorAll('[data-kk-headless-facet-key]').forEach(function (facet) {
      deferred = reorderCountSortedFilterFacet(state, facet, filtersByKey) || deferred;
    });

    return deferred;
  }

  function scheduleDeferredFilterCountUpdate(state) {
    if (!state || state.destroyed || (!state.pendingFilterCountUpdate && !state.pendingFilterReorder && !state.pendingFilterRender)) return;

    window.clearTimeout(state.filterCountFlushTimer);
    state.filterCountFlushTimer = window.setTimeout(function () {
      state.filterCountFlushTimer = null;
      if (state.destroyed || state.filterListPointerCount > 0 || (state.root && !state.root.isConnected)) return;
      if (state.indexLoaded && (state.pendingFilterRender || state.pendingFilterReorder)) {
        renderCompletedFiltersInSlices(state).catch(function (error) {
          console.warn('[KiekkoKingi] Deferred filter render failed:', error);
        });
      } else if (state.pendingFilterRender) {
        renderFilters(state);
      } else {
        updateFilterCountsInPlace(state);
      }
    }, 0);
  }

  function handleFilterPointerDown(event) {
    var list = event.target && event.target.closest && event.target.closest('[data-kk-headless-filter-list]');
    var state;

    if (!list || activeFilterPointers.has(event.pointerId)) return;
    state = getState(list);
    if (!state || state.destroyed) return;

    activeFilterPointers.set(event.pointerId, state);
    state.filterListPointerCount += 1;
  }

  function handleFilterPointerEnd(event) {
    var state = activeFilterPointers.get(event.pointerId);

    if (!state) return;
    activeFilterPointers.delete(event.pointerId);
    state.filterListPointerCount = Math.max(0, state.filterListPointerCount - 1);
    if (state.filterListPointerCount === 0) scheduleDeferredFilterCountUpdate(state);
  }

  function releaseAllFilterPointers() {
    var statesToFlush = new Set();

    activeFilterPointers.forEach(function (state) {
      state.filterListPointerCount = 0;
      statesToFlush.add(state);
    });
    activeFilterPointers.clear();
    statesToFlush.forEach(scheduleDeferredFilterCountUpdate);
  }

  function handleFilterFocusOut(event) {
    var state = getState(event.target);

    if (!state || !state.pendingFilterReorder) return;
    scheduleDeferredFilterCountUpdate(state);
  }

  function syncFilterOptionListLimit(state, list) {
    var options = Array.prototype.slice.call(list.querySelectorAll('[data-kk-headless-filter-option]'));
    var toggle = list.querySelector('[data-kk-headless-toggle-more]');
    var toggleItem = toggle && toggle.closest('.filter-item');
    var searchInput = list.closest('[data-kk-headless-facet]') && list.closest('[data-kk-headless-facet]').querySelector('[data-kk-headless-filter-search]');
    var hasSearchTerm = Boolean(searchInput && searchInput.value.trim());
    var expanded = Boolean(toggle && toggle.getAttribute('data-kk-headless-toggle-more') === 'true');
    var mobile = isMobileFilterViewport();
    var eligibleCount = 0;

    options.forEach(function (item, index) {
      var input = item.querySelector('[data-kk-headless-filter-input]');
      var checked = Boolean(input && input.checked);
      var zeroResult = item.hasAttribute('data-kk-headless-zero-option');
      var eligible = checked || !zeroResult;
      var sourceIndex = parseInt(item.getAttribute('data-kk-headless-source-index'), 10);
      var hiddenByDefault;

      if (isNaN(sourceIndex)) sourceIndex = index;

      if (mobile) {
        hiddenByDefault = !checked && eligible && eligibleCount >= state.tagLimit;
        if (eligible) eligibleCount += 1;
      } else {
        hiddenByDefault = !checked && sourceIndex >= state.tagLimit;
        eligibleCount += 1;
      }

      item.toggleAttribute('data-hidden-default', hiddenByDefault);

      if (!hasSearchTerm) {
        item.classList.toggle('filter-item--hidden', hiddenByDefault && !expanded);
      }
    });

    if (!toggle || !toggleItem) return;

    toggleItem.toggleAttribute('data-kk-headless-no-overflow', eligibleCount <= state.tagLimit);
    toggleItem.hidden = hasSearchTerm || eligibleCount <= state.tagLimit;

    if (eligibleCount <= state.tagLimit && expanded) {
      toggle.setAttribute('data-kk-headless-toggle-more', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = toggle.getAttribute('data-kk-headless-see-more-text') || t('see_more', 'See more');
      list.classList.remove('kk-facet__list--expanded');
    }
  }

  function syncFilterOptionLimits(state, container) {
    if (!container) return;

    container.querySelectorAll('[data-kk-headless-filter-list]').forEach(function (list) {
      syncFilterOptionListLimit(state, list);
    });
  }

  function syncAllFilterOptionLimits(state) {
    var sidebar = getSidebar(state);
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');

    syncFilterOptionLimits(state, sidebar);
    if (modalContent && modalContent !== sidebar) {
      syncFilterOptionLimits(state, modalContent);
    }
  }

  function defaultLabel(key, fallback) {
    var code = String(config.language || '').toLowerCase();
    var labels = {
      fi: {
        vendor: 'Merkki',
        profile: 'Profile'
      },
      sv: {
        vendor: 'Märke',
        profile: 'Profil'
      },
      en: {
        vendor: 'Brand',
        profile: 'Profile'
      }
    };

    return (labels[code] && labels[code][key]) || fallback;
  }

  function getFacetDefinitions(state) {
    var definitions = [
      {
        key: 'vendor',
        id: 'filter.p.vendor',
        label: t('filter_brand', defaultLabel('vendor', 'Brand')),
        values: function (product) {
          var vendorName = canonicalizeHeadlessVendorName(product.vendor);

          return vendorName ? [vendorName] : [];
        },
        input: function (value) {
          return { productVendor: value };
        }
      },
      {
        key: 'my_fields.muovi',
        id: 'filter.p.m.my_fields.muovi',
        label: t('disc_plastic', 'Plastic'),
        values: function (product) {
          return getMetafieldValues(product.muovi);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'my_fields', key: 'muovi', value: value } };
        }
      },
      {
        key: 'custom.profile',
        id: 'filter.p.m.custom.profile',
        label: t('filter_profile', defaultLabel('profile', 'Profile')),
        values: function (product) {
          return getMetafieldValues(product.profile);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'custom', key: 'profile', value: value } };
        }
      },
      {
        key: 'my_fields.kunto',
        id: 'filter.p.m.my_fields.kunto',
        label: t('disc_condition', 'Condition'),
        values: function (product) {
          return getMetafieldValues(product.kunto);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'my_fields', key: 'kunto', value: value } };
        }
      },
      createDiscRangeDefinition('my_fields.paino', 'filter.p.m.my_fields.paino', t('disc_weight', 'Weight'), 'paino', getWeightValues),
      {
        key: 'shopify.color-pattern',
        id: 'filter.p.m.shopify.color-pattern',
        label: t('disc_color', 'Color'),
        swatch: true,
        values: function (product) {
          return getColorPatternValues(product);
        },
        input: function (value) {
          return { productMetafield: { namespace: 'shopify', key: 'color-pattern', value: value } };
        }
      },
      createDiscRangeDefinition('custom.nopeus', 'filter.p.m.custom.nopeus', t('flight_numbers_speed', 'Speed'), 'nopeus'),
      createDiscRangeDefinition('custom.liito', 'filter.p.m.custom.liito', t('flight_numbers_glide', 'Glide'), 'liito'),
      createDiscRangeDefinition('custom.vakaus', 'filter.p.m.custom.vakaus', t('flight_numbers_turn', 'Turn'), 'vakaus'),
      createDiscRangeDefinition('custom.feidi', 'filter.p.m.custom.feidi', t('flight_numbers_fade', 'Fade'), 'feidi')
    ];

    if (state && !isWeightFacetEnabled(state)) {
      definitions = definitions.filter(function (definition) {
        return definition.key !== WEIGHT_FACET_KEY;
      });
    }

    return definitions;
  }

  function createDiscRangeDefinition(key, id, label, productKey, valueNormalizer) {
    var pieces = key.split('.');

    return {
      key: key,
      id: id,
      label: label,
      range: true,
      values: function (product) {
        return valueNormalizer ? valueNormalizer(product[productKey]) : getMetafieldValues(product[productKey]);
      },
      input: function (value) {
        return { productMetafield: { namespace: pieces[0], key: pieces[1], value: String(value) } };
      }
    };
  }

  function getMetafieldValues(metafield) {
    var value = metafield && metafield.value;
    var parsed;
    var values;

    if (value == null || value === '') {
      return [];
    }

    if (metafieldValuesCache.has(metafield)) {
      return metafieldValuesCache.get(metafield);
    }

    try {
      parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        values = parsed.map(String).filter(Boolean);
      } else if (parsed != null && typeof parsed !== 'object') {
        values = [String(parsed)];
      }
    } catch (error) {
      // Liquid returns single-line metafields as plain strings.
    }

    if (!values) {
      values = [String(value)];
    }

    metafieldValuesCache.set(metafield, values);
    return values;
  }

  function getWeightValues(metafield) {
    return uniqueValues(getMetafieldValues(metafield).map(normalizeWeightValue).filter(Boolean));
  }

  function uniqueValues(values) {
    var seen = new Set();

    return values.filter(function (value) {
      var normalized = String(value || '').trim();

      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);
      return true;
    });
  }

  function getLanguageCode() {
    return String(config.language || document.documentElement.lang || 'fi').toLowerCase().split('-')[0];
  }

  function getReleaseCountdownTextFallbacks() {
    var code = getLanguageCode();
    var fallback;

    if (code === 'sv') {
      fallback = {
        label: 'Tillgänglig:',
        dayOne: 'dag',
        dayMany: 'dagar',
        openText: 'Datum öppet'
      };
    } else if (code === 'en') {
      fallback = {
        label: 'Available:',
        dayOne: 'day',
        dayMany: 'days',
        openText: 'Date TBA'
      };
    } else {
      fallback = {
        label: 'Saatavilla:',
        dayOne: 'päivä',
        dayMany: 'päivää',
        openText: 'Ajankohta avoin'
      };
    }

    return {
      label: t('grid_launch_countdown_label', fallback.label),
      dayOne: t('grid_launch_countdown_day_one', fallback.dayOne),
      dayMany: t('grid_launch_countdown_day_many', fallback.dayMany),
      openText: t('grid_launch_countdown_open_text', fallback.openText)
    };
  }

  function getColorGroupLabel(group) {
    var code = getLanguageCode();

    return (group.labels && (group.labels[code] || group.labels.en || group.labels.fi)) || group.key;
  }

  function colorAliasMatches(key, compactKey, alias) {
    var normalizedAlias = normalizeColorKey(alias);
    var compactAlias = normalizedAlias.replace(/\s+/g, '');

    return key === normalizedAlias || compactKey === compactAlias;
  }

  function getColorGroupsForValue(value) {
    var label = String(value || '').trim();
    var key = normalizeColorKey(label);
    var compactKey = key.replace(/\s+/g, '');
    var groups = [];

    if (!label) {
      return groups;
    }

    COLOR_GROUPS.forEach(function (group) {
      var matches = (group.aliases || []).some(function (alias) {
        return colorAliasMatches(key, compactKey, alias);
      });

      if (matches) {
        groups.push(getColorGroupLabel(group));
      }
    });

    return groups;
  }

  function getColorPatternValues(product) {
    var values = getMetafieldValues(product.colorPattern);
    var splitValues = [];
    var result;

    if (colorPatternValuesCache.has(product)) {
      return colorPatternValuesCache.get(product);
    }

    values.forEach(function (value) {
      String(value || '').split(/\s*,\s*/).forEach(function (part) {
        if (part) {
          getColorGroupsForValue(part).forEach(function (group) {
            splitValues.push(group);
          });
        }
      });
    });

    result = uniqueValues(splitValues);
    colorPatternValuesCache.set(product, result);
    return result;
  }

  function normalizeColorKey(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getColorSwatchStyle(label) {
    var key = normalizeColorKey(label);
    var compactKey = key.replace(/\s+/g, '');

    if (COLOR_SWATCH_STYLES[key]) {
      return COLOR_SWATCH_STYLES[key];
    }

    if (COLOR_SWATCH_STYLES[compactKey]) {
      return COLOR_SWATCH_STYLES[compactKey];
    }

    if (key.indexOf('multi') > -1 || key.indexOf('monivar') > -1 || key.indexOf('flerfarg') > -1) {
      return COLOR_SWATCH_STYLES.multicolor;
    }

    return 'background: rgba(255, 255, 255, 0.08);';
  }

  function isRangeFacetKey(facetKey) {
    return facetKey === 'my_fields.paino' ||
      facetKey === 'custom.nopeus' ||
      facetKey === 'custom.liito' ||
      facetKey === 'custom.vakaus' ||
      facetKey === 'custom.feidi';
  }

  function getRangeFacetUnit(facetKey) {
    return facetKey === 'my_fields.paino' ? 'g' : '';
  }

  function formatRangeFacetValue(facetKey, value) {
    var unit = getRangeFacetUnit(facetKey);

    return String(value) + (unit ? ' ' + unit : '');
  }

  function normalizeRangeSelection(facetKey, min, max, filterLabel) {
    var normalizedMin = toNumber(min, NaN);
    var normalizedMax = toNumber(max, NaN);

    if (!isRangeFacetKey(facetKey) || !Number.isFinite(normalizedMin) || !Number.isFinite(normalizedMax)) {
      return null;
    }

    if (normalizedMin > normalizedMax) {
      var swap = normalizedMin;
      normalizedMin = normalizedMax;
      normalizedMax = swap;
    }

    return {
      facetKey: facetKey,
      min: normalizedMin,
      max: normalizedMax,
      filterLabel: String(filterLabel || '')
    };
  }

  function getRangeSelectionFilterLabel(facetKey) {
    var definition = getFacetDefinitions().find(function (item) {
      return item.key === facetKey;
    });

    return definition ? definition.label : '';
  }

  function inputFacetKey(input) {
    if (!input) {
      return '';
    }

    if (Object.prototype.hasOwnProperty.call(input, 'productVendor')) {
      return 'vendor';
    }

    if (input.productMetafield) {
      return input.productMetafield.namespace + '.' + input.productMetafield.key;
    }

    if (Object.prototype.hasOwnProperty.call(input, 'tag')) {
      return 'tag';
    }

    return stableFilterKey(input);
  }

  function productMetafieldKey(namespace, key) {
    if (namespace === 'custom' && key === 'nopeus') return 'nopeus';
    if (namespace === 'custom' && key === 'liito') return 'liito';
    if (namespace === 'custom' && key === 'vakaus') return 'vakaus';
    if (namespace === 'custom' && key === 'feidi') return 'feidi';
    if (namespace === 'custom' && key === 'profile') return 'profile';
    if (namespace === 'my_fields' && key === 'muovi') return 'muovi';
    if (namespace === 'my_fields' && key === 'kunto') return 'kunto';
    if (namespace === 'my_fields' && key === 'paino') return 'paino';
    if (namespace === 'shopify' && key === 'color-pattern') return 'colorPattern';
    return '';
  }

  function selectedInputMatches(product, input) {
    var metafield;

    if (!input) {
      return true;
    }

    if (Object.prototype.hasOwnProperty.call(input, 'productVendor')) {
      return canonicalizeHeadlessVendorName(product.vendor) === canonicalizeHeadlessVendorName(input.productVendor);
    }

    if (Object.prototype.hasOwnProperty.call(input, 'tag')) {
      return (product.tags || []).indexOf(input.tag) > -1;
    }

    if (input.productMetafield) {
      if (input.productMetafield.namespace === 'shopify' && input.productMetafield.key === 'color-pattern') {
        return getColorPatternValues(product).indexOf(String(input.productMetafield.value)) > -1;
      }

      metafield = productMetafieldKey(input.productMetafield.namespace, input.productMetafield.key);
      return getMetafieldValues(product[metafield]).indexOf(String(input.productMetafield.value)) > -1;
    }

    return true;
  }

  function getProductRangeValues(product, facetKey) {
    var pieces = String(facetKey || '').split('.');
    var metafieldKey = pieces.length === 2 ? productMetafieldKey(pieces[0], pieces[1]) : '';
    var values;

    if (!metafieldKey || !product || !product[metafieldKey]) {
      return [];
    }

    values = facetKey === 'my_fields.paino' ?
      getWeightValues(product[metafieldKey]) : getMetafieldValues(product[metafieldKey]);

    return values.map(function (value) {
      return toNumber(value, NaN);
    }).filter(function (value) {
      return Number.isFinite(value);
    });
  }

  function productMatchesRangeSelection(product, selection) {
    if (!selection) return true;

    return getProductRangeValues(product, selection.facetKey).some(function (value) {
      return value >= selection.min && value <= selection.max;
    });
  }

  function selectedFacetItemMatches(product, item) {
    return item && item.rangeSelection ?
      productMatchesRangeSelection(product, item.rangeSelection) : selectedInputMatches(product, item && item.input);
  }

  function getProductMinPrice(product) {
    return toNumber(product.priceRange && product.priceRange.minVariantPrice && product.priceRange.minVariantPrice.amount, 0);
  }

  function getProductMaxPrice(product) {
    return toNumber(product.priceRange && product.priceRange.maxVariantPrice && product.priceRange.maxVariantPrice.amount, getProductMinPrice(product));
  }

  function matchesPrice(product, state) {
    var min = state.priceMin === null ? 0 : state.priceMin;
    var max = state.priceMax === null ? Number.POSITIVE_INFINITY : state.priceMax;

    return getProductMaxPrice(product) >= min && getProductMinPrice(product) <= max;
  }

  function normalizeSearchText(value) {
    return String(value || '').toLowerCase();
  }

  function matchesQuery(product, query) {
    var parts = normalizeSearchText(query).split(/\s+/).filter(Boolean);
    var haystack;

    if (!parts.length) {
      return true;
    }

    if (productSearchTextCache.has(product)) {
      haystack = productSearchTextCache.get(product);
    } else {
      haystack = [
        product.title,
        product.handle,
        product.vendor,
        (product.tags || []).join(' '),
        getMetafieldValues(product.muovi).join(' '),
        getMetafieldValues(product.kunto).join(' '),
        getColorPatternValues(product).join(' '),
        getMetafieldValues(product.profile).join(' ')
      ].join(' ').toLowerCase();
      productSearchTextCache.set(product, haystack);
    }

    return parts.every(function (part) {
      return haystack.indexOf(part) > -1;
    });
  }

  function filterProducts(state, options) {
    var excludedFacet = options && options.excludeFacet;
    var excludePrice = options && options.excludePrice;
    var grouped = {};
    var facetKeys;

    state.selected.forEach(function (item) {
      var key = inputFacetKey(item.input);
      if (state.rangeSelections && state.rangeSelections.has(key)) return;
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
    });

    if (state.rangeSelections) {
      state.rangeSelections.forEach(function (selection, facetKey) {
        grouped[facetKey] = [{ rangeSelection: selection }];
      });
    }

    facetKeys = Object.keys(grouped);

    return state.indexProducts.filter(function (product) {
      if (!matchesQuery(product, state.query)) {
        return false;
      }

      if (!excludePrice && !matchesPrice(product, state)) {
        return false;
      }

      return facetKeys.every(function (facetKey) {
        if (excludedFacet && facetKey === excludedFacet) {
          return true;
        }

        return grouped[facetKey].some(function (item) {
          return selectedFacetItemMatches(product, item);
        });
      });
    });
  }

  function sortProducts(state, products) {
    var sorted = products.slice();
    var query = normalizeSearchText(state.query);

    function compareSourceOrder(a, b) {
      return toNumber(a.sourceOrder, 0) - toNumber(b.sourceOrder, 0);
    }

    function createdTimestamp(product) {
      var timestamp = toNumber(product.createdAtTimestamp, NaN);

      if (Number.isFinite(timestamp) && timestamp > 0) {
        return timestamp;
      }

      return 0;
    }

    if (state.sortBy === 'price-ascending') {
      sorted.sort(function (a, b) {
        return getProductMinPrice(a) - getProductMinPrice(b) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'price-descending') {
      sorted.sort(function (a, b) {
        return getProductMinPrice(b) - getProductMinPrice(a) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'title-ascending' || state.sortBy === 'alpha-ascending') {
      sorted.sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''), undefined, { sensitivity: 'base' }) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'title-descending' || state.sortBy === 'alpha-descending') {
      sorted.sort(function (a, b) {
        return String(b.title || '').localeCompare(String(a.title || ''), undefined, { sensitivity: 'base' }) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'created-ascending' || state.sortBy === 'date-ascending') {
      sorted.sort(function (a, b) {
        return createdTimestamp(a) - createdTimestamp(b) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'created-descending' || state.sortBy === 'date-descending') {
      sorted.sort(function (a, b) {
        return createdTimestamp(b) - createdTimestamp(a) || compareSourceOrder(a, b);
      });
    } else if (state.sortBy === 'manual' || state.sortBy === 'best-selling') {
      sorted.sort(compareSourceOrder);
    } else if ((state.sortBy === 'relevance' || !state.sortBy) && query) {
      sorted.sort(function (a, b) {
        var aTitle = normalizeSearchText(a.title);
        var bTitle = normalizeSearchText(b.title);
        var aScore = aTitle.indexOf(query) === 0 ? 0 : aTitle.indexOf(query) > -1 ? 1 : 2;
        var bScore = bTitle.indexOf(query) === 0 ? 0 : bTitle.indexOf(query) > -1 ? 1 : 2;

        return aScore - bScore || compareSourceOrder(a, b);
      });
    } else {
      sorted.sort(compareSourceOrder);
    }

    return sorted;
  }

  var CUSTOM_VALUE_ORDER = {
    'custom.profile': ['1 - Concave', '2 - Flat', '3 - Neutral', '4 - Domey', '5 - Very Domey'],
    'my_fields.kunto': ['Uusi', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C']
  };

  function resolveCustomOrder(order) {
    if (!order) return null;
    if (typeof order === 'function') return order();
    if (Array.isArray(order)) return order;
    var code = String(config.language || '').toLowerCase().split('-')[0];
    return order[code] || order.en || order.fi || null;
  }

  function sortByCustomOrder(values, order) {
    values.sort(function (a, b) {
      var aIdx = order.indexOf(a.label);
      var bIdx = order.indexOf(b.label);
      if (aIdx === -1 && bIdx === -1) {
        return String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      }
      if (aIdx === -1) return 1;
      if (bIdx === -1) return -1;
      return aIdx - bIdx;
    });
  }

  function buildFilterValuesFromCounts(definition, counts) {
    var values;
    var customOrder;

    values = Array.from(counts.keys()).map(function (value) {
      return {
        id: definition.id + ':' + value,
        label: value,
        count: counts.get(value) || 0,
        swatch: definition.swatch ? { style: getColorSwatchStyle(value) } : null,
        input: JSON.stringify(definition.input(value))
      };
    });

    customOrder = resolveCustomOrder(CUSTOM_VALUE_ORDER[definition.key]);

    if (definition.range) {
      values.sort(function (a, b) {
        return toNumber(a.label, 0) - toNumber(b.label, 0);
      });
    } else if (customOrder) {
      sortByCustomOrder(values, customOrder);
    } else {
      values.sort(function (a, b) {
        return (b.count || 0) - (a.count || 0) || String(a.label).localeCompare(String(b.label), undefined, { sensitivity: 'base' });
      });
    }

    return values;
  }

  function createContextualFilterAccumulator(state, definitions) {
    var grouped = new Map();
    var facetCounts = new Map();

    state.selected.forEach(function (item) {
      var key = inputFacetKey(item.input);

      if (state.rangeSelections && state.rangeSelections.has(key)) return;

      if (!grouped.has(key)) grouped.set(key, []);
      grouped.get(key).push(item);
    });

    if (state.rangeSelections) {
      state.rangeSelections.forEach(function (selection, facetKey) {
        grouped.set(facetKey, [{ rangeSelection: selection }]);
      });
    }

    definitions.forEach(function (definition) {
      facetCounts.set(definition.key, new Map());
    });

    return {
      facetCounts: facetCounts,
      failedDefinitions: new Set(),
      groupedEntries: Array.from(grouped.entries()),
      priceMin: null,
      priceMax: 0,
      resultProducts: []
    };
  }

  function addProductToContextualFilterAccumulator(accumulator, state, definitions, product) {
    var unmatchedCount = 0;
    var unmatchedFacetKey = '';
    var priceMatches;

    if (!matchesQuery(product, state.query)) return;

    accumulator.groupedEntries.forEach(function (entry) {
      var matches = entry[1].some(function (item) {
        return selectedFacetItemMatches(product, item);
      });

      if (!matches) {
        unmatchedCount += 1;
        unmatchedFacetKey = entry[0];
      }
    });

    if (unmatchedCount === 0) {
      var productMinPrice = getProductMinPrice(product);

      if (productMinPrice > 0) {
        accumulator.priceMin = accumulator.priceMin === null ?
          productMinPrice : Math.min(accumulator.priceMin, productMinPrice);
      }
      accumulator.priceMax = Math.max(accumulator.priceMax, getProductMaxPrice(product));
    }

    priceMatches = matchesPrice(product, state);
    if (priceMatches && unmatchedCount === 0) accumulator.resultProducts.push(product);
    if (!priceMatches) return;

    definitions.forEach(function (definition) {
      var counts;

      if (accumulator.failedDefinitions.has(definition.key)) return;
      if (unmatchedCount > 1 || (unmatchedCount === 1 && unmatchedFacetKey !== definition.key)) return;

      counts = accumulator.facetCounts.get(definition.key);

      try {
        definition.values(product).forEach(function (value) {
          if (value === '') return;
          counts.set(value, (counts.get(value) || 0) + 1);
        });
      } catch (error) {
        accumulator.failedDefinitions.add(definition.key);
        counts.clear();
        console.warn('[KiekkoKingi] Skipping headless filter "' + definition.key + '":', error);
      }
    });
  }

  function buildContextualFilterSnapshot(state, definitions) {
    var accumulator = createContextualFilterAccumulator(state, definitions);

    // One product traversal produces the result set, contextual price bounds
    // and every exclude-current-facet counter. The previous implementation
    // filtered and rescanned the complete 6k+ index separately for each facet.
    state.indexProducts.forEach(function (product) {
      addProductToContextualFilterAccumulator(accumulator, state, definitions, product);
    });

    return accumulator;
  }

  function buildContextualFilterSnapshotInSlices(state, definitions, workGeneration, shouldContinue) {
    var accumulator = createContextualFilterAccumulator(state, definitions);

    return processItemsInSlices(state.indexProducts, function (product) {
      addProductToContextualFilterAccumulator(accumulator, state, definitions, product);
    }, function () {
      return !state.destroyed &&
        workGeneration === state.filterWorkGeneration &&
        (!shouldContinue || shouldContinue()) &&
        (!state.root || state.root.isConnected);
    }).then(function (completed) {
      return completed ? accumulator : null;
    });
  }

  function getPriceFilter(state) {
    return {
      id: 'filter.v.price',
      label: t('filters_price', 'Price'),
      type: 'PRICE_RANGE',
      values: []
    };
  }

  function hasActiveFilterConstraints(state) {
    return Boolean(
      String(state.query || '').trim() ||
      state.selected.size ||
      (state.rangeSelections && state.rangeSelections.size) ||
      state.priceMin !== null ||
      state.priceMax !== null
    );
  }

  function prepareContextualFilterSnapshot(state, workGeneration, shouldContinue) {
    if (!hasActiveFilterConstraints(state)) return Promise.resolve(null);
    if (state.indexProducts.length <= CONTEXTUAL_SYNC_PRODUCT_LIMIT) {
      return Promise.resolve(buildContextualFilterSnapshot(state, getFacetDefinitions(state)));
    }
    return buildContextualFilterSnapshotInSlices(state, getFacetDefinitions(state), workGeneration, shouldContinue);
  }

  function buildFilters(state, options) {
    var partial = Boolean(options && options.partial);
    var definitions = getFacetDefinitions(state);
    var hasActiveConstraints = hasActiveFilterConstraints(state);
    var unfilteredBase = hasActiveConstraints ? null : state.indexProducts;
    var useIncrementalIndex = Boolean(
      unfilteredBase &&
      state.indexAccumulatorReady &&
      state.indexProductHandles &&
      state.indexProductHandles.size === state.indexProducts.length
    );
    var hasPreparedContextualSnapshot = Boolean(options && Object.prototype.hasOwnProperty.call(options, 'contextualSnapshot'));
    var contextualSnapshot = hasActiveConstraints ?
      (hasPreparedContextualSnapshot ? options.contextualSnapshot : buildContextualFilterSnapshot(state, definitions)) : null;
    var priceBase = useIncrementalIndex || contextualSnapshot ? null : (unfilteredBase || filterProducts(state, { excludePrice: true }));
    var maxPrice = useIncrementalIndex ? state.indexPriceMax : contextualSnapshot ? contextualSnapshot.priceMax : priceBase.reduce(function (max, product) {
      return Math.max(max, getProductMaxPrice(product));
    }, 0);
    var minPrice = useIncrementalIndex ? state.indexPriceMin : contextualSnapshot ? contextualSnapshot.priceMin : priceBase.reduce(function (min, product) {
      var price = getProductMinPrice(product);
      if (price <= 0) return min;
      return min === null ? price : Math.min(min, price);
    }, null);
    var filters = [];

    state.rangeContexts = {};
    state.facetValueCounts = new Map();
    state.contextualResultProducts = contextualSnapshot ? contextualSnapshot.resultProducts : null;
    state.contextualResultCount = contextualSnapshot ? contextualSnapshot.resultProducts.length : state.indexProducts.length;
    state.contextualResultGeneration = state.filterWorkGeneration;

    state.priceBoundMin = minPrice === null ? 0 : Math.floor(minPrice);
    state.priceBoundMax = Math.ceil(maxPrice);
    if (!partial) {
      if (state.priceMax !== null && state.priceMax >= state.priceBoundMax) {
        state.priceMax = null;
      }
      if (state.priceMin !== null && state.priceMin <= state.priceBoundMin) {
        state.priceMin = null;
      }
    }

    if (state.priceBoundMax > 0 && state.priceBoundMax > state.priceBoundMin) {
      filters.push(getPriceFilter(state));
    }

    definitions.forEach(function (definition) {
      var base;
      var values;
      var numericValues;
      var facetCounts;

      try {
        if (useIncrementalIndex) {
          values = buildFilterValuesFromCounts(definition, state.indexFacetCounts.get(definition.key) || new Map());
        } else if (contextualSnapshot) {
          if (contextualSnapshot.failedDefinitions.has(definition.key)) return;
          values = buildFilterValuesFromCounts(definition, contextualSnapshot.facetCounts.get(definition.key) || new Map());
        } else {
          base = unfilteredBase || filterProducts(state, { excludeFacet: definition.key });
          values = buildFilterValues(definition, base);
        }
      } catch (error) {
        console.warn('[KiekkoKingi] Skipping headless filter "' + definition.key + '":', error);
        return;
      }

      if (definition.range) {
        // Facet bounds follow the products allowed by every other active
        // filter, but an explicit value from this same range must stay visible
        // and removable. This mirrors Shopify's active-or-positive facet
        // semantics used by the native collection and search paths.
        state.selected.forEach(function (item) {
          var selectedValue;
          var alreadyIncluded;

          if (inputFacetKey(item.input) !== definition.key || !item.input || !item.input.productMetafield) {
            return;
          }

          selectedValue = toNumber(item.input.productMetafield.value, NaN);
          if (!Number.isFinite(selectedValue)) return;

          alreadyIncluded = values.some(function (value) {
            return toNumber(value.label, NaN) === selectedValue;
          });
          if (alreadyIncluded) return;

          values.push({
            id: definition.id + ':' + selectedValue,
            label: String(selectedValue),
            count: 0,
            input: JSON.stringify(item.input)
          });
        });

        var activeRangeSelection = state.rangeSelections.get(definition.key);
        if (activeRangeSelection) {
          [activeRangeSelection.min, activeRangeSelection.max].forEach(function (selectedValue) {
            var alreadyIncluded = values.some(function (value) {
              return toNumber(value.label, NaN) === selectedValue;
            });

            if (alreadyIncluded) return;
            values.push({
              id: definition.id + ':range-bound:' + selectedValue,
              label: String(selectedValue),
              count: 0,
              input: JSON.stringify(definition.input(selectedValue))
            });
          });
        }
        values.sort(function (a, b) {
          return toNumber(a.label, 0) - toNumber(b.label, 0);
        });

        numericValues = values.map(function (value) {
          return toNumber(value.label, 0);
        });

        state.rangeContexts[definition.key] = {
          facetKey: definition.key,
          filter: {
            id: definition.id,
            label: definition.label,
            type: 'LIST',
            range: true,
            values: values
          },
          values: numericValues
        };

      }

      facetCounts = new Map();
      values.forEach(function (value) {
        facetCounts.set(stableFilterKey(parseFilterInput(value.input)), value.count || 0);
      });
      state.facetValueCounts.set(definition.key, facetCounts);

      if (definition.range && !numericValues.length) {
        return;
      }

      if (values.length > 1 || (definition.range && values.length)) {
        filters.push({
          facetKey: definition.key,
          id: definition.id,
          label: definition.label,
          type: 'LIST',
          range: Boolean(definition.range),
          swatch: Boolean(definition.swatch),
          values: values
        });
      }
    });

    state.filters = filters;
    return filters;
  }

  function sanitizeEncodedFilterParam(url, paramName, shouldRemove) {
    var values = url.searchParams.getAll(paramName);
    var sanitizedValues = [];
    var changed = false;

    values.forEach(function (encodedValue) {
      var decoded = decodeBase64Url(encodedValue);
      var parsed;
      var sanitized;

      try {
        parsed = JSON.parse(decoded);
      } catch (error) {
        sanitizedValues.push(encodedValue);
        return;
      }

      if (!Array.isArray(parsed)) {
        sanitizedValues.push(encodedValue);
        return;
      }

      sanitized = parsed.filter(function (item) {
        return !shouldRemove(item);
      });

      if (sanitized.length === parsed.length) {
        sanitizedValues.push(encodedValue);
        return;
      }

      changed = true;
      if (sanitized.length) {
        sanitizedValues.push(encodeBase64Url(JSON.stringify(sanitized)));
      }
    });

    if (!changed) return false;

    url.searchParams.delete(paramName);
    sanitizedValues.forEach(function (value) {
      if (value) url.searchParams.append(paramName, value);
    });
    return true;
  }

  function sanitizeDisabledWeightUrlState(state) {
    var url;
    var changed = false;
    var removedServerWeightParam = false;

    if (isWeightFacetEnabled(state)) return false;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return false;
    }

    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name === WEIGHT_FILTER_PARAM || name.indexOf(WEIGHT_FILTER_PARAM + '.') === 0) {
        url.searchParams.delete(name);
        changed = true;
        removedServerWeightParam = true;
      }
    });

    changed = sanitizeEncodedFilterParam(url, 'kkf', function (item) {
      return Boolean(item && isWeightMetafieldInput(item.input));
    }) || changed;
    changed = sanitizeEncodedFilterParam(url, 'kkr', function (item) {
      return Boolean(item && item.facetKey === WEIGHT_FACET_KEY);
    }) || changed;

    if (changed) {
      if (removedServerWeightParam) {
        // Shopify has already rendered the initial product grid from this
        // server-side parameter. Reload once with the clean URL so the grid
        // cannot stay filtered after the control itself has been hidden.
        window.location.replace(url.pathname + (url.search ? url.search : '') + (url.hash || ''));
      } else {
        window.history.replaceState(
          window.history.state,
          '',
          url.pathname + (url.search ? url.search : '') + (url.hash || '')
        );
      }
    }

    return changed;
  }

  function readUrlState(state) {
    var params;
    var encoded;
    var encodedRanges;
    var decoded;
    var decodedRanges;
    var selected;
    var ranges;
    var legacyRanges = new Map();

    function rememberRange(facetKey, min, max, filterLabel) {
      var selection = normalizeRangeSelection(facetKey, min, max, filterLabel);
      var existing;

      if (!selection) return;
      if (facetKey === WEIGHT_FACET_KEY && !isWeightFacetEnabled(state)) return;

      existing = legacyRanges.get(facetKey);
      if (existing) {
        selection.min = Math.min(existing.min, selection.min);
        selection.max = Math.max(existing.max, selection.max);
        selection.filterLabel = selection.filterLabel || existing.filterLabel;
      }
      legacyRanges.set(facetKey, selection);
    }

    sanitizeDisabledWeightUrlState(state);
    params = new URLSearchParams(window.location.search);
    encoded = params.get('kkf');
    encodedRanges = params.get('kkr');

    state.selected.clear();
    state.rangeSelections.clear();
    state.query = params.get('q') || '';
    state.sortBy = params.get('sort_by') || state.sortBy || '';
    state.priceMin = params.get('kk_price_min') ? toNumber(params.get('kk_price_min'), null) : null;
    state.priceMax = params.get('kk_price_max') ? toNumber(params.get('kk_price_max'), null) : null;

    if (encoded) {
      decoded = decodeBase64Url(encoded);

      try {
        selected = JSON.parse(decoded);
      } catch (error) {
        selected = [];
      }

      if (Array.isArray(selected)) {
        selected.forEach(function (item) {
          var itemFilterLabel;
          var itemLabel;
          var normalizedInput;
          var facetKey;
          var rangeValue;

          if (!item || !item.input) {
            return;
          }

          normalizedInput = normalizeHeadlessFilterInput(item.input);
          if (isWeightMetafieldInput(normalizedInput) && !normalizedInput.productMetafield.value) {
            return;
          }

          itemLabel = Object.prototype.hasOwnProperty.call(normalizedInput, 'productVendor')
            ? normalizedInput.productVendor
            : item.label || '';
          itemFilterLabel = item.filterLabel || '';

          if (isWeightMetafieldInput(normalizedInput)) {
            itemLabel = normalizedInput.productMetafield.value;
            itemFilterLabel = itemFilterLabel || t('disc_weight', 'Weight');
          }

          facetKey = inputFacetKey(normalizedInput);
          if (isRangeFacetKey(facetKey) && normalizedInput.productMetafield) {
            rangeValue = toNumber(normalizedInput.productMetafield.value, NaN);
            if (Number.isFinite(rangeValue)) {
              rememberRange(facetKey, rangeValue, rangeValue, itemFilterLabel || getRangeSelectionFilterLabel(facetKey));
            }
            return;
          }

          state.selected.set(stableFilterKey(normalizedInput), {
            input: normalizedInput,
            label: itemLabel,
            filterLabel: itemFilterLabel
          });
        });
      }
    }

    if (encodedRanges) {
      decodedRanges = decodeBase64Url(encodedRanges);

      try {
        ranges = JSON.parse(decodedRanges);
      } catch (error) {
        ranges = [];
      }

      if (Array.isArray(ranges)) {
        ranges.forEach(function (range) {
          if (!range) return;
          rememberRange(
            range.facetKey,
            range.min,
            range.max,
            range.filterLabel || getRangeSelectionFilterLabel(range.facetKey)
          );
        });
      }
    }

    legacyRanges.forEach(function (selection, facetKey) {
      state.rangeSelections.set(facetKey, selection);
    });
  }

  function writeUrlState(state) {
    var url = new URL(window.location.href);
    var filters = [];
    var ranges = [];

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    url.searchParams.delete('kkf');
    url.searchParams.delete('kkr');
    url.searchParams.delete('kk_price_min');
    url.searchParams.delete('kk_price_max');

    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name.indexOf('filter.') === 0) {
        url.searchParams.delete(name);
      }
    });

    if (state.query) {
      url.searchParams.set('q', state.query);
    } else {
      url.searchParams.delete('q');
    }

    if (state.sortBy) {
      url.searchParams.set('sort_by', state.sortBy);
    }

    state.selected.forEach(function (item) {
      filters.push({
        input: item.input,
        label: item.label,
        filterLabel: item.filterLabel
      });
    });

    if (filters.length) {
      url.searchParams.set('kkf', encodeBase64Url(JSON.stringify(filters)));
    }

    state.rangeSelections.forEach(function (selection, facetKey) {
      ranges.push({
        facetKey: facetKey,
        min: selection.min,
        max: selection.max,
        filterLabel: selection.filterLabel || getRangeSelectionFilterLabel(facetKey)
      });
    });

    if (ranges.length) {
      url.searchParams.set('kkr', encodeBase64Url(JSON.stringify(ranges)));
    }

    if (state.priceMin !== null) {
      url.searchParams.set('kk_price_min', state.priceMin);
    }

    if (state.priceMax !== null) {
      url.searchParams.set('kk_price_max', state.priceMax);
    }

    window.history.replaceState({}, '', url.pathname + (url.search ? url.search : ''));
  }

  function getResultsContainer(state) {
    return state.root.querySelector('[data-results-container]');
  }

  function getSidebar(state) {
    return state.root.querySelector('[data-product-grid-sidebar]');
  }

  function getCacheKey(state) {
    return [
      'kk-headless-index-v14',
      state.handle,
      config.country || '',
      config.language || '',
      getLocalizedRootUrl(),
      config.currencyCode || '',
      state.indexItems || state.collectionCount || '',
      state.indexSortBy || getNativeIndexSort(state.sortBy) || 'default'
    ].join(':');
  }

  function clearLegacyIndexCache() {
    var index;
    var key;

    if (legacyIndexCacheCleaned) {
      return;
    }

    legacyIndexCacheCleaned = true;

    try {
      for (index = window.localStorage.length - 1; index >= 0; index--) {
        key = window.localStorage.key(index);
        if (key && key.indexOf('kk-headless-index-v') === 0) {
          window.localStorage.removeItem(key);
        }
      }
    } catch (error) {
      // localStorage can be unavailable in privacy modes. It is only used here for legacy cleanup.
    }
  }

  function openIndexCacheDatabase() {
    var request;
    var attemptPromise;

    if (indexCacheDatabasePromise) {
      return indexCacheDatabasePromise;
    }

    clearLegacyIndexCache();

    if (!window.indexedDB) {
      return Promise.resolve(null);
    }

    try {
      request = window.indexedDB.open(INDEX_CACHE_DB_NAME, INDEX_CACHE_DB_VERSION);
    } catch (error) {
      return Promise.resolve(null);
    }

    attemptPromise = new Promise(function (resolve) {
      var settled = false;
      var openTimeout;

      function finish(database) {
        if (settled) {
          if (database) {
            database.close();
          }
          return;
        }

        settled = true;
        window.clearTimeout(openTimeout);
        resolve(database || null);
      }

      openTimeout = window.setTimeout(function () {
        finish(null);
      }, 1500);

      request.onupgradeneeded = function () {
        var database = request.result;
        var store;

        if (!database.objectStoreNames.contains(INDEX_CACHE_STORE_NAME)) {
          store = database.createObjectStore(INDEX_CACHE_STORE_NAME, { keyPath: 'key' });
          store.createIndex('createdAt', 'createdAt', { unique: false });
        }
      };

      request.onsuccess = function () {
        var database = request.result;

        database.onversionchange = function () {
          database.close();
          indexCacheDatabasePromise = null;
        };

        finish(database);
      };

      request.onerror = function () {
        finish(null);
      };

      request.onblocked = function () {
        finish(null);
      };
    });

    indexCacheDatabasePromise = attemptPromise;
    attemptPromise.then(function (database) {
      if (!database && indexCacheDatabasePromise === attemptPromise) {
        indexCacheDatabasePromise = null;
      }
    });

    return attemptPromise;
  }

  function deleteIndexCacheRecord(database, key) {
    try {
      database.transaction(INDEX_CACHE_STORE_NAME, 'readwrite')
        .objectStore(INDEX_CACHE_STORE_NAME)
        .delete(key);
    } catch (error) {
      // Cache cleanup must never interrupt the live collection index.
    }
  }

  function pruneIndexCache(database) {
    var transaction;
    var request;
    var cutoff = Date.now() - INDEX_CACHE_TTL;

    if (indexCachePruneStarted || !database) {
      return;
    }

    indexCachePruneStarted = true;

    try {
      transaction = database.transaction(INDEX_CACHE_STORE_NAME, 'readwrite');
      request = transaction.objectStore(INDEX_CACHE_STORE_NAME).openCursor();
      request.onsuccess = function (event) {
        var cursor = event.target.result;

        if (!cursor) {
          return;
        }

        if (!cursor.value || !cursor.value.createdAt || cursor.value.createdAt < cutoff) {
          cursor.delete();
        }

        cursor.continue();
      };
    } catch (error) {
      // Expired entries can be pruned during a later page load.
    }
  }

  function readIndexCache(state) {
    var cacheKey = getCacheKey(state);

    return openIndexCacheDatabase().then(function (database) {
      if (!database) {
        return null;
      }

      return new Promise(function (resolve) {
        var transaction;
        var request;
        var settled = false;

        function finish(value) {
          if (settled) {
            return;
          }

          settled = true;
          resolve(value || null);
        }

        try {
          transaction = database.transaction(INDEX_CACHE_STORE_NAME, 'readonly');
          request = transaction.objectStore(INDEX_CACHE_STORE_NAME).get(cacheKey);
        } catch (error) {
          finish(null);
          return;
        }

        request.onsuccess = function () {
          var cached = request.result;
          var sourceOrderIsContiguous = cached && Array.isArray(cached.products) && cached.products.every(function (product, index) {
            return Math.floor(toNumber(product && product.sourceOrder, -1)) === index;
          });
          var invalid = !cached ||
            cached.schemaVersion !== INDEX_CACHE_SCHEMA_VERSION ||
            !cached.createdAt ||
            !Array.isArray(cached.products) ||
            cached.products.length === 0 ||
            cached.productCount !== cached.products.length ||
            !sourceOrderIsContiguous;

          if (invalid || Date.now() - cached.createdAt > INDEX_CACHE_TTL) {
            if (cached) {
              deleteIndexCacheRecord(database, cacheKey);
            }
            finish(null);
            return;
          }

          finish(cached.products);
        };

        request.onerror = function () {
          finish(null);
        };

        transaction.onabort = function () {
          finish(null);
        };
      });
    }).catch(function () {
      return null;
    });
  }

  function readIndexCacheWithTimeout(state) {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        finish(null);
      }, INDEX_CACHE_READ_TIMEOUT);

      function finish(value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(value || null);
      }

      readIndexCache(state).then(finish).catch(function () {
        finish(null);
      });
    });
  }

  function writeIndexCache(state, products) {
    var cacheKey;

    if (!products || !products.length) {
      return Promise.resolve(false);
    }

    cacheKey = getCacheKey(state);

    return openIndexCacheDatabase().then(function (database) {
      if (!database) {
        return false;
      }

      return new Promise(function (resolve) {
        var transaction;
        var settled = false;

        function finish(success) {
          if (settled) {
            return;
          }

          settled = true;
          resolve(success);
        }

        try {
          transaction = database.transaction(INDEX_CACHE_STORE_NAME, 'readwrite');
          transaction.objectStore(INDEX_CACHE_STORE_NAME).put({
            key: cacheKey,
            schemaVersion: INDEX_CACHE_SCHEMA_VERSION,
            createdAt: Date.now(),
            productCount: products.length,
            products: products
          });
        } catch (error) {
          finish(false);
          return;
        }

        transaction.oncomplete = function () {
          finish(true);
          window.setTimeout(function () {
            pruneIndexCache(database);
          }, 0);
        };

        transaction.onerror = function () {
          finish(false);
        };

        transaction.onabort = function () {
          finish(false);
        };
      });
    }).catch(function () {
      // The live index still works if the browser denies persistent cache storage.
      return false;
    });
  }

  function cancelScheduledIndexCacheWrite(state) {
    if (state.indexCacheWriteHandle === null || state.indexCacheWriteHandle === undefined) {
      return;
    }

    if (state.indexCacheWriteUsesIdle && typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(state.indexCacheWriteHandle);
    } else {
      window.clearTimeout(state.indexCacheWriteHandle);
    }

    state.indexCacheWriteHandle = null;
    state.indexCacheWriteUsesIdle = false;
  }

  function scheduleIndexCacheWrite(state, products) {
    var requestGeneration = state.indexGeneration;

    cancelScheduledIndexCacheWrite(state);

    function writeWhenIdle() {
      state.indexCacheWriteHandle = null;
      state.indexCacheWriteUsesIdle = false;

      if (state.destroyed || requestGeneration !== state.indexGeneration) {
        return;
      }

      writeIndexCache(state, products);
    }

    if (typeof window.requestIdleCallback === 'function') {
      state.indexCacheWriteUsesIdle = true;
      state.indexCacheWriteHandle = window.requestIdleCallback(writeWhenIdle, { timeout: 1500 });
    } else {
      state.indexCacheWriteUsesIdle = false;
      state.indexCacheWriteHandle = window.setTimeout(writeWhenIdle, 150);
    }
  }

  function resetIndex(state, preserveFilterWork) {
    state.indexGeneration += 1;
    if (!preserveFilterWork) state.filterWorkGeneration += 1;
    state.filterRenderGeneration += 1;
    state.filterRenderPromise = null;
    state.modalPreviewGeneration += 1;
    if (state.indexAbortController) state.indexAbortController.abort();
    state.indexAbortController = null;
    cancelScheduledIndexCacheWrite(state);
    window.clearTimeout(state.partialRenderTimer);
    window.clearTimeout(state.modalRefreshTimer);
    state.indexProducts = [];
    resetIncrementalIndexData(state);
    state.indexLoaded = false;
    state.indexPromise = null;
    state.partialRendered = false;
    state.partialRenderTimer = null;
    state.partialFilterGeneration += 1;
    state.modalRefreshTimer = null;
    state.incrementalFiltersReady = false;
    state.contextualResultProducts = null;
    state.contextualResultCount = 0;
    state.contextualResultGeneration = -1;
    state.filters = [];
    state.vendorLogoAliases = new Map();
    state.root.classList.remove('kk-headless-collection--partial-index');
  }

  function getIndexLoadingText(state, count) {
    var total = state.indexItems || state.collectionCount || 0;
    var label = t('collection_search_loading', 'Loading');

    if (!count) return total ? label + ' 0 / ' + total : label;

    return total ? label + ' ' + count + ' / ' + total : label + ' ' + count;
  }

  function renderIndexLoading(state, count) {
    var sidebar = getSidebar(state);
    var text = getIndexLoadingText(state, count);
    var existingTextNodes;
    var existingWrapper;
    var loadingInnerHtml;

    existingTextNodes = document.querySelectorAll('[data-kk-headless-index-loading-text]');
    if (existingTextNodes.length) {
      existingTextNodes.forEach(function (node) {
        if (node.textContent !== text) node.textContent = text;
      });
      return;
    }

    if (state.partialRendered || state.indexLoaded) {
      return;
    }

    if (!sidebar) {
      return;
    }

    loadingInnerHtml = [
      '<div class="kk-headless-index-loading__status" role="status" aria-live="polite" aria-atomic="true">',
      '<span class="kk-headless-index-loading__spinner" aria-hidden="true"></span>',
      '<span class="kk-headless-index-loading__text" data-kk-headless-index-loading-text>', escapeHtml(text), '</span>',
      '</div>',
      '<div class="kk-headless-index-skeleton" aria-hidden="true">',
      '<div class="kk-headless-index-skeleton__group">',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--title"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '</div>',
      '<div class="kk-headless-index-skeleton__group">',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--title"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '</div>',
      '<div class="kk-headless-index-skeleton__group">',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--title"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '</div>',
      '<div class="kk-headless-index-skeleton__group">',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--title"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '<span class="kk-headless-index-skeleton__bar kk-headless-index-skeleton__bar--option"></span>',
      '</div>',
      '</div>'
    ].join('');
    existingWrapper = sidebar.querySelector('[data-kk-headless-filters-content]');

    if (existingWrapper) {
      existingWrapper.classList.add('kk-headless-index-loading');
      existingWrapper.setAttribute('data-kk-headless-index-loading', '');
      existingWrapper.setAttribute('aria-busy', 'true');
      existingWrapper.innerHTML = loadingInnerHtml;
    } else {
      sidebar.querySelectorAll('[data-productgrid-filters-content]').forEach(function (node) {
        node.remove();
      });
      sidebar.insertAdjacentHTML('afterbegin', [
        '<div class="productgrid--sidebar-section kk-headless-index-loading" data-productgrid-filters-content data-kk-headless-filters-content data-kk-headless-index-loading aria-busy="true">',
        loadingInnerHtml,
        '</div>'
      ].join(''));
    }

    state.root.classList.add('kk-headless-collection--has-filters');
    updateFilterTrigger(state);
  }

  function setProcessing(state, processing) {
    var container = getResultsContainer(state);

    if (container) {
      container.classList.toggle('processing--filter', processing);
    }

    state.root.classList.toggle('kk-headless-collection--processing', processing);
  }

  function normalizeFilterLabel(filter) {
    var label = filter && filter.label ? filter.label : '';
    var sampleInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';
    var labelDowncase = label.toLowerCase();

    if (filter && filter.type === 'PRICE_RANGE') {
      return t('filters_price', label || 'Price');
    }

    if (sampleInput.indexOf('nopeus') > -1 || labelDowncase === 'nopeus') {
      return t('flight_numbers_speed', 'Speed');
    }

    if (sampleInput.indexOf('liito') > -1 || labelDowncase === 'liito') {
      return t('flight_numbers_glide', 'Glide');
    }

    if (sampleInput.indexOf('vakaus') > -1 || labelDowncase === 'vakaus') {
      return t('flight_numbers_turn', 'Turn');
    }

    if (sampleInput.indexOf('feidi') > -1 || labelDowncase === 'feidi') {
      return t('flight_numbers_fade', 'Fade');
    }

    if (sampleInput.indexOf('muovi') > -1 || labelDowncase === 'muovi') {
      return t('disc_plastic', 'Plastic');
    }

    if (sampleInput.indexOf('paino') > -1 || labelDowncase === 'paino' || labelDowncase === 'weight' || labelDowncase === 'vikt') {
      return t('disc_weight', 'Weight');
    }

    if (sampleInput.indexOf('color-pattern') > -1 || labelDowncase === 'väri' || labelDowncase === 'vari' || labelDowncase === 'color' || labelDowncase === 'färg' || labelDowncase === 'farg') {
      return t('disc_color', 'Color');
    }

    if (sampleInput.indexOf('kunto') > -1 || labelDowncase === 'kunto') {
      return t('disc_condition', 'Condition');
    }

    return label;
  }

  function normalizeValueLabel(filter, value) {
    var label = value && value.label ? value.label : '';
    var filterInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';

    if (filterInput.indexOf('kunto') > -1 && label.toLowerCase() === 'uusi') {
      return t('disc_condition_new', 'New');
    }

    return label;
  }

  function isDiscRangeFilter(filter) {
    var sampleInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';
    var label = filter && filter.label ? filter.label.toLowerCase() : '';

    return Boolean(filter && filter.range) ||
      sampleInput.indexOf('nopeus') > -1 ||
      sampleInput.indexOf('liito') > -1 ||
      sampleInput.indexOf('vakaus') > -1 ||
      sampleInput.indexOf('feidi') > -1 ||
      label === 'nopeus' ||
      label === 'liito' ||
      label === 'vakaus' ||
      label === 'feidi';
  }

  function getSortedValues(filter) {
    return (filter.values || []).slice();
  }

  function findPriceFilter(filters) {
    return (filters || []).find(function (filter) {
      return filter.type === 'PRICE_RANGE';
    });
  }

  function getListFilters(filters) {
    return (filters || []).filter(function (filter) {
      return filter.type !== 'PRICE_RANGE';
    });
  }

  function isSelected(state, input) {
    return state.selected.has(stableFilterKey(input));
  }

  function getDiscRangeFacetKey(filter) {
    var sampleInput = filter && filter.values && filter.values[0] ? filter.values[0].input : '';
    var facetKey = filter && filter.facetKey ? filter.facetKey : '';

    if (!facetKey && sampleInput) {
      facetKey = inputFacetKey(parseFilterInput(sampleInput));
    }

    return isRangeFacetKey(facetKey) ? facetKey : '';
  }

  function buildFilterValues(definition, products) {
    var counts = new Map();

    products.forEach(function (product) {
      definition.values(product).forEach(function (value) {
        if (value === '') {
          return;
        }

        counts.set(value, (counts.get(value) || 0) + 1);
      });
    });

    return buildFilterValuesFromCounts(definition, counts);
  }

  function getActiveDiscRangeBounds(state, facetKey, min, max) {
    var selection = state && state.rangeSelections ? state.rangeSelections.get(facetKey) : null;
    var activeMin = selection ? selection.min : min;
    var activeMax = selection ? selection.max : max;

    activeMin = Math.max(min, Math.min(activeMin, max));
    activeMax = Math.max(activeMin, Math.min(activeMax, max));

    return {
      min: activeMin,
      max: activeMax,
      selected: Boolean(selection)
    };
  }

  function renderDiscRangeOptions(filter, label) {
    return (filter.values || []).map(function (value) {
      return '<input type="hidden" data-kk-headless-range-option value="' + escapeHtml(value.input) + '" data-kk-headless-range-value="' + escapeHtml(toNumber(value.label, 0)) + '" data-kk-headless-range-label="' + escapeHtml(normalizeValueLabel(filter, value)) + '" data-kk-headless-filter-label="' + escapeHtml(label) + '">';
    }).join('');
  }

  function setDiscRangeControl(control, min, max, value, preserveValue) {
    if (!control) return;

    control.min = String(min);
    control.max = String(max);
    if (!preserveValue) {
      control.value = String(Math.max(min, Math.min(value, max)));
    }
  }

  function updateContextualDiscRangesInPlace(state, container) {
    var contexts = state && state.rangeContexts ? state.rangeContexts : {};

    if (!container) return;

    container.querySelectorAll('[data-kk-headless-native-range]').forEach(function (range) {
      var facetKey = range.getAttribute('data-kk-headless-range-facet-key') || '';
      var context = contexts[facetKey];
      var filter = context && context.filter;
      var numericValues = context && context.values ? context.values : [];
      var details = range.closest('[data-kk-headless-range-facet]');
      var min;
      var max;
      var active;
      var bounds;
      var preserveValues;

      if (!filter || !numericValues.length) {
        if (details) details.hidden = true;
        return;
      }

      min = Math.floor(Math.min.apply(Math, numericValues));
      max = Math.ceil(Math.max.apply(Math, numericValues));
      active = getActiveDiscRangeBounds(state, facetKey, min, max);
      preserveValues = range.contains(document.activeElement);

      if (details) details.hidden = min === max;

      range.setAttribute('data-kk-headless-range-min', String(min));
      range.setAttribute('data-kk-headless-range-max', String(max));

      setDiscRangeControl(range.querySelector('[data-kk-headless-range-min-input]'), min, max, active.min, preserveValues);
      setDiscRangeControl(range.querySelector('[data-kk-headless-range-max-input]'), min, max, active.max, preserveValues);
      setDiscRangeControl(range.querySelector('[data-kk-headless-range-lower]'), min, max, active.min, preserveValues);
      setDiscRangeControl(range.querySelector('[data-kk-headless-range-upper]'), min, max, active.max, preserveValues);

      bounds = range.querySelector('.kk-range-filter__bounds');
      if (bounds && bounds.children.length >= 2) {
        bounds.children[0].textContent = formatRangeFacetValue(facetKey, min);
        bounds.children[1].textContent = formatRangeFacetValue(facetKey, max);
      }

      range.querySelectorAll('[data-kk-headless-range-option]').forEach(function (option) {
        option.remove();
      });
      range.insertAdjacentHTML('beforeend', renderDiscRangeOptions(filter, normalizeFilterLabel(filter)));
      updateRangeTooltips(range);
    });
  }

  function renderPriceFilter(state, filter) {
    var min = Math.max(0, Math.floor(state.priceBoundMin || 0));
    var max = Math.max(min, Math.ceil(state.priceBoundMax || 0));
    var minValue = state.priceMin === null ? min : state.priceMin;
    var maxValue = state.priceMax === null ? max : state.priceMax;
    var currencyCode = state.currencyCode || config.currencyCode || 'EUR';
    var symbol = getCurrencySymbol(currencyCode);
    var label = normalizeFilterLabel(filter);

    if (!max) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet data-kk-headless-facet-key="filter.v.price">',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(label), ' (', escapeHtml(symbol || currencyCode), ')</span></summary>',
      '<div class="kk-facet__body">',
      '<div class="collection-filters__price-range-form productgrid--sidebar-item filter-group kk-range-filter kk-range-filter--price" data-kk-headless-price-range data-kk-headless-range-min="', escapeHtml(min), '" data-kk-headless-range-max="', escapeHtml(max), '">',
      '<div class="collection-filters__filter collection-filters__filter-range">',
      '<div class="kk-range-filter__fields">',
      '<div class="collection-filters__filter-range--from kk-range-filter__field"><span class="collection-filters__filter-range-currency">', escapeHtml(symbol), '</span>',
      '<input class="collection-filters__filter-range-input kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="0.01" value="', escapeHtml(minValue), '" data-kk-headless-price-min aria-label="', escapeHtml(label), ' minimum"></div>',
      '<span class="kk-range-filter__separator" aria-hidden="true">-</span>',
      '<div class="collection-filters__filter-range--to kk-range-filter__field"><span class="collection-filters__filter-range-currency">', escapeHtml(symbol), '</span>',
      '<input class="collection-filters__filter-range-input kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="0.01" value="', escapeHtml(maxValue), '" data-kk-headless-price-max aria-label="', escapeHtml(label), ' maximum"></div>',
      '</div>',
      '<div class="kk-range-filter__slider" data-kk-headless-price-track data-kk-tooltip-prefix="', escapeHtml(symbol), '">',
      '<input class="kk-range-filter__range kk-range-filter__range--lower" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(Math.floor(minValue)), '" data-kk-headless-price-lower aria-label="', escapeHtml(label), ' minimum">',
      '<input class="kk-range-filter__range kk-range-filter__range--upper" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(Math.ceil(maxValue)), '" data-kk-headless-price-upper aria-label="', escapeHtml(label), ' maximum">',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--lower" data-kk-range-tooltip="lower" aria-hidden="true"></span>',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--upper" data-kk-range-tooltip="upper" aria-hidden="true"></span>',
      '</div>',
      '<div class="kk-range-filter__bounds" aria-hidden="true"><span>', escapeHtml(min), '</span><span>', escapeHtml(max), '</span></div>',
      '</div>',
      '</div>',
      '</div>',
      '</details>'
    ].join('');
  }

  function renderRangeFilter(state, filter) {
    var label = normalizeFilterLabel(filter);
    var facetKey = getDiscRangeFacetKey(filter);
    var unit = getRangeFacetUnit(facetKey);
    var titleLabel = unit ? label + ' (' + unit + ')' : label;
    var tooltipSuffix = unit ? ' ' + unit : '';
    var values = getSortedValues(filter);
    var numericValues = values.map(function (value) {
      return toNumber(value.label, 0);
    });
    var min = Math.floor(Math.min.apply(Math, numericValues));
    var max = Math.ceil(Math.max.apply(Math, numericValues));
    var active = getActiveDiscRangeBounds(state, facetKey, min, max);
    var activeMin = active.min;
    var activeMax = active.max;
    var options = renderDiscRangeOptions(filter, label);

    if (!values.length) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet data-kk-headless-facet-key="', escapeHtml(facetKey), '" data-kk-headless-range-facet="', escapeHtml(facetKey), '"', min === max ? ' hidden' : '', '>',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(titleLabel), '</span></summary>',
      '<div class="kk-facet__body">',
      '<div class="kk-range-filter kk-range-filter--metafield" data-kk-headless-native-range data-kk-headless-range-facet-key="', escapeHtml(facetKey), '" data-kk-headless-range-min="', escapeHtml(min), '" data-kk-headless-range-max="', escapeHtml(max), '">',
      '<div class="kk-range-filter__fields">',
      '<input class="kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMin), '" data-kk-headless-range-min-input aria-label="', escapeHtml(titleLabel), ' minimum">',
      '<span class="kk-range-filter__separator" aria-hidden="true">-</span>',
      '<input class="kk-range-filter__number" type="number" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMax), '" data-kk-headless-range-max-input aria-label="', escapeHtml(titleLabel), ' maximum">',
      '</div>',
      '<div class="kk-range-filter__slider" data-kk-tooltip-suffix="', escapeHtml(tooltipSuffix), '">',
      '<input class="kk-range-filter__range kk-range-filter__range--lower" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMin), '" data-kk-headless-range-lower aria-label="', escapeHtml(titleLabel), ' minimum">',
      '<input class="kk-range-filter__range kk-range-filter__range--upper" type="range" min="', escapeHtml(min), '" max="', escapeHtml(max), '" step="1" value="', escapeHtml(activeMax), '" data-kk-headless-range-upper aria-label="', escapeHtml(titleLabel), ' maximum">',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--lower" data-kk-range-tooltip="lower" aria-hidden="true"></span>',
      '<span class="kk-range-filter__tooltip kk-range-filter__tooltip--upper" data-kk-range-tooltip="upper" aria-hidden="true"></span>',
      '</div>',
      '<div class="kk-range-filter__bounds" aria-hidden="true"><span>', escapeHtml(formatRangeFacetValue(facetKey, min)), '</span><span>', escapeHtml(formatRangeFacetValue(facetKey, max)), '</span></div>',
      options,
      '</div>',
      '</div>',
      '</details>'
    ].join('');
  }

  function renderHeadlessSwatch(value, label) {
    var swatch = value && value.swatch ? value.swatch : null;
    var style = swatch && swatch.style ? swatch.style : getColorSwatchStyle(label);

    return [
      '<span class="faceted-filter-swatch">',
      '<span class="faceted-filter-swatch__color" style="', escapeHtml(style), '"></span>',
      '</span>'
    ].join('');
  }

  function getVendorLogo(state, vendorName) {
    var keys = getHeadlessVendorLogoKeys(vendorName);
    var logo = null;
    var alias;
    var index;

    if (!state.vendorLogos) {
      return null;
    }

    for (index = 0; index < keys.length; index += 1) {
      logo = state.vendorLogos.get(keys[index]);
      if (logo) {
        return logo;
      }

      alias = state.vendorLogoAliases && state.vendorLogoAliases.get(keys[index]);
      logo = alias ? state.vendorLogos.get(alias) : null;
      if (logo) {
        return logo;
      }
    }

    return null;
  }

  function rebuildVendorLogoAliases(state) {
    var aliases = new Map();

    (state.indexProducts || []).forEach(function (product) {
      var vendorKey = normalizeVendorLogoKey(product.vendor);
      var referenceKey = normalizeVendorLogoKey(product.vendorReferenceHandle);

      if (vendorKey && referenceKey && !aliases.has(vendorKey)) {
        aliases.set(vendorKey, referenceKey);
      }
    });

    state.vendorLogoAliases = aliases;
  }

  function renderVendorLogoImage(logo) {
    if (!logo || !logo.url) {
      return '';
    }

    return '<img class="kk-facet__vendor-logo" src="' + escapeHtml(logo.url) + '" alt="" aria-hidden="true" width="36" height="24" loading="lazy" decoding="async">';
  }

  function renderVendorLogoSlot(state, vendorName) {
    return [
      '<span class="kk-facet__vendor-logo-slot" data-kk-vendor-logo-slot data-kk-vendor-name="', escapeHtml(vendorName), '">',
      renderVendorLogoImage(getVendorLogo(state, vendorName)),
      '</span>'
    ].join('');
  }

  function normalizeProfileImageKey(value) {
    var key = normalizeVendorLogoKey(value);
    var aliases = {
      concave: 'concave',
      '1concave': 'concave',
      flat: 'flat',
      '2flat': 'flat',
      neutral: 'neutral',
      '3neutral': 'neutral',
      domey: 'domey',
      '4domey': 'domey',
      verydomey: 'veryDomey',
      '5verydomey': 'veryDomey'
    };

    return aliases[key] || '';
  }

  function renderProfileImage(profileName) {
    var imageKey = normalizeProfileImageKey(profileName);
    var imageUrl = imageKey && config.profileImages ? normalizeVendorLogoUrl(config.profileImages[imageKey]) : '';

    if (!imageUrl) {
      return '';
    }

    return [
      '<span class="kk-facet__profile-image-slot">',
      '<img class="kk-facet__profile-image" src="', escapeHtml(imageUrl), '" alt="" aria-hidden="true" width="36" height="24" loading="lazy" decoding="async">',
      '</span>'
    ].join('');
  }

  function hydrateVendorLogoSlots(state, root) {
    var scope = root && root.querySelectorAll ? root : state.root;
    var slots = [];

    if (!scope) return;
    if (scope.matches && scope.matches('[data-kk-vendor-logo-slot]')) slots.push(scope);
    scope.querySelectorAll('[data-kk-vendor-logo-slot]').forEach(function (slot) {
      slots.push(slot);
    });

    slots.forEach(function (slot) {
      var logo;
      var image;

      if (slot.querySelector('.kk-facet__vendor-logo')) {
        slot.setAttribute('data-kk-vendor-logo-hydrated', '');
        return;
      }

      logo = getVendorLogo(state, slot.getAttribute('data-kk-vendor-name'));
      if (!logo || !logo.url) {
        return;
      }

      image = document.createElement('img');
      image.className = 'kk-facet__vendor-logo';
      image.src = logo.url;
      image.alt = '';
      image.setAttribute('aria-hidden', 'true');
      image.width = 36;
      image.height = 24;
      image.loading = 'lazy';
      image.decoding = 'async';
      slot.appendChild(image);
      slot.setAttribute('data-kk-vendor-logo-hydrated', '');
    });
  }

  function hydrateCurrentVendorLogoSlots(state) {
    var modalContent = getOpenHeadlessModalContent();

    hydrateVendorLogoSlots(state, state.root);
    if (modalContent && (!state.root || !state.root.contains(modalContent))) {
      hydrateVendorLogoSlots(state, modalContent);
    }
  }

  function primeVendorLogos(state) {
    if (state.vendorLogoPromise) {
      return state.vendorLogoPromise;
    }

    state.vendorLogoPromise = fetchVendorLogos(state).then(function (logos) {
      state.vendorLogos = logos;
      hydrateCurrentVendorLogoSlots(state);
      return logos;
    });

    return state.vendorLogoPromise;
  }

  function renderListFilter(state, filter, filterIndex) {
    var label = normalizeFilterLabel(filter);
    var facetKey = filter.facetKey || filter.id || filter.key || label;
    var values = getSortedValues(filter);
    var filterListId = 'KkHeadlessFacetOptions-' + String(filter.id || filter.key || label || 'filter')
      .replace(/[^a-z0-9_-]+/gi, '-') + '-' + String(filterIndex + 1);
    var showSearch = values.length > state.tagLimit;
    var isSwatch = Boolean(filter.swatch);
    var isVendor = filter.id === 'filter.p.vendor';
    var isProfile = filter.key === 'custom.profile' || filter.id === 'filter.p.m.custom.profile';
    var filterGroupClass = isSwatch ? 'filter-group--swatch' : (isVendor ? 'filter-group--vendor' : (isProfile ? 'filter-group--profile' : 'filter-group--text'));
    var toggleMoreText = isSwatch ? t('filters_show_all', 'Show all') : t('see_more', 'See more');
    var toggleLessText = isSwatch ? t('filters_show_less', 'Show less') : t('see_less', 'See less');
    var items = values.map(function (value, index) {
      var input = parseFilterInput(value.input);
      var checked = isSelected(state, input);
      var disabled = !checked && value.count === 0;
      var displayLabel = normalizeValueLabel(filter, value);
      var optionImage = isVendor ? renderVendorLogoSlot(state, displayLabel) : (isProfile ? renderProfileImage(displayLabel) : '');
      var displayValue = optionImage ? [
        '<span class="kk-facet__value-with-logo">',
        optionImage,
        '<span class="kk-facet__value">', escapeHtml(displayLabel), '</span>',
        '</span>'
      ].join('') : '<span class="kk-facet__value">' + escapeHtml(displayLabel) + '</span>';

      return [
        '<li class="filter-item kk-facet__item ', checked ? 'filter-item--active' : 'filter-item--inactive', index >= state.tagLimit ? ' filter-item--hidden' : '', disabled ? ' filter-item--disabled kk-headless-filter-option--zero' : '', '" data-kk-headless-filter-option data-kk-headless-filter-key="', escapeHtml(stableFilterKey(input)), '" data-kk-headless-source-index="', escapeHtml(index), '" data-kk-headless-filter-search-text="', escapeHtml(displayLabel.toLowerCase()), '" ', disabled ? 'data-kk-headless-zero-option ' : '', index >= state.tagLimit ? 'data-hidden-default' : '', '>',
        '<label class="filter-item__label kk-facet__label ', disabled ? 'filter-item__label--disabled' : '', '">',
        '<input class="faceted-filter__checkbox" type="checkbox" ', checked ? 'checked' : '', disabled ? 'disabled' : '', ' data-kk-headless-filter-input value="', escapeHtml(value.input), '" data-kk-headless-filter-label="', escapeHtml(label), '" data-kk-headless-value-label="', escapeHtml(displayLabel), '">',
        isSwatch ? renderHeadlessSwatch(value, displayLabel) : '<span class="filter-icon--checkbox" aria-hidden="true"></span>',
        '<span class="faceted-filter__label-text kk-facet__label-text">', displayValue,
        state.showProductCounts ? '<span class="kk-facet__count">(' + escapeHtml(value.count || 0) + ')</span>' : '',
        '</span></label></li>'
      ].join('');
    }).join('');

    if (!values.length) {
      return '';
    }

    return [
      '<details class="kk-facet" open data-kk-headless-facet data-kk-headless-facet-key="', escapeHtml(facetKey), '">',
      '<summary class="kk-facet__summary"><span class="kk-facet__title">', escapeHtml(label), '</span></summary>',
      '<div class="kk-facet__body">',
      showSearch ? '<label class="kk-facet__search"><span class="visually-hidden">' + escapeHtml(t('filters_search_options', 'Search options')) + '</span><input class="kk-facet__search-input" type="search" placeholder="' + escapeHtml(t('filters_search_options', 'Search options')) + '" autocomplete="off" data-kk-headless-filter-search></label>' : '',
      '<ul id="', escapeHtml(filterListId), '" class="productgrid--sidebar-item filter-group ', escapeHtml(filterGroupClass), ' kk-facet__list" data-kk-headless-filter-list>',
      items,
      values.length > state.tagLimit ? '<li class="filter-item filter-item--toggle-more kk-facet__toggle-more"><button class="filter-text--link kk-filter-toggle-button" type="button" data-kk-headless-toggle-more="false" data-kk-headless-see-more-text="' + escapeHtml(toggleMoreText) + '" data-kk-headless-see-less-text="' + escapeHtml(toggleLessText) + '" aria-expanded="false" aria-controls="' + escapeHtml(filterListId) + '">' + escapeHtml(toggleMoreText) + '</button></li>' : '',
      '</ul>',
      '</div>',
      '</details>'
    ].join('');
  }

  function refreshOpenFilterModal() {
    var modalContainer = document.querySelector('[data-modal-container]');
    var modalContent = modalContainer && modalContainer.querySelector('[data-modal-content]');
    var sidebarFilterContent = document.querySelector('[data-product-grid-sidebar] [data-productgrid-filters-content]');
    var modalFilterContent = modalContent && modalContent.querySelector('[data-productgrid-filters-content]');
    var modalIsOpenForFilters = modalContainer && modalContainer.classList.contains('modal--productgrid-filters');

    if (!modalIsOpenForFilters || !modalContent || !sidebarFilterContent) {
      return;
    }

    // Superstore's modal controller keeps a reference to the filter content
    // node it moved into the modal. Replacing that node leaves the controller
    // pointing at a detached element, which can discard staged selections and
    // leave the body scroll lock active when the modal closes. Preserve the
    // owned node and update its contents in place instead.
    if (modalFilterContent) {
      modalFilterContent.className = sidebarFilterContent.className;
      modalFilterContent.innerHTML = sidebarFilterContent.innerHTML;
      modalFilterContent.setAttribute('data-productgrid-filters-content', '');
      modalFilterContent.setAttribute('data-faceted-filters', '');
      modalFilterContent.setAttribute('data-kk-headless-filters-content', '');

      if (sidebarFilterContent.hasAttribute('aria-busy')) {
        modalFilterContent.setAttribute('aria-busy', sidebarFilterContent.getAttribute('aria-busy'));
      } else {
        modalFilterContent.removeAttribute('aria-busy');
      }

      sidebarFilterContent.remove();
      return;
    }

    while (modalContent.firstChild) {
      modalContent.removeChild(modalContent.firstChild);
    }

    while (sidebarFilterContent.firstChild) {
      modalContent.appendChild(sidebarFilterContent.firstChild);
    }
  }

  function getMobileResultsLabel(count) {
    var code = getLanguageCode();

    if (code === 'fi') {
      return count === 1 ? 'N\u00e4yt\u00e4 1 tulos' : 'N\u00e4yt\u00e4 ' + count + ' tulosta';
    }

    if (code === 'sv') {
      return 'Visa ' + count + ' resultat';
    }

    return count === 1 ? 'Show 1 result' : 'Show ' + count + ' results';
  }

  function getStagedFiltersLabel() {
    var code = getLanguageCode();

    if (code === 'fi') return 'Valitut suodattimet';
    if (code === 'sv') return 'Valda filter';
    return 'Selected filters';
  }

  function getRemoveStagedFilterLabel(label) {
    var code = getLanguageCode();

    if (code === 'fi') return 'Poista suodatin ' + label;
    if (code === 'sv') return 'Ta bort filtret ' + label;
    return 'Remove filter ' + label;
  }

  function getStagedResultCount(state) {
    if (!state.indexLoaded || state.contextualResultGeneration !== state.filterWorkGeneration) {
      return null;
    }

    return Math.max(0, toNumber(state.contextualResultCount, state.loadedCount || state.collectionCount || 0));
  }

  function getStagedFilterChips(state) {
    var chips = [];
    var grouped = new Map();
    var currency = state.currencyCode || config.currencyCode || 'EUR';

    state.rangeSelections.forEach(function (selection, facetKey) {
      var rangeUnit = getRangeFacetUnit(facetKey);
      var valueLabel = selection.min === selection.max ?
        String(selection.min) : selection.min + ' - ' + selection.max;
      var filterLabel = selection.filterLabel || getRangeSelectionFilterLabel(facetKey);

      if (rangeUnit) valueLabel += ' ' + rangeUnit;
      chips.push({
        type: 'range',
        key: facetKey,
        label: filterLabel ? filterLabel + ': ' + valueLabel : valueLabel
      });
    });

    state.selected.forEach(function (item, key) {
      var facetKey = inputFacetKey(item.input);

      if (state.rangeSelections.has(facetKey)) return;

      if (!grouped.has(facetKey)) {
        grouped.set(facetKey, []);
      }

      grouped.get(facetKey).push({ key: key, item: item });
    });

    grouped.forEach(function (entries, facetKey) {
      if (isRangeFacetKey(facetKey) && entries.length) {
        var values = entries.map(function (entry) {
          return toNumber(entry.item.label, NaN);
        }).filter(function (value) {
          return !isNaN(value);
        });
        var min = values.length ? Math.min.apply(Math, values) : '';
        var max = values.length ? Math.max.apply(Math, values) : '';
        var filterLabel = entries[0].item.filterLabel || '';
        var rangeUnit = getRangeFacetUnit(facetKey);
        var valueLabel = min === max ? String(min) : min + ' - ' + max;

        if (rangeUnit) valueLabel += ' ' + rangeUnit;

        chips.push({
          type: 'range',
          key: facetKey,
          label: filterLabel ? filterLabel + ': ' + valueLabel : valueLabel
        });
        return;
      }

      entries.forEach(function (entry) {
        chips.push({
          type: 'filter',
          key: entry.key,
          label: entry.item.filterLabel ? entry.item.filterLabel + ': ' + entry.item.label : entry.item.label
        });
      });
    });

    if (state.priceMin !== null || state.priceMax !== null) {
      chips.push({
        type: 'price',
        key: 'price',
        label: formatMoney(state.priceMin === null ? (state.priceBoundMin || 0) : state.priceMin, currency) +
          ' - ' + formatMoney(state.priceMax === null ? state.priceBoundMax : state.priceMax, currency)
      });
    }

    return chips;
  }

  function getStagedChipAttribute(chip) {
    return chip.type === 'range' ? 'data-kk-headless-staged-remove-range' :
      (chip.type === 'price' ? 'data-kk-headless-staged-remove-price' : 'data-kk-headless-staged-remove-filter');
  }

  function getStagedChipIdentity(chip) {
    return chip.type + ':' + chip.key;
  }

  function renderStagedFilterChipButton(chip) {
    var attribute = getStagedChipAttribute(chip);

    return [
      '<button class="kk-headless-staged-chip" type="button" ', attribute, '="', escapeHtml(chip.key), '" aria-label="', escapeHtml(getRemoveStagedFilterLabel(chip.label)), '">',
      '<span class="kk-headless-staged-chip__text">', escapeHtml(chip.label), '</span>',
      '<span class="kk-headless-staged-chip__remove" aria-hidden="true"></span>',
      '</button>'
    ].join('');
  }

  function renderStagedFilterChipButtons(state) {
    return getStagedFilterChips(state).map(renderStagedFilterChipButton).join('');
  }

  function getStagedChipButtonIdentity(button) {
    if (button.hasAttribute('data-kk-headless-staged-remove-range')) {
      return 'range:' + button.getAttribute('data-kk-headless-staged-remove-range');
    }

    if (button.hasAttribute('data-kk-headless-staged-remove-price')) {
      return 'price:' + button.getAttribute('data-kk-headless-staged-remove-price');
    }

    return 'filter:' + (button.getAttribute('data-kk-headless-staged-remove-filter') || '');
  }

  function syncStagedFilterChipTrack(state, track) {
    var chips = getStagedFilterChips(state);
    var existing = new Map();
    var nextPosition = track.firstElementChild;

    track.querySelectorAll('.kk-headless-staged-chip').forEach(function (button) {
      existing.set(getStagedChipButtonIdentity(button), button);
    });

    chips.forEach(function (chip) {
      var identity = getStagedChipIdentity(chip);
      var button = existing.get(identity);
      var text;

      if (!button) {
        var template = document.createElement('template');
        template.innerHTML = renderStagedFilterChipButton(chip);
        button = template.content.firstElementChild;
      } else {
        existing.delete(identity);
      }

      button.setAttribute('aria-label', getRemoveStagedFilterLabel(chip.label));
      text = button.querySelector('.kk-headless-staged-chip__text');
      if (text && text.textContent !== chip.label) {
        text.textContent = chip.label;
      }

      // Preserve an already correctly positioned button node. Even moving the
      // same node away and back during pointer activation can suppress the
      // browser's final click event on touch and mouse input.
      if (button !== nextPosition) {
        track.insertBefore(button, nextPosition);
      }
      nextPosition = button.nextElementSibling;
    });

    existing.forEach(function (button) {
      button.remove();
    });

    return chips.length;
  }

  function renderMobileStagedFilters(state) {
    var chips = renderStagedFilterChipButtons(state);

    return [
      '<div class="kk-headless-mobile-staged-filters" data-kk-headless-staged-filters aria-label="', escapeHtml(getStagedFiltersLabel()), '"', chips ? '' : ' hidden', '>',
      '<div class="kk-headless-mobile-staged-filters__track">', chips, '</div>',
      '</div>'
    ].join('');
  }

  function renderMobileApplyBar(state) {
    var count = getStagedResultCount(state);
    var countAttribute = count === null ? '' : ' data-kk-headless-filter-results-count="' + escapeHtml(count) + '"';
    var loadingAttributes = count === null ? ' disabled aria-busy="true"' : '';
    var label = count === null ? t('filters_show_results', 'Show results') : getMobileResultsLabel(count);

    return [
      '<div class="kk-headless-mobile-apply-bar" data-kk-headless-mobile-apply-bar>',
      '<button class="kk-filter-results-button" type="button" data-kk-headless-filter-results data-kk-filter-results-button data-modal-close', countAttribute, loadingAttributes, '>',
      escapeHtml(label),
      '</button>',
      '</div>'
    ].join('');
  }

  function getOpenHeadlessModalContent() {
    var modal = document.querySelector('[data-modal-container].modal--productgrid-filters');
    var modalContent = modal && modal.querySelector('[data-modal-content]');
    var wrappedContent = modalContent && modalContent.querySelector('[data-kk-headless-filters-content]');

    if (wrappedContent) return wrappedContent;
    if (modalContent && modalContent.querySelector('[data-kk-headless-staged-filters], [data-kk-headless-facets]')) {
      return modalContent;
    }

    return null;
  }

  function updateMobileModalStagedUi(state) {
    var content = getOpenHeadlessModalContent();

    syncMobileStagedUiInContent(state, content);
  }

  function syncMobileStagedUiInContent(state, content) {
    var chips = content && content.querySelector('[data-kk-headless-staged-filters]');
    var track = chips && chips.querySelector('.kk-headless-mobile-staged-filters__track');
    var button = content && content.querySelector('[data-kk-headless-filter-results]');
    var chipCount;
    var count;

    if (!content) return;

    chipCount = track ? syncStagedFilterChipTrack(state, track) : getStagedFilterChips(state).length;
    if (chips) chips.hidden = chipCount === 0;

    count = getStagedResultCount(state);
    if (button) {
      if (count === null) {
        button.textContent = t('filters_show_results', 'Show results');
        button.removeAttribute('data-kk-headless-filter-results-count');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      } else {
        button.textContent = getMobileResultsLabel(count);
        button.setAttribute('data-kk-headless-filter-results-count', String(count));
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  }

  function getRenderedFacetKey(facet) {
    return facet && facet.getAttribute('data-kk-headless-facet-key') || '';
  }

  function getRenderedFilterKey(option) {
    var key = option && option.getAttribute('data-kk-headless-filter-key');
    var input;

    if (key) return key;
    input = option && option.querySelector('[data-kk-headless-filter-input]');
    return input ? stableFilterKey(parseFilterInput(input.value)) : '';
  }

  function copyFilterOptionMetadata(current, desired) {
    ['data-kk-headless-source-index', 'data-kk-headless-filter-search-text', 'data-hidden-default', 'data-kk-headless-option-count'].forEach(function (name) {
      if (desired.hasAttribute(name)) {
        current.setAttribute(name, desired.getAttribute(name));
      } else {
        current.removeAttribute(name);
      }
    });
  }

  function copyFilterOptionState(current, desired) {
    var currentInput = current.querySelector('[data-kk-headless-filter-input]');
    var desiredInput = desired.querySelector('[data-kk-headless-filter-input]');
    var currentCount = current.querySelector('.kk-facet__count');
    var desiredCount = desired.querySelector('.kk-facet__count');
    var currentLabel = current.querySelector('.kk-facet__label');
    var desiredLabel = desired.querySelector('.kk-facet__label');

    copyFilterOptionMetadata(current, desired);
    current.hidden = desired.hidden;
    current.removeAttribute('data-kk-headless-reconcile-missing');
    current.classList.toggle('filter-item--active', desired.classList.contains('filter-item--active'));
    current.classList.toggle('filter-item--inactive', desired.classList.contains('filter-item--inactive'));
    current.classList.toggle('filter-item--disabled', desired.classList.contains('filter-item--disabled'));
    current.classList.toggle('kk-headless-filter-option--zero', desired.classList.contains('kk-headless-filter-option--zero'));
    current.toggleAttribute('data-kk-headless-zero-option', desired.hasAttribute('data-kk-headless-zero-option'));

    if (currentInput && desiredInput) {
      currentInput.checked = desiredInput.checked;
      currentInput.disabled = desiredInput.disabled;
      currentInput.value = desiredInput.value;
      ['data-kk-headless-filter-label', 'data-kk-headless-value-label'].forEach(function (name) {
        if (desiredInput.hasAttribute(name)) {
          currentInput.setAttribute(name, desiredInput.getAttribute(name));
        } else {
          currentInput.removeAttribute(name);
        }
      });
    }

    if (currentCount && desiredCount && currentCount.textContent !== desiredCount.textContent) {
      currentCount.textContent = desiredCount.textContent;
    }
    if (currentLabel && desiredLabel) {
      currentLabel.classList.toggle('filter-item__label--disabled', desiredLabel.classList.contains('filter-item__label--disabled'));
    }
  }

  function reconcileListFacet(state, currentFacet, desiredFacet) {
    var currentBody = currentFacet.querySelector('.kk-facet__body');
    var desiredSearch = desiredFacet.querySelector('[data-kk-headless-filter-search]');
    var currentSearch = currentFacet.querySelector('[data-kk-headless-filter-search]');
    var desiredList = desiredFacet.querySelector('[data-kk-headless-filter-list]');
    var currentList = currentFacet.querySelector('[data-kk-headless-filter-list]');
    var currentOptions = new Map();
    var currentOrderIndexes = new Map();
    var desiredKeys = new Set();
    var desiredOrder = [];
    var retainedOrder = [];
    var desiredToggle;
    var currentToggle;
    var currentToggleItem;
    var desiredToggleItem;
    var activeInList;
    var listScrollTop;
    var orderedNodes;
    var missingNodes = [];
    var activeOption;
    var activeIndex;
    var countSorted;
    var facetKey = getRenderedFacetKey(currentFacet);
    var currentChildren;
    var orderChanged;

    if (!currentBody || !desiredList || !currentList) return false;

    if (desiredSearch && !currentSearch) {
      currentBody.insertBefore(desiredSearch.closest('.kk-facet__search').cloneNode(true), currentList);
    }

    currentList.querySelectorAll('[data-kk-headless-filter-option]').forEach(function (option, index) {
      var key = getRenderedFilterKey(option);
      if (key) {
        currentOptions.set(key, option);
        currentOrderIndexes.set(key, index);
      }
    });

    desiredList.querySelectorAll('[data-kk-headless-filter-option]').forEach(function (desiredOption) {
      var key = getRenderedFilterKey(desiredOption);
      var currentOption = key && currentOptions.get(key);

      if (!key) return;
      desiredKeys.add(key);

      if (currentOption) {
        copyFilterOptionState(currentOption, desiredOption);
      } else {
        currentOption = desiredOption.cloneNode(true);
        currentOptions.set(key, currentOption);
        missingNodes.push(currentOption);
      }
      desiredOrder.push(currentOption);
    });

    currentOptions.forEach(function (option, key) {
      var input;
      var selected;

      if (desiredKeys.has(key)) return;
      input = option.querySelector('[data-kk-headless-filter-input]');
      selected = Boolean((state.selected && state.selected.has(key)) || (input && input.checked));
      if (input) {
        input.checked = selected;
        input.disabled = !selected;
      }
      option.setAttribute('data-kk-headless-option-count', '0');
      option.toggleAttribute('data-kk-headless-reconcile-missing', !selected);
      option.hidden = !selected;
      option.classList.toggle('filter-item--active', selected);
      option.classList.toggle('filter-item--inactive', !selected);
      option.classList.toggle('filter-item--disabled', !selected);
      option.classList.toggle('kk-headless-filter-option--zero', !selected);
      option.toggleAttribute('data-kk-headless-zero-option', !selected);
      var countNode = option.querySelector('.kk-facet__count');
      var labelNode = option.querySelector('.kk-facet__label');
      if (countNode && state.showProductCounts) countNode.textContent = '(0)';
      if (labelNode) labelNode.classList.toggle('filter-item__label--disabled', !selected);
      retainedOrder.push(option);
    });

    desiredToggle = desiredList.querySelector('[data-kk-headless-toggle-more]');
    currentToggle = currentList.querySelector('[data-kk-headless-toggle-more]');

    if (desiredToggle && !currentToggle) {
      desiredToggleItem = desiredToggle.closest('.filter-item').cloneNode(true);
      currentToggle = desiredToggleItem.querySelector('[data-kk-headless-toggle-more]');
    }

    if (currentToggle) {
      currentToggleItem = currentToggle.closest('.filter-item');
      if (desiredToggle) {
        currentToggle.setAttribute('data-kk-headless-see-more-text', desiredToggle.getAttribute('data-kk-headless-see-more-text') || '');
        currentToggle.setAttribute('data-kk-headless-see-less-text', desiredToggle.getAttribute('data-kk-headless-see-less-text') || '');
        currentToggle.setAttribute('aria-controls', currentList.id || desiredToggle.getAttribute('aria-controls') || '');
      }
    }

    activeInList = currentList.contains(document.activeElement);
    listScrollTop = currentList.scrollTop;
    countSorted = getCountSortedFiltersByKey(state).has(facetKey);
    if (countSorted) {
      desiredOrder = desiredOrder.map(function (option, desiredIndex) {
        var key = getRenderedFilterKey(option);
        return {
          option: option,
          count: getCurrentFilterOptionCount(state, option),
          previousIndex: currentOrderIndexes.has(key) ? currentOrderIndexes.get(key) : currentOptions.size + desiredIndex
        };
      }).sort(function (a, b) {
        return b.count - a.count || a.previousIndex - b.previousIndex;
      }).map(function (entry) {
        return entry.option;
      });
    }
    orderedNodes = desiredOrder.concat(retainedOrder);
    orderedNodes.forEach(function (option, index) {
      if (option.getAttribute('data-kk-headless-source-index') !== String(index)) {
        option.setAttribute('data-kk-headless-source-index', String(index));
      }
    });
    if (currentToggleItem) orderedNodes.push(currentToggleItem);
    currentChildren = Array.prototype.slice.call(currentList.children);
    orderChanged = currentChildren.length !== orderedNodes.length || orderedNodes.some(function (node, index) {
      return currentChildren[index] !== node;
    });

    if (!orderChanged) {
      currentList.scrollTop = listScrollTop;
      return false;
    }

    if (activeInList) {
      activeOption = document.activeElement && document.activeElement.closest ?
        document.activeElement.closest('[data-kk-headless-filter-option]') : null;
      if (activeOption && activeOption.parentNode === currentList) {
        var beforeFragment = document.createDocumentFragment();
        var afterFragment = document.createDocumentFragment();
        activeIndex = orderedNodes.indexOf(activeOption);

        if (activeIndex !== -1) {
          orderedNodes.slice(0, activeIndex).forEach(function (node) {
            beforeFragment.appendChild(node);
          });
          orderedNodes.slice(activeIndex + 1).forEach(function (node) {
            afterFragment.appendChild(node);
          });
          currentList.insertBefore(beforeFragment, activeOption);
          currentList.insertBefore(afterFragment, activeOption.nextSibling);
          currentList.scrollTop = listScrollTop;
          return false;
        }
      }

      if (missingNodes.length) {
        var fragment = document.createDocumentFragment();
        missingNodes.forEach(function (node) {
          fragment.appendChild(node);
        });
        currentList.insertBefore(fragment, currentToggleItem || null);
      }
      currentList.scrollTop = listScrollTop;
      return true;
    }

    if (typeof currentList.replaceChildren === 'function') {
      currentList.replaceChildren.apply(currentList, orderedNodes);
    } else {
      orderedNodes.forEach(function (node) {
        currentList.appendChild(node);
      });
    }
    currentList.scrollTop = listScrollTop;
    return false;
  }

  function reconcilePriceFacet(currentFacet, desiredFacet) {
    var currentRange = currentFacet.querySelector('[data-kk-headless-price-range]');
    var desiredRange = desiredFacet.querySelector('[data-kk-headless-price-range]');
    var selectors = [
      '[data-kk-headless-price-min]',
      '[data-kk-headless-price-max]',
      '[data-kk-headless-price-lower]',
      '[data-kk-headless-price-upper]'
    ];
    var preserveValues;

    if (!currentRange || !desiredRange) return;
    preserveValues = currentRange.contains(document.activeElement);
    ['data-kk-headless-range-min', 'data-kk-headless-range-max'].forEach(function (name) {
      currentRange.setAttribute(name, desiredRange.getAttribute(name) || '0');
    });

    selectors.forEach(function (selector) {
      var current = currentRange.querySelector(selector);
      var desired = desiredRange.querySelector(selector);

      if (!current || !desired) return;
      current.min = desired.min;
      current.max = desired.max;
      current.step = desired.step;
      if (!preserveValues) current.value = desired.value;
    });

    Array.prototype.forEach.call(currentRange.querySelectorAll('.kk-range-filter__bounds span'), function (bound, index) {
      var desiredBound = desiredRange.querySelectorAll('.kk-range-filter__bounds span')[index];
      if (desiredBound) bound.textContent = desiredBound.textContent;
    });
    updateRangeTooltips(currentRange);
  }

  function reconcileCompletedFilterContent(state, content, innerHtml) {
    var template = document.createElement('template');
    var desiredContent;
    var currentForm;
    var desiredForm;
    var currentFacets = new Map();
    var desiredKeys = new Set();
    var scrollTop;
    var modalScroller;
    var modalScrollTop;

    if (!content) return false;

    template.innerHTML = innerHtml;
    desiredContent = template.content;
    currentForm = content.querySelector('[data-kk-headless-facets]');
    desiredForm = desiredContent.querySelector('[data-kk-headless-facets]');
    if (!currentForm || !desiredForm) return false;

    scrollTop = content.scrollTop;
    modalScroller = content.closest('[data-modal-content]');
    modalScrollTop = modalScroller ? modalScroller.scrollTop : 0;

    currentForm.querySelectorAll('[data-kk-headless-facet-key]').forEach(function (facet) {
      var key = getRenderedFacetKey(facet);
      if (key) currentFacets.set(key, facet);
    });

    desiredForm.querySelectorAll('[data-kk-headless-facet-key]').forEach(function (desiredFacet) {
      var key = getRenderedFacetKey(desiredFacet);
      var currentFacet = key && currentFacets.get(key);

      if (!key) return;
      desiredKeys.add(key);

      if (!currentFacet) {
        currentForm.appendChild(desiredFacet.cloneNode(true));
        return;
      }

      currentFacet.hidden = desiredFacet.hidden;
      if (key === 'filter.v.price') {
        reconcilePriceFacet(currentFacet, desiredFacet);
      } else {
        reconcileListFacet(state, currentFacet, desiredFacet);
      }
    });

    currentFacets.forEach(function (facet, key) {
      if (!desiredKeys.has(key)) facet.hidden = true;
    });

    content.querySelectorAll('[data-kk-headless-index-loading-text]').forEach(function (node) {
      var wrapper = node.closest('.kk-headless-index-loading__status');
      if (wrapper) wrapper.remove();
    });

    syncMobileStagedUiInContent(state, content);
    content.scrollTop = scrollTop;
    if (modalScroller) modalScroller.scrollTop = modalScrollTop;
    return true;
  }

  function getFilterRenderTarget(state) {
    var sidebar = getSidebar(state);
    var modalContainer = document.querySelector('[data-modal-container].modal--productgrid-filters');
    var modalContent = modalContainer && modalContainer.querySelector('[data-modal-content]');
    var modalOwnedContent = modalContent && modalContent.querySelector('[data-productgrid-filters-content]');
    var openModalFilterContent = getOpenHeadlessModalContent();
    var content = modalOwnedContent || openModalFilterContent ||
      (modalContainer && modalContainer.classList.contains('visible') ? modalContent : null) ||
      (sidebar && sidebar.querySelector('[data-kk-headless-filters-content]'));
    var form = content && content.querySelector('[data-kk-headless-facets]');

    return {
      sidebar: sidebar,
      modalContent: modalContent,
      content: content,
      form: form
    };
  }

  function preserveFilterScroll(content, callback) {
    var modalScroller = content && content.closest ? content.closest('[data-modal-content]') : null;
    var contentScrollTop = content ? content.scrollTop : 0;
    var modalScrollTop = modalScroller ? modalScroller.scrollTop : 0;
    var result = callback();

    if (content) content.scrollTop = contentScrollTop;
    if (modalScroller && modalScroller !== content) modalScroller.scrollTop = modalScrollTop;
    return result;
  }

  function getFilterFacetDescriptors(state) {
    var descriptors = [];
    var priceFilter = findPriceFilter(state.filters);

    if (priceFilter) {
      descriptors.push({
        filter: priceFilter,
        render: function () {
          return renderPriceFilter(state, priceFilter);
        }
      });
    }

    getListFilters(state.filters).forEach(function (filter, filterIndex) {
      descriptors.push({
        filter: filter,
        render: function () {
          return isDiscRangeFilter(filter) ? renderRangeFilter(state, filter) : renderListFilter(state, filter, filterIndex);
        }
      });
    });

    return descriptors;
  }

  function runFilterRenderSteps(items, iteratee, shouldContinue) {
    var index = 0;

    return new Promise(function (resolve, reject) {
      function next() {
        if (shouldContinue && !shouldContinue()) {
          resolve(false);
          return;
        }

        if (index >= items.length) {
          resolve(true);
          return;
        }

        try {
          iteratee(items[index], index);
          index += 1;
        } catch (error) {
          reject(error);
          return;
        }

        // A facet is the atomic DOM unit. Always yield after one facet, even
        // when it completed inside the 8 ms budget, so mutation observers such
        // as Langify never receive the whole filter tree in one task.
        yieldToMainThread().then(next, reject);
      }

      yieldToMainThread().then(next, reject);
    });
  }

  function isCurrentFilterRender(state, context) {
    return Boolean(
      state &&
      !state.destroyed &&
      state.filterRenderGeneration === context.renderGeneration &&
      state.indexGeneration === context.indexGeneration &&
      state.filterWorkGeneration === context.workGeneration &&
      state.partialFilterGeneration === context.partialGeneration &&
      state.filterListPointerCount === 0 &&
      state.root &&
      state.root.isConnected &&
      context.content &&
      context.content.isConnected &&
      context.form &&
      context.content.contains(context.form)
    );
  }

  function parseDesiredFacetMarkup(markup) {
    var template;

    if (!markup) return null;
    template = document.createElement('template');
    template.innerHTML = markup;
    return template.content.firstElementChild;
  }

  function updateFacetHeading(currentFacet, desiredFacet) {
    var currentTitle = currentFacet.querySelector('.kk-facet__title');
    var desiredTitle = desiredFacet.querySelector('.kk-facet__title');

    if (currentTitle && desiredTitle && currentTitle.textContent !== desiredTitle.textContent) {
      currentTitle.textContent = desiredTitle.textContent;
    }
  }

  function reconcileCompletedFacet(state, context, desiredFacet) {
    var key = getRenderedFacetKey(desiredFacet);
    var currentFacet = key && context.currentFacets.get(key);
    var currentList;
    var searchInput;
    var reorderDeferred = false;

    if (!key) return;
    context.desiredKeys.add(key);

    preserveFilterScroll(context.content, function () {
      if (!currentFacet) {
        currentFacet = desiredFacet.cloneNode(true);
        context.form.appendChild(currentFacet);
        context.currentFacets.set(key, currentFacet);
      } else {
        currentFacet.hidden = desiredFacet.hidden;
        updateFacetHeading(currentFacet, desiredFacet);

        if (key === 'filter.v.price') {
          reconcilePriceFacet(currentFacet, desiredFacet);
        } else if (desiredFacet.querySelector('[data-kk-headless-native-range]')) {
          updateContextualDiscRangesInPlace(state, currentFacet);
        } else {
          reorderDeferred = reconcileListFacet(state, currentFacet, desiredFacet);
        }
      }

      currentList = currentFacet.querySelector('[data-kk-headless-filter-list]');
      if (currentList) {
        currentList.querySelectorAll('[data-kk-headless-filter-input]').forEach(function (input) {
          updateRenderedFilterInput(state, input, state.facetValueCounts, context.legacyValueCounts);
        });
        syncFilterOptionListLimit(state, currentList);
        searchInput = currentFacet.querySelector('[data-kk-headless-filter-search]');
        if (searchInput) handleFilterSearch({ target: searchInput });
      }
      currentFacet.querySelectorAll('[data-kk-headless-price-range], [data-kk-headless-native-range]').forEach(updateRangeTooltips);
    });

    if (reorderDeferred) context.reorderDeferred = true;
  }

  function cancelCompletedFilterRender(state, context) {
    if (
      state &&
      !state.destroyed &&
      state.filterRenderGeneration === context.renderGeneration &&
      state.indexGeneration === context.indexGeneration &&
      state.filterWorkGeneration === context.workGeneration &&
      state.partialFilterGeneration === context.partialGeneration &&
      state.root &&
      state.root.isConnected
    ) {
      state.pendingFilterRender = true;
      if (state.filterListPointerCount === 0) scheduleDeferredFilterCountUpdate(state);
    }
    return false;
  }

  function ensureCompletedFilterShell(state, target) {
    var content = target.content;
    var shellHtml = [
      renderMobileStagedFilters(state),
      '<h2 class="productgrid--sidebar-title visually-hidden">', escapeHtml(t('filters_title_count_zero', 'Filters')), '</h2>',
      '<nav aria-label="Collection filters">',
      '<form class="faceted-filter__form kk-facets" data-kk-headless-facets></form>',
      '</nav>',
      renderMobileApplyBar(state)
    ].join('');

    if (!content && target.sidebar) {
      target.sidebar.querySelectorAll('[data-productgrid-filters-content]').forEach(function (node) {
        node.remove();
      });
      target.sidebar.insertAdjacentHTML('afterbegin', [
        '<div class="productgrid--sidebar-section" data-productgrid-filters-content data-faceted-filters data-kk-headless-filters-content aria-busy="true">',
        shellHtml,
        '</div>'
      ].join(''));
      content = target.sidebar.querySelector('[data-kk-headless-filters-content]');
      target.content = content;
    } else if (content && !content.querySelector('[data-kk-headless-facets]')) {
      content.innerHTML = shellHtml;
    }

    target.form = content && content.querySelector('[data-kk-headless-facets]');
    return Boolean(target.content && target.form);
  }

  function renderCompletedFiltersInSlices(state, options) {
    var target = getFilterRenderTarget(state);
    var partialIndexLoading = state.partialRendered && !state.indexLoaded;
    var renderGeneration;
    var context;
    var descriptors;
    var preparedFacets = [];
    var promise;

    if (
      partialIndexLoading ||
      !state.indexLoaded
    ) {
      renderFilters(state);
      return Promise.resolve(true);
    }

    if (state.filterListPointerCount > 0) {
      state.pendingFilterRender = true;
      return Promise.resolve(false);
    }

    if (!ensureCompletedFilterShell(state, target)) {
      renderFilters(state);
      return Promise.resolve(true);
    }

    renderGeneration = state.filterRenderGeneration + 1;
    state.filterRenderGeneration = renderGeneration;
    state.pendingFilterRender = false;
    target.content.setAttribute('aria-busy', 'true');
    context = {
      renderGeneration: renderGeneration,
      indexGeneration: state.indexGeneration,
      workGeneration: options && options.workGeneration !== undefined ? options.workGeneration : state.filterWorkGeneration,
      partialGeneration: state.partialFilterGeneration,
      content: target.content,
      form: target.form,
      currentFacets: new Map(),
      desiredKeys: new Set(),
      reorderDeferred: false,
      legacyValueCounts: state.facetValueCounts && typeof state.facetValueCounts.get === 'function' ?
        null : getLegacyFilterValueCounts(state)
    };
    descriptors = getFilterFacetDescriptors(state);

    context.form.querySelectorAll('[data-kk-headless-facet-key]').forEach(function (facet) {
      var key = getRenderedFacetKey(facet);
      if (key) context.currentFacets.set(key, facet);
    });

    promise = runFilterRenderSteps(descriptors, function (descriptor) {
      var desiredFacet = parseDesiredFacetMarkup(descriptor.render());
      if (desiredFacet) preparedFacets.push(desiredFacet);
    }, function () {
      return isCurrentFilterRender(state, context);
    }).then(function (prepared) {
      if (!prepared || !isCurrentFilterRender(state, context)) {
        return cancelCompletedFilterRender(state, context);
      }

      return runFilterRenderSteps(preparedFacets, function (desiredFacet) {
        reconcileCompletedFacet(state, context, desiredFacet);
      }, function () {
        return isCurrentFilterRender(state, context);
      });
    }).then(function (completed) {
      if (!completed || !isCurrentFilterRender(state, context)) {
        return cancelCompletedFilterRender(state, context);
      }

      preserveFilterScroll(context.content, function () {
        context.currentFacets.forEach(function (facet, key) {
          var list;
          var searchInput;
          var hasSelected;

          if (context.desiredKeys.has(key)) return;
          facet.querySelectorAll('[data-kk-headless-filter-input]').forEach(function (input) {
            updateRenderedFilterInput(state, input, state.facetValueCounts, context.legacyValueCounts);
          });
          hasSelected = Boolean(facet.querySelector('[data-kk-headless-filter-input]:checked'));
          if (facet.contains(document.activeElement) || hasSelected) {
            facet.hidden = false;
            list = facet.querySelector('[data-kk-headless-filter-list]');
            if (list) syncFilterOptionListLimit(state, list);
            searchInput = facet.querySelector('[data-kk-headless-filter-search]');
            if (searchInput) handleFilterSearch({ target: searchInput });
            if (facet.contains(document.activeElement)) context.reorderDeferred = true;
            return;
          }
          facet.hidden = true;
        });
        context.content.querySelectorAll('[data-kk-headless-index-loading-text]').forEach(function (node) {
          var wrapper = node.closest('.kk-headless-index-loading__status');
          if (wrapper) wrapper.remove();
        });
        context.content.classList.remove('kk-headless-index-loading', 'kk-headless-partial-loading');
        context.content.removeAttribute('data-kk-headless-index-loading');
        context.content.setAttribute('data-faceted-filters', '');
        syncMobileStagedUiInContent(state, context.content);
      });

      state.pendingFilterCountUpdate = false;
      state.pendingFilterRender = false;
      state.pendingFilterReorder = context.reorderDeferred;
      state.incrementalFiltersReady = true;
      state.root.classList.toggle('kk-headless-collection--has-filters', preparedFacets.length > 0);
      updateFilterTrigger(state);
      hydrateVendorLogoSlots(state, context.content);
      context.content.removeAttribute('aria-busy');
      return true;
    }).catch(function (error) {
      if (
        state.filterRenderGeneration === context.renderGeneration &&
        context.content &&
        context.content.isConnected
      ) {
        context.content.removeAttribute('aria-busy');
        state.pendingFilterRender = true;
      }
      throw error;
    }).finally(function () {
      if (state.filterRenderPromise === promise) {
        state.filterRenderPromise = null;
      }
    });

    state.filterRenderPromise = promise;
    return promise;
  }

  function renderFilters(state) {
    var sidebar = getSidebar(state);
    var modalContainer = document.querySelector('[data-modal-container].modal--productgrid-filters');
    var modalContent = modalContainer && modalContainer.querySelector('[data-modal-content]');
    var modalOwnedContent = modalContent && modalContent.querySelector('[data-productgrid-filters-content]');
    var openModalFilterContent = getOpenHeadlessModalContent();
    var priceFilter = findPriceFilter(state.filters);
    var filters = getListFilters(state.filters);
    var filterHtml = '';
    var partialIndexLoading = state.partialRendered && !state.indexLoaded;
    var partialLoadingHtml = '';
    var innerHtml;
    var existingContent;
    var reconciled = false;

    state.filterRenderGeneration += 1;
    state.filterRenderPromise = null;

    if (state.filterListPointerCount > 0) {
      state.pendingFilterRender = true;
      return false;
    }

    state.pendingFilterRender = false;

    if (priceFilter) {
      filterHtml += renderPriceFilter(state, priceFilter);
    }

    filters.forEach(function (filter, filterIndex) {
      filterHtml += isDiscRangeFilter(filter) ? renderRangeFilter(state, filter) : renderListFilter(state, filter, filterIndex);
    });

    if (partialIndexLoading) {
      partialLoadingHtml = [
        '<div class="kk-headless-index-loading__status kk-headless-index-loading__status--partial" role="status" aria-live="polite" aria-atomic="true">',
        '<span class="kk-headless-index-loading__spinner" aria-hidden="true"></span>',
        '<span class="kk-headless-index-loading__text" data-kk-headless-index-loading-text>', escapeHtml(getIndexLoadingText(state, state.indexProducts.length)), '</span>',
        '</div>'
      ].join('');
    }

    innerHtml = [
      partialLoadingHtml,
      renderMobileStagedFilters(state),
      '<h2 class="productgrid--sidebar-title visually-hidden">', escapeHtml(t('filters_title_count_zero', 'Filters')), '</h2>',
      '<nav aria-label="Collection filters">',
      '<form class="faceted-filter__form kk-facets" data-kk-headless-facets>',
      filterHtml,
      '</form>',
      '</nav>',
      renderMobileApplyBar(state)
    ].join('');

    if (sidebar) {
      sidebar.querySelectorAll('[data-productgrid-filters-content]').forEach(function (node) {
        if (!node.hasAttribute('data-kk-headless-filters-content')) {
          node.remove();
        }
      });

      existingContent = modalOwnedContent || openModalFilterContent || sidebar.querySelector('[data-kk-headless-filters-content]');

      if (existingContent) {
        if (existingContent !== modalContent || modalOwnedContent) {
          existingContent.classList.remove('kk-headless-index-loading');
          existingContent.classList.toggle('kk-headless-partial-loading', partialIndexLoading);
          existingContent.removeAttribute('data-kk-headless-index-loading');
          existingContent.setAttribute('data-faceted-filters', '');
        }
        if (partialIndexLoading) {
          existingContent.setAttribute('aria-busy', 'true');
        } else {
          existingContent.removeAttribute('aria-busy');
        }
        if (state.incrementalFiltersReady && !partialIndexLoading) {
          reconciled = reconcileCompletedFilterContent(state, existingContent, innerHtml);
        }
        if (!reconciled) {
          existingContent.innerHTML = innerHtml;
        }
      } else {
        sidebar.insertAdjacentHTML('afterbegin', [
          '<div class="productgrid--sidebar-section', partialIndexLoading ? ' kk-headless-partial-loading' : '', '" data-productgrid-filters-content data-faceted-filters data-kk-headless-filters-content', partialIndexLoading ? ' aria-busy="true"' : '', '>',
          innerHtml,
          '</div>'
        ].join(''));
      }
    }

    if ((state.indexLoaded || state.partialRendered) && !openModalFilterContent) {
      refreshOpenFilterModal();
    }

    state.root.classList.toggle('kk-headless-collection--has-filters', Boolean(filterHtml));
    updateFilterTrigger(state);
    updateAllRangeTooltips(state);
    if (reconciled) updateFilterCountsInPlace(state);
    else {
      state.pendingFilterCountUpdate = false;
      syncAllFilterOptionLimits(state);
    }
    if (state.indexLoaded || state.partialRendered) state.incrementalFiltersReady = true;
    return true;
  }

  function renderFlightNumbers(product) {
    var parts = [
      ['nopeus', t('flight_numbers_speed', 'Speed')],
      ['liito', t('flight_numbers_glide', 'Glide')],
      ['vakaus', t('flight_numbers_turn', 'Turn')],
      ['feidi', t('flight_numbers_fade', 'Fade')]
    ];
    var items = parts.map(function (part) {
      var value = getMetafieldValues(product[part[0]])[0];

      return value ? '<div class="tooltip">' + escapeHtml(value) + '<span class="tooltiptext">' + escapeHtml(part[1]) + '</span></div>' : '';
    }).join('');

    return items ? '<div class="flight-numbers">' + items + '</div>' : '';
  }

  function stateCurrency(product) {
    var minPrice = product.priceRange && product.priceRange.minVariantPrice;

    return minPrice ? minPrice.currencyCode : config.currencyCode || 'EUR';
  }

  function renderProductPrice(product) {
    var minPrice = product.priceRange && product.priceRange.minVariantPrice;
    var maxPrice = product.priceRange && product.priceRange.maxVariantPrice;
    var compareMin = product.compareAtPriceRange && product.compareAtPriceRange.minVariantPrice;
    var price = minPrice ? toNumber(minPrice.amount, 0) : 0;
    var comparePrice = compareMin ? toNumber(compareMin.amount, 0) : 0;
    var currency = minPrice ? minPrice.currencyCode : stateCurrency(product);
    var varies = maxPrice && toNumber(maxPrice.amount, price) !== price;
    var priceHtml = varies ?
      t('price_range_html', '[[price]]').replace('[[price]]', formatMoney(price, currency)) :
      formatMoney(price, currency);
    var priceMarkup = varies ? priceHtml : '<span class="money">' + escapeHtml(priceHtml) + '</span>';
    var compareHtml = comparePrice > price ?
      '<div class="price--compare-at visible" data-price-compare-at><span class="visually-hidden">' + escapeHtml(t('original_price', 'Original price')) + '</span><span class="money">' + escapeHtml(formatMoney(comparePrice, currency)) + '</span></div>' :
      '<div class="price--compare-at visible" data-price-compare-at><span class="price--spacer"></span></div>';

    return [
      '<div class="productitem--price">',
      compareHtml,
      '<div class="price--main" data-price>',
      comparePrice > price ? '<span class="visually-hidden">' + escapeHtml(t('current_price', 'Current price')) + '</span>' : '',
      priceMarkup,
      '</div>',
      '</div>'
    ].join('');
  }

  function getProductImageDimension(image, dimension) {
    var fallbackKey = dimension === 'width' ? 'originalWidth' : 'originalHeight';

    return Math.max(0, Math.floor(toNumber(
      image && image[dimension],
      toNumber(image && image[fallbackKey], 0)
    )));
  }

  function getProductImageUrlAtWidth(url, width) {
    var source = String(url || '');
    var targetWidth = Math.max(1, Math.floor(toNumber(width, 1)));
    var hashIndex;
    var hash = '';

    if (!source) {
      return '';
    }

    if (/([?&])width=\d+/i.test(source)) {
      return source.replace(/([?&])width=\d+/i, '$1width=' + targetWidth);
    }

    hashIndex = source.indexOf('#');
    if (hashIndex !== -1) {
      hash = source.slice(hashIndex);
      source = source.slice(0, hashIndex);
    }

    return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=' + targetWidth + hash;
  }

  function getProductImageSrcset(image) {
    var naturalWidth = getProductImageDimension(image, 'width');
    var widths = PRODUCT_IMAGE_WIDTHS.filter(function (width) {
      return !naturalWidth || width <= naturalWidth;
    });
    var largestUsefulWidth;

    if (naturalWidth) {
      largestUsefulWidth = Math.min(naturalWidth, PRODUCT_IMAGE_WIDTHS[PRODUCT_IMAGE_WIDTHS.length - 1]);
      if (widths.indexOf(largestUsefulWidth) === -1) {
        widths.push(largestUsefulWidth);
      }
    }

    widths.sort(function (a, b) { return a - b; });

    return widths.map(function (width) {
      return getProductImageUrlAtWidth(image.url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function shouldRenderJudgeMePreviewBadge() {
    return config.productReviewsEnabled !== false && config.productGridStarRatingsEnabled !== false;
  }

  function getJudgeMeProductId(product) {
    var gidMatch;

    if (product.legacyId) {
      return String(product.legacyId);
    }

    gidMatch = String(product.id || '').match(/Product\/(\d+)$/);
    return gidMatch ? gidMatch[1] : '';
  }

  function renderJudgeMePreviewBadge(product) {
    var productId;
    var badgeHtml;
    var reviewCountMatch;

    if (!shouldRenderJudgeMePreviewBadge()) {
      return '';
    }

    badgeHtml = String(product.judgeMeBadgeHtml || '').trim();
    if (!badgeHtml) {
      return '';
    }

    reviewCountMatch = badgeHtml.match(/data-number-of-reviews\s*=\s*["'](\d+)["']/i);
    if (reviewCountMatch && parseInt(reviewCountMatch[1], 10) < 1) {
      return '';
    }

    productId = getJudgeMeProductId(product);
    if (!productId) {
      return '';
    }

    return [
      '<div class="productitem--ratings productitem--ratings--judgeme">',
      '<div style="" class="jdgm-widget jdgm-preview-badge" data-id="',
      escapeHtml(productId),
      '" data-template="collection" data-auto-install="false">',
      badgeHtml,
      '</div>',
      '</div>'
    ].join('');
  }

  function hasPendingJudgeMeBadges() {
    return Boolean(document.querySelector(JUDGE_ME_PENDING_BADGE_SELECTOR));
  }

  function stopJudgeMeRefresh() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }

    if (judgeMeDoneSetupListening) {
      document.removeEventListener('jdgm.doneSetup', handleJudgeMeDoneSetup);
      judgeMeDoneSetupListening = false;
    }

    judgeMeRefreshAttempts = 0;
  }

  function isJudgeMeScriptRequested(jdgm, path) {
    var requestedUrls = jdgm && jdgm.loadScript && jdgm.loadScript.requestedUrls;
    var normalizedPath = String(path || '').replace(/^\/+/, '');
    var flattenedPath = normalizedPath.replace(/\//g, '_');

    if (!Array.isArray(requestedUrls) || !normalizedPath) return false;

    return requestedUrls.some(function (url) {
      var cleanUrl = String(url || '').split(/[?#]/)[0];
      return cleanUrl.slice(-normalizedPath.length) === normalizedPath
        || cleanUrl.slice(-flattenedPath.length) === flattenedPath;
    });
  }

  function requestJudgeMeScript(jdgm, path, useFullCdnUrl) {
    var cdnHost;
    var source;

    if (!jdgm || typeof jdgm.loadScript !== 'function' || isJudgeMeScriptRequested(jdgm, path)) {
      return false;
    }

    cdnHost = String(jdgm.CDN_HOST || 'https://cdn.judge.me/').replace(/\/?$/, '/');
    source = useFullCdnUrl ? cdnHost + String(path || '') : path;

    try {
      jdgm.loadScript(source);
      return true;
    } catch (error) {
      return false;
    }
  }

  function ensureJudgeMeBadgeRuntime() {
    var jdgm = window.jdgm;
    var settings = window.jdgmSettings || {};

    if (!jdgm || typeof jdgm.loadScript !== 'function') return false;
    if (typeof jdgm.customizeBadges === 'function') return true;

    if (!settings.widget_load_with_code_splitting) {
      requestJudgeMeScript(jdgm, JUDGE_ME_LEGACY_SCRIPT_PATH, true);
      return true;
    }

    if (typeof jdgm.initializeWidgets === 'function') {
      requestJudgeMeScript(jdgm, JUDGE_ME_BADGE_SCRIPT_PATH, true);
      return true;
    }

    if (typeof jdgm.$ === 'function') {
      requestJudgeMeScript(jdgm, JUDGE_ME_COMMON_SCRIPT_PATH, false);
      return true;
    }

    requestJudgeMeScript(jdgm, JUDGE_ME_BASE_SCRIPT_PATH, false);
    return true;
  }

  function runJudgeMeRefresh() {
    var jdgm = window.jdgm;

    if (!hasPendingJudgeMeBadges()) {
      return true;
    }

    if (!jdgm || typeof jdgm.customizeBadges !== 'function') {
      ensureJudgeMeBadgeRuntime();
      return false;
    }

    try {
      jdgm.customizeBadges();
    } catch (error) {
      return false;
    }

    return !hasPendingJudgeMeBadges();
  }

  function scheduleJudgeMeRefresh() {
    judgeMeRefreshTimer = null;

    if (!shouldRenderJudgeMePreviewBadge() || runJudgeMeRefresh()) {
      stopJudgeMeRefresh();
      return;
    }

    judgeMeRefreshAttempts += 1;
    if (judgeMeRefreshAttempts >= JUDGE_ME_REFRESH_MAX_ATTEMPTS) {
      stopJudgeMeRefresh();
      return;
    }

    judgeMeRefreshTimer = window.setTimeout(scheduleJudgeMeRefresh, JUDGE_ME_REFRESH_DELAY);
  }

  function handleJudgeMeDoneSetup() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }
    scheduleJudgeMeRefresh();
  }

  function refreshJudgeMeWidgets() {
    stopJudgeMeRefresh();

    if (!shouldRenderJudgeMePreviewBadge() || !hasPendingJudgeMeBadges()) {
      return;
    }

    document.addEventListener('jdgm.doneSetup', handleJudgeMeDoneSetup);
    judgeMeDoneSetupListening = true;
    scheduleJudgeMeRefresh();
  }

  function stopJudgeMeAppendWatch() {
    if (judgeMeAppendObserver) {
      judgeMeAppendObserver.disconnect();
      judgeMeAppendObserver = null;
    }

    if (judgeMeAppendTimeout) {
      window.clearTimeout(judgeMeAppendTimeout);
      judgeMeAppendTimeout = null;
    }
  }

  function mutationAddsJudgeMeBadge(mutations) {
    var mutationIndex;
    var nodeIndex;
    var addedNodes;
    var node;

    for (mutationIndex = 0; mutationIndex < mutations.length; mutationIndex += 1) {
      addedNodes = mutations[mutationIndex].addedNodes;
      for (nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
        node = addedNodes[nodeIndex];
        if (
          node.nodeType === 1 &&
          (
            (node.matches && node.matches(JUDGE_ME_BADGE_SELECTOR)) ||
            (node.querySelector && node.querySelector(JUDGE_ME_BADGE_SELECTOR))
          )
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function watchNativeLoadMoreJudgeMeBadges(trigger) {
    var root = trigger && trigger.closest ? trigger.closest('[data-kk-headless-collection]') : null;
    var grid = root && root.querySelector('[data-product-grid]');

    stopJudgeMeAppendWatch();
    if (!grid || typeof MutationObserver === 'undefined') {
      return;
    }

    judgeMeAppendObserver = new MutationObserver(function (mutations) {
      if (!mutationAddsJudgeMeBadge(mutations)) {
        return;
      }

      stopJudgeMeAppendWatch();
      refreshJudgeMeWidgets();
    });
    judgeMeAppendObserver.observe(grid, { childList: true, subtree: true });
    judgeMeAppendTimeout = window.setTimeout(stopJudgeMeAppendWatch, JUDGE_ME_APPEND_WATCH_TIMEOUT);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && target.closest ? target.closest('[data-click-to-load]') : null;

    if (trigger && trigger.closest('[data-kk-headless-collection]')) {
      watchNativeLoadMoreJudgeMeBadges(trigger);
    }
  }, true);

  window.addEventListener('pagehide', stopJudgeMeRefresh);
  window.addEventListener('pagehide', stopJudgeMeAppendWatch);

  function renderProductImage(product, prioritize) {
    var image = product.featuredImage;
    var width;
    var height;
    var srcset;

    if (!image || !image.url) {
      return '';
    }

    width = getProductImageDimension(image, 'width');
    height = getProductImageDimension(image, 'height');
    srcset = getProductImageSrcset(image);

    return [
      '<img src="', escapeHtml(image.url), '"',
      srcset ? ' srcset="' + escapeHtml(srcset) + '"' : '',
      ' sizes="', escapeHtml(PRODUCT_IMAGE_SIZES), '"',
      width && height ? ' width="' + width + '" height="' + height + '"' : '',
      ' alt="', escapeHtml(image.altText || product.title || ''), '"',
      ' class="productitem--image-primary" loading="', prioritize ? 'eager' : 'lazy', '"',
      prioritize ? ' fetchpriority="high"' : '',
      ' decoding="async">'
    ].join('');
  }

  function renderProductCard(product, prioritizeImage) {
    var imageHtml = renderProductImage(product, prioritizeImage);
    var tags = product.tags || [];
    var isUsed = tags.indexOf('Used') > -1;
    var releaseTimestamp = toNumber(product.releaseTimestamp, 0);
    var isFutureRelease = releaseTimestamp && releaseTimestamp * 1000 > Date.now();
    var soldOut = !product.availableForSale;
    var productPrice = Math.round(getProductMinPrice(product) * 100);
    var productPriceMax = Math.round(getProductMaxPrice(product) * 100);
    var onSale = product.compareAtPriceRange &&
      product.compareAtPriceRange.minVariantPrice &&
      product.priceRange &&
      product.priceRange.minVariantPrice &&
      toNumber(product.compareAtPriceRange.minVariantPrice.amount, 0) > toNumber(product.priceRange.minVariantPrice.amount, 0);
    var badgeText = product.badgeText ? String(product.badgeText).trim() : '';
    var badgeColor = product.badgeColor ? String(product.badgeColor).trim() : '';
    var customBadgeHtml = badgeText && !isFutureRelease ?
      '<span class="productitem--custom-badge"' + (badgeColor ? ' style="--badge-bg: ' + escapeHtml(badgeColor) + '"' : '') + '>' + escapeHtml(badgeText) + '</span>' :
      '';
    var countdownTextFallbacks = getReleaseCountdownTextFallbacks();
    var countdownLabel = countdownTextFallbacks.label;
    var countdownDayOne = countdownTextFallbacks.dayOne;
    var countdownDayMany = countdownTextFallbacks.dayMany;
    var countdownOpenText = countdownTextFallbacks.openText;
    var launchCountdownHtml = isFutureRelease ?
      '<span class="productitem--launch-countdown" data-grid-launch-countdown data-target="' + escapeHtml(releaseTimestamp) + '" data-day-one="' + escapeHtml(countdownDayOne) + '" data-day-many="' + escapeHtml(countdownDayMany) + '" data-open-text="' + escapeHtml(countdownOpenText) + '" aria-label="' + escapeHtml(countdownLabel) + '">' +
        '<span class="productitem--launch-countdown-label">' + escapeHtml(countdownLabel) + '</span>' +
        '<span class="productitem--launch-countdown-time" data-grid-launch-time>--:--:--</span>' +
      '</span>' :
      '';

    return [
      '<li class="productgrid--item imagestyle--cropped-medium productitem--emphasis ', onSale && !isFutureRelease ? 'productitem--sale' : '', '" data-product-item data-product-price="', String(productPrice), '" data-product-price-max="', String(productPriceMax), '">',
      '<article class="productitem" data-product-item-content>',
      '<a class="productitem--image-link" href="', escapeHtml(buildProductUrl(product.handle)), '" tabindex="-1" data-product-page-link>',
      '<figure class="productitem--image" data-product-item-image>',
      imageHtml,
      isUsed ? '<span class="recycle-logo-container" aria-hidden="true"></span>' : '',
      customBadgeHtml,
      soldOut && !isFutureRelease ? '<span class="productitem--badge badge--soldout">' + escapeHtml(t('sold_out', 'Sold out')) + '</span>' : '',
      onSale && !soldOut && !isFutureRelease ? '<span class="productitem--badge badge--sale" data-badge-sales>' + escapeHtml(t('sale', 'Sale')) + '</span>' : '',
      launchCountdownHtml,
      '</figure>',
      '</a>',
      '<div class="productitem--info">',
      renderFlightNumbers(product),
      renderJudgeMePreviewBadge(product),
      renderProductPrice(product),
      product.vendor ? '<span class="productitem--vendor">' + escapeHtml(product.vendor) + '</span>' : '',
      '<h2 class="productitem--title 2"><a href="', escapeHtml(buildProductUrl(product.handle)), '" data-product-page-link>', escapeHtml(product.title), '</a></h2>',
      '</div>',
      '</article>',
      '</li>'
    ].join('');
  }

  function renderProducts(state, products, options) {
    var container = getResultsContainer(state);
    var list = container && container.querySelector('[data-product-grid]');
    var emptyHtml = '<div class="kk-headless-productgrid__empty">' + escapeHtml(t('collection_search_result_count_other', '0 results').replace('[[count]]', '0')) + '</div>';
    var html;
    var renderGeneration;
    var priorityAvailable;

    if (!collectionImagePriorityClaimed && document.querySelector('[data-kk-collection-lcp-image]')) {
      collectionImagePriorityClaimed = true;
    }

    priorityAvailable = !collectionImagePriorityClaimed;

    if (!container) {
      return;
    }

    state.resultsRenderGeneration = (state.resultsRenderGeneration || 0) + 1;
    renderGeneration = state.resultsRenderGeneration;

    if (!list) {
      list = document.createElement('ul');
      list.className = 'productgrid--items productgrid--no-spacing';
      list.setAttribute('data-product-grid', '');
      list.setAttribute('data-html', 'productgridItems');
      container.appendChild(list);
    }

    html = products.map(function (product) {
      var prioritizeImage = priorityAvailable && Boolean(product.featuredImage && product.featuredImage.url);

      if (prioritizeImage) {
        priorityAvailable = false;
        collectionImagePriorityClaimed = true;
      }

      return renderProductCard(product, prioritizeImage);
    }).join('');
    list.innerHTML = html || emptyHtml;
    container.classList.add('kk-headless-collection-results-active');
    container.setAttribute('data-product-count', String(state.loadedCount));
    renderLoadMore(state);
    renderActiveFilters(state);
    initGridLaunchCountdowns();
    refreshJudgeMeWidgets();
    document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
      detail: {
        resultCount: state.loadedCount
      }
    }));

    if (options && options.loadMore) {
      queueLoadMoreAfterRender(state, options.loadMore, renderGeneration);
    } else {
      state.loadMorePending = false;
      clearLoadMoreStatus(state);
    }
  }

  function renderLoadMore(state) {
    var container = getResultsContainer(state);
    var existing = container && container.querySelector('[data-kk-headless-load-more-wrapper]');
    var label = t('pagination_load', 'Load more products');

    if (existing) {
      existing.remove();
    }

    if (!container || state.visibleCount >= state.resultProducts.length) {
      return;
    }

    container.insertAdjacentHTML('beforeend', [
      '<div class="kk-collection-search__pagination" data-kk-headless-load-more-wrapper>',
      '<button class="button-primary kk-collection-search__load-more" type="button" data-kk-headless-load-more>', escapeHtml(label), '</button>',
      '</div>'
    ].join(''));
  }

  function getLoadMoreStatus(state, create) {
    var container = getResultsContainer(state);
    var status = container && container.querySelector('[data-kk-headless-load-more-status]');

    if (!status && create && container) {
      status = document.createElement('p');
      status.className = 'live-region visually-hidden';
      status.setAttribute('data-kk-headless-load-more-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      container.appendChild(status);
    }

    return status;
  }

  function clearLoadMoreStatus(state) {
    var status = getLoadMoreStatus(state, false);

    if (status) {
      status.textContent = '';
    }
  }

  function isLostFocus() {
    var active = document.activeElement;

    return !active ||
      active === document.body ||
      active === document.documentElement ||
      !active.isConnected;
  }

  function isAvailableFocusTarget(target) {
    var style;

    if (
      !target ||
      !target.isConnected ||
      target.hidden ||
      target.disabled ||
      target.getAttribute('aria-disabled') === 'true' ||
      target.closest('[hidden], [aria-hidden="true"], [inert]')
    ) {
      return false;
    }

    if (window.getComputedStyle) {
      style = window.getComputedStyle(target);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }

    return !target.getClientRects || target.getClientRects().length > 0;
  }

  function getFirstNewProductLink(container, previousVisibleCount) {
    var cards = container.querySelectorAll('[data-product-grid] [data-product-item]');
    var card = cards[previousVisibleCount];

    return card && card.querySelector('.productitem--title a[href], [data-product-page-link][href]:not([tabindex="-1"])');
  }

  function queueLoadMoreAfterRender(state, options, renderGeneration) {
    var container = getResultsContainer(state);
    var status = getLoadMoreStatus(state, true);
    var visibleCount = Math.min(state.visibleCount, state.resultProducts.length);
    var message = t('headless_products_loaded', 'Products loaded: [[count]].').replace('[[count]]', String(visibleCount));
    var schedule = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 0);
    };

    if (status) {
      // Clearing first ensures the same count is announced after a filter reset.
      status.textContent = '';
    }

    schedule(function () {
      var focusTarget;

      if (
        state.resultsRenderGeneration !== renderGeneration ||
        !container ||
        !container.isConnected
      ) {
        return;
      }

      state.loadMorePending = false;

      if (status && status.isConnected) {
        status.textContent = message;
      }

      if (!options.focusOwned || !isLostFocus()) {
        return;
      }

      focusTarget = container.querySelector('[data-kk-headless-load-more]');
      if (!focusTarget) {
        focusTarget = getFirstNewProductLink(container, options.previousVisibleCount);
      }

      if (isAvailableFocusTarget(focusTarget) && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    });
  }

  function getActiveCount(state) {
    var count = state.selected.size + state.rangeSelections.size;

    if (state.priceMin !== null || state.priceMax !== null) {
      count += 1;
    }

    return count;
  }

  function renderActiveFilters(state) {
    var container = getResultsContainer(state);
    var existing = container && container.querySelector('.kk-headless-active-filters');
    var items = [];
    var before;
    var currency = state.currencyCode || config.currencyCode || 'EUR';

    if (!container) {
      return;
    }

    if (existing) {
      existing.remove();
    }

    var grouped = new Map();
    state.rangeSelections.forEach(function (selection, facetKey) {
      var filterLabel = selection.filterLabel || getRangeSelectionFilterLabel(facetKey);
      var rangeUnit = getRangeFacetUnit(facetKey);
      var valueLabel = selection.min === selection.max ?
        String(selection.min) : selection.min + ' - ' + selection.max;
      var labelText;

      if (rangeUnit) valueLabel += ' ' + rangeUnit;
      labelText = filterLabel ? filterLabel + ': ' + valueLabel : valueLabel;
      items.push(
        '<li class="filter-item--grid">' +
        '<a href="#" data-kk-headless-remove-range-facet="' + escapeHtml(facetKey) + '">' +
        '<span class="filter-text">' + escapeHtml(labelText) + '</span>' +
        '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
        '</a></li>'
      );
    });

    state.selected.forEach(function (item, key) {
      var facetKey = inputFacetKey(item.input);
      if (state.rangeSelections.has(facetKey)) return;
      if (!grouped.has(facetKey)) {
        grouped.set(facetKey, []);
      }
      grouped.get(facetKey).push({ key: key, item: item });
    });

    grouped.forEach(function (entries, facetKey) {
      if (isRangeFacetKey(facetKey) && entries.length > 0) {
        var values = entries.map(function (e) { return toNumber(e.item.label, NaN); }).filter(function (n) { return !isNaN(n); });
        var minVal = values.length ? Math.min.apply(Math, values) : '';
        var maxVal = values.length ? Math.max.apply(Math, values) : '';
        var filterLabel = entries[0].item.filterLabel || '';
        var rangeUnit = getRangeFacetUnit(facetKey);
        var labelText;

        if (minVal === maxVal) {
          labelText = filterLabel ? filterLabel + ': ' + minVal : String(minVal);
        } else {
          labelText = filterLabel ? filterLabel + ': ' + minVal + ' - ' + maxVal : minVal + ' - ' + maxVal;
        }
        if (rangeUnit) labelText += ' ' + rangeUnit;

        items.push(
          '<li class="filter-item--grid">' +
          '<a href="#" data-kk-headless-remove-range-facet="' + escapeHtml(facetKey) + '">' +
          '<span class="filter-text">' + escapeHtml(labelText) + '</span>' +
          '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
          '</a></li>'
        );
      } else {
        entries.forEach(function (entry) {
          items.push(
            '<li class="filter-item--grid">' +
            '<a href="#" data-kk-headless-remove-filter="' + escapeHtml(entry.key) + '">' +
            '<span class="filter-text">' + escapeHtml(entry.item.filterLabel ? entry.item.filterLabel + ': ' + entry.item.label : entry.item.label) + '</span>' +
            '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
            '</a></li>'
          );
        });
      }
    });

    if (state.priceMin !== null || state.priceMax !== null) {
      items.push(
        '<li class="filter-item--grid">' +
        '<a href="#" data-kk-headless-remove-price>' +
        '<span class="filter-text">' + escapeHtml(formatMoney(state.priceMin === null ? (state.priceBoundMin || 0) : state.priceMin, currency) + ' - ' + formatMoney(state.priceMax === null ? state.priceBoundMax : state.priceMax, currency)) + '</span>' +
        '<span class="filter-icon--remove" aria-hidden="true">x</span>' +
        '</a></li>'
      );
    }

    if (!items.length) {
      updateFilterTrigger(state);
      return;
    }

    items.push(
      '<li class="filter-item--grid-simple">' +
      '<a href="#" data-kk-headless-clear-all>' + escapeHtml(t('filters_remove_all', 'Remove all filters')) + '</a>' +
      '</li>'
    );

    before = container.querySelector('.productgrid--utils') || container.querySelector('[data-product-grid]');
    container.insertBefore(
      document.createRange().createContextualFragment(
        '<div class="productgrid--filters kk-headless-active-filters">' +
        '<ul class="filter-group--grid">' + items.join('') + '</ul>' +
        '</div>'
      ),
      before || null
    );
    updateFilterTrigger(state);
  }

  function updateFilterTrigger(state) {
    var count = getActiveCount(state);
    var trigger = state.root.querySelector('[data-productgrid-trigger-filters]');
    var text = trigger && trigger.querySelector('.utils-filter-text');
    var label = t('filters_title_count_zero', 'Filters').replace(/\d+/, count);

    if (!trigger) {
      return;
    }

    trigger.hidden = !(state.filters && state.filters.length);
    trigger.setAttribute('aria-label', label);

    if (text) {
      text.textContent = label;
    }
  }

  function setSearchInput(state) {
    var input = state.root.querySelector('[data-kk-collection-search-input]');
    var clear = state.root.querySelector('[data-kk-collection-search-clear]');

    if (input) {
      input.value = state.query || '';
    }

    if (clear) {
      clear.hidden = !state.query;
    }
  }

  function watchSidebar(state) {
    var sidebar = getSidebar(state);
    var ourSelector = '[data-kk-headless-filters-content], [data-kk-headless-index-loading]';
    var rerenderTimer = null;
    var observer;

    if (!sidebar || state.sidebarObserver) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var lostOurs = false;

      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches && node.matches(ourSelector)) {
            lostOurs = true;
          }
        });
      });

      if (!lostOurs) {
        return;
      }

      if (sidebar.querySelector(ourSelector)) {
        return;
      }

      // Superstore moves the exact sidebar node into its mobile modal. That
      // move is not a removal: the Modal controller still owns the element
      // and must receive the same node back when it closes.
      if (document.querySelector('.modal--productgrid-filters [data-modal-content] [data-productgrid-filters-content]')) {
        return;
      }

      if (state.sidebarGuardCount === undefined) {
        state.sidebarGuardCount = 0;
      }

      state.sidebarGuardCount += 1;

      if (state.sidebarGuardCount === 1) {
        console.warn('[KiekkoKingi] Headless filter content removed by external code. Restoring.', new Error('sidebar-guard'));
      }

      if (state.sidebarGuardCount > 5) {
        console.warn('[KiekkoKingi] Headless filter restoration aborted after repeated removals.');
        observer.disconnect();
        return;
      }

      window.clearTimeout(rerenderTimer);
      rerenderTimer = window.setTimeout(function () {
        state.sidebarRerenderTimer = null;
        if (state.destroyed || (state.root && !state.root.isConnected)) return;
        if (state.indexLoaded && state.filters && state.filters.length) {
          renderCompletedFiltersInSlices(state).catch(function (error) {
            console.warn('[KiekkoKingi] Headless filter restoration failed:', error);
          });
        } else if (state.indexProducts && state.indexProducts.length) {
          renderIndexLoading(state, state.indexProducts.length);
        } else {
          renderIndexLoading(state, 0);
        }
      }, 50);
      state.sidebarRerenderTimer = rerenderTimer;
    });

    observer.observe(sidebar, { childList: true });
    state.sidebarObserver = observer;
  }

  function fetchLiquidIndex(state, requestGeneration, signal, shouldContinue) {
    var products = [];
    var firstPayload = null;
    var estimatedPages = Math.max(1, Math.floor(toNumber(state.indexPages, 0)) || Math.ceil(
      Math.max(0, toNumber(state.indexItems, 0)) /
      Math.max(1, toNumber(state.indexPageSize, INDEX_PAGE_SIZE))
    ));
    var expectedItems = Math.max(0, Math.floor(toNumber(state.indexItems, 0)));
    var warmupPages = [];
    var remainingPages = [];
    var firstPagePromise;
    var warmupPromise;
    var pageNumber;

    resetIncrementalIndexData(state);
    state.indexAccumulatorReady = true;
    state.indexProducts = products;

    function fetchAndAppendPage(page, retriesLeft) {
      return fetchLiquidPage(state, page, retriesLeft, signal, shouldContinue).then(function (payload) {
        if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
          throw createIndexAbortError();
        }

        if (page === 1) firstPayload = payload;
        return appendLiquidProducts(state, products, payload, requestGeneration, signal, shouldContinue).then(function (completed) {
          var abortError;

          if (!completed && ((signal && signal.aborted) || (shouldContinue && !shouldContinue()))) {
            abortError = new Error('Index processing aborted');
            abortError.name = 'AbortError';
            throw abortError;
          }
        });
      });
    }

    function fetchPages(pages) {
      if (!pages.length) {
        return Promise.resolve();
      }

      return runWithConcurrency(pages, INDEX_PARALLEL_BATCH, function (page) {
        return fetchAndAppendPage(page).catch(function (error) {
          if (error && error.name === 'AbortError') {
            throw error;
          }

          console.warn('[KiekkoKingi] Index page ' + page + ' failed permanently after retries:', error);
          throw error;
        });
      });
    }

    // Page 1 is authoritative for the final page count, but Shopify preview can
    // take several seconds to finish it. Start only the rest of the first
    // four-request batch speculatively so a faster page can publish real filter
    // progress while page 1 is still in flight. These warmups do not retry until
    // page 1 confirms that the page still exists; this preserves the stale-HTML
    // overfetch guard without serialising the visible loading state behind page 1.
    for (pageNumber = 2; pageNumber <= Math.min(estimatedPages, INDEX_PARALLEL_BATCH); pageNumber++) {
      warmupPages.push(pageNumber);
    }

    firstPagePromise = fetchAndAppendPage(1);
    warmupPromise = Promise.all(warmupPages.map(function (page) {
      return fetchAndAppendPage(page, 0).then(function () {
        return { page: page, completed: true, error: null };
      }).catch(function (error) {
        return { page: page, completed: false, error: error };
      });
    }));

    return firstPagePromise.then(function () {
      var authoritativePages = Math.max(1, Math.floor(toNumber(firstPayload && firstPayload.pages, estimatedPages)));

      if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
        throw createIndexAbortError();
      }

      expectedItems = Math.max(0, Math.floor(toNumber(firstPayload && firstPayload.items, expectedItems)));
      state.indexItems = expectedItems;
      state.indexPages = authoritativePages;

      return warmupPromise.then(function (warmupResults) {
        var completedWarmups = Object.create(null);

        warmupResults.forEach(function (result) {
          if (result.error && result.error.name === 'AbortError') {
            throw result.error;
          }
          if (result.completed && result.page <= authoritativePages) {
            completedWarmups[result.page] = true;
          }
        });

        for (pageNumber = 2; pageNumber <= authoritativePages; pageNumber++) {
          if (!completedWarmups[pageNumber]) remainingPages.push(pageNumber);
        }

        return fetchPages(remainingPages);
      });
    }).then(function () {
      var canonicalProducts;
      var incrementalPrepared;

      if ((signal && signal.aborted) || (shouldContinue && !shouldContinue())) {
        throw createIndexAbortError();
      }

      canonicalProducts = canonicalizeIndexProducts(products, expectedItems);
      incrementalPrepared = canonicalProducts.length === products.length &&
        state.indexProductHandles.size === canonicalProducts.length;

      state.indexProducts = canonicalProducts;
      return {
        expectedItems: expectedItems,
        incrementalPrepared: incrementalPrepared,
        products: canonicalProducts
      };
    });
  }

  function loadIndexWithCacheHedge(state, requestGeneration) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var cachePending = true;
      var networkStarted = false;
      var networkError = null;
      var networkController = typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var hedgeTimer = window.setTimeout(startNetwork, INDEX_CACHE_HEDGE_DELAY);

      state.indexAbortController = networkController;

      function isCurrentRequest() {
        return !state.destroyed &&
          requestGeneration === state.indexGeneration &&
          (!state.root || state.root.isConnected);
      }

      function finish(result) {
        if (settled) return;

        if (!isCurrentRequest()) {
          settled = true;
          window.clearTimeout(hedgeTimer);
          if (networkController) networkController.abort();
          if (state.indexAbortController === networkController) state.indexAbortController = null;
          resolve({ expectedItems: 0, incrementalPrepared: false, loadedFromCache: false, products: [] });
          return;
        }

        settled = true;
        window.clearTimeout(hedgeTimer);
        if (state.indexAbortController === networkController) state.indexAbortController = null;

        if (result.loadedFromCache) {
          abortBootstrappedIndex(state);

          window.clearTimeout(state.partialRenderTimer);
          state.partialRenderTimer = null;
          state.indexAccumulatorReady = false;

          if (networkStarted && networkController) {
            networkController.abort();
          }
        }

        resolve(result);
      }

      function failNetwork(error) {
        if (settled) return;
        if ((error && error.name === 'AbortError') || state.destroyed || requestGeneration !== state.indexGeneration) {
          settled = true;
          window.clearTimeout(hedgeTimer);
          if (state.indexAbortController === networkController) state.indexAbortController = null;
          resolve({ expectedItems: 0, incrementalPrepared: false, loadedFromCache: false, products: [] });
          return;
        }
        if (state.indexAbortController === networkController) state.indexAbortController = null;
        networkError = error;

        if (!cachePending) {
          settled = true;
          reject(error);
        }
      }

      function startNetwork() {
        if (networkStarted || settled) return;
        if (state.destroyed || requestGeneration !== state.indexGeneration || (state.root && !state.root.isConnected)) {
          settled = true;
          window.clearTimeout(hedgeTimer);
          if (state.indexAbortController === networkController) state.indexAbortController = null;
          resolve({ expectedItems: 0, incrementalPrepared: false, loadedFromCache: false, products: [] });
          return;
        }
        networkStarted = true;

        fetchLiquidIndex(
          state,
          requestGeneration,
          networkController ? networkController.signal : undefined,
          function () {
            return !settled && isCurrentRequest();
          }
        ).then(function (result) {
          result.loadedFromCache = false;
          finish(result);
        }).catch(failNetwork);
      }

      readIndexCacheWithTimeout(state).then(function (cached) {
        cachePending = false;

        if (settled) return;

        if (!isCurrentRequest()) {
          finish({ expectedItems: 0, incrementalPrepared: false, loadedFromCache: false, products: [] });
          return;
        }

        if (cached) {
          var canonicalCached = canonicalizeIndexProducts(cached, 0);

          finish({
            expectedItems: canonicalCached.length,
            incrementalPrepared: false,
            loadedFromCache: true,
            products: canonicalCached
          });
          return;
        }

        if (networkError) {
          settled = true;
          reject(networkError);
          return;
        }

        startNetwork();
      }).catch(function () {
        cachePending = false;
        startNetwork();
      });
    });
  }

  function ensureIndex(state) {
    var nativeIndexSort = getNativeIndexSort(state.sortBy);
    var requestedIndexSort = nativeIndexSort || state.indexSortBy || '';
    var requestGeneration;
    var expectedItems = 0;
    var incrementalPrepared = false;
    var loadedFromCache = false;

    function commitIndexProducts(products) {
      window.clearTimeout(state.partialRenderTimer);
      state.indexProducts = products;
      state.indexAccumulatorReady = true;
      if (!incrementalPrepared) rebuildVendorLogoAliases(state);
      state.indexLoaded = true;
      state.partialRendered = false;
      state.partialRenderTimer = null;
      state.root.classList.remove('kk-headless-collection--partial-index');
      hydrateCurrentVendorLogoSlots(state);

      if (!loadedFromCache) {
        scheduleIndexCacheWrite(state, products);
      }

      return products;
    }

    if (state.destroyed || (state.root && !state.root.isConnected)) {
      return Promise.resolve([]);
    }

    if (nativeIndexSort && state.indexSortBy !== nativeIndexSort && (state.indexLoaded || state.partialRendered || state.indexPromise)) {
      resetIndex(state, true);
    }

    state.indexSortBy = requestedIndexSort;

    if (state.indexLoaded) {
      return Promise.resolve(state.indexProducts);
    }

    if (state.indexPromise) {
      return state.indexPromise;
    }

    renderIndexLoading(state, 0);
    requestGeneration = state.indexGeneration;

    state.indexPromise = loadIndexWithCacheHedge(state, requestGeneration).then(function (result) {
      expectedItems = result.expectedItems;
      incrementalPrepared = result.incrementalPrepared;
      loadedFromCache = result.loadedFromCache;
      return result.products;
    }).then(function (products) {
      if (state.destroyed || (state.root && !state.root.isConnected)) {
        return [];
      }

      if (requestGeneration !== state.indexGeneration) {
        if (state.destroyed || (state.root && !state.root.isConnected)) return [];
        return ensureIndex(state);
      }

      if (!loadedFromCache && expectedItems && products.length !== expectedItems) {
        var countDrift = Math.abs(expectedItems - products.length);
        var allowedCountDrift = Math.max(25, Math.ceil(expectedItems * 0.01));

        // Collection membership can change while Shopify serves the paginated
        // index (for example when an individual used disc sells). Every page
        // has still completed successfully, so accept a small count drift
        // instead of discarding the whole index and leaving filters unusable.
        // A larger difference still indicates a genuinely incomplete page set.
        if (countDrift > allowedCountDrift) {
          throw new Error('Index incomplete: expected ' + expectedItems + ' products, received ' + products.length);
        }

        state.indexItems = products.length;
      }

      if (!incrementalPrepared) {
        window.clearTimeout(state.partialRenderTimer);
        state.partialRenderTimer = null;
        state.indexAccumulatorReady = false;
        return rebuildIncrementalIndexData(state, products, requestGeneration).then(function (completed) {
          return completed ? commitIndexProducts(products) : [];
        });
      }

      return commitIndexProducts(products);
    }).catch(function (error) {
      if (state.destroyed || (error && error.name === 'AbortError')) {
        return [];
      }
      console.warn('[KiekkoKingi] Liquid index load failed:', error);
      if (requestGeneration === state.indexGeneration) {
        state.indexPromise = null;
      }
      throw error;
    });

    return state.indexPromise;
  }

  function applyCollection(state, options) {
    var render = !options || options.render !== false;
    var showProcessing = render || state.indexLoaded;
    var workGeneration = state.filterWorkGeneration + 1;

    state.filterWorkGeneration = workGeneration;
    state.activeApplyGeneration = workGeneration;

    if (showProcessing) {
      setProcessing(state, true);
    }

    return ensureIndex(state).then(function () {
      if (
        state.destroyed ||
        workGeneration !== state.filterWorkGeneration ||
        (state.root && !state.root.isConnected)
      ) {
        return null;
      }

      if (!state.indexLoaded) {
        throw new Error('Cannot apply collection filters before the complete index is loaded');
      }

      return prepareContextualFilterSnapshot(state, workGeneration);
    }).then(function (contextualSnapshot) {
      var indexOrderMatches;
      var hasActiveConstraints;
      var products;

      if (
        state.destroyed ||
        workGeneration !== state.filterWorkGeneration ||
        (state.root && !state.root.isConnected)
      ) return;

      buildFilters(state, { contextualSnapshot: contextualSnapshot });
      hasActiveConstraints = hasActiveFilterConstraints(state);
      indexOrderMatches = !state.sortBy || state.sortBy === state.indexSortBy;
      products = !hasActiveConstraints && indexOrderMatches ?
        state.indexProducts : sortProducts(state, state.contextualResultProducts || filterProducts(state));
      state.resultProducts = products;
      state.loadedCount = products.length;
      if (!state.visibleCount || state.visibleCount < state.perPage) {
        state.visibleCount = state.perPage;
      }

      return renderCompletedFiltersInSlices(state, { workGeneration: workGeneration }).then(function () {
        if (
          state.destroyed ||
          workGeneration !== state.filterWorkGeneration ||
          (state.root && !state.root.isConnected)
        ) return;

        setSearchInput(state);

        if (render) {
          renderProducts(state, products.slice(0, state.visibleCount));
          writeUrlState(state);
        } else {
          renderActiveFilters(state);
        }
      });
    }).catch(function (error) {
      console.warn('[KiekkoKingi] Liquid index load failed:', error);
      state.root.classList.add('kk-headless-collection--error');
    }).finally(function () {
      if (showProcessing && state.activeApplyGeneration === workGeneration) {
        setProcessing(state, false);
      }
    });
  }

  function primeIndex(state) {
    if (!state || state.indexLoaded || state.indexPromise) {
      return;
    }

    applyCollection(state, { render: false });
  }

  function updateSelectedFromInput(state, input) {
    var parsed = parseFilterInput(input.value);
    var key = stableFilterKey(parsed);

    if (input.checked) {
      state.selected.set(key, {
        input: parsed,
        label: input.getAttribute('data-kk-headless-value-label') || '',
        filterLabel: input.getAttribute('data-kk-headless-filter-label') || ''
      });
    } else {
      state.selected.delete(key);
    }
  }

  function updateRangeTooltips(range) {
    if (!range) return;
    var slider = range.querySelector('[data-kk-headless-price-track]') || range.querySelector('.kk-range-filter__slider');
    if (!slider) return;

    var prefix = slider.getAttribute('data-kk-tooltip-prefix') || '';
    var suffix = slider.getAttribute('data-kk-tooltip-suffix') || '';
    var lower = slider.querySelector('[data-kk-headless-price-lower], [data-kk-headless-range-lower]');
    var upper = slider.querySelector('[data-kk-headless-price-upper], [data-kk-headless-range-upper]');
    var tooltipLower = slider.querySelector('[data-kk-range-tooltip="lower"]');
    var tooltipUpper = slider.querySelector('[data-kk-range-tooltip="upper"]');

    function update(input, tooltip) {
      if (!input || !tooltip) return;
      var inputMin = toNumber(input.min, 0);
      var inputMax = toNumber(input.max, 100);
      var value = toNumber(input.value, inputMin);
      var range = inputMax - inputMin;
      var percent = range > 0 ? ((value - inputMin) / range * 100) : 0;
      var thumbHalf = 13;
      var offset = thumbHalf * (1 - percent / 50);
      tooltip.style.left = 'calc(' + percent + '% + ' + offset.toFixed(2) + 'px)';
      tooltip.textContent = (prefix ? prefix + value : String(value)) + suffix;
    }

    update(lower, tooltipLower);
    update(upper, tooltipUpper);
  }

  function updateAllRangeTooltips(state) {
    if (!state || !state.root) return;
    state.root.querySelectorAll('[data-kk-headless-price-range], [data-kk-headless-native-range]').forEach(updateRangeTooltips);
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    if (modalContent) {
      modalContent.querySelectorAll('[data-kk-headless-price-range], [data-kk-headless-native-range]').forEach(updateRangeTooltips);
    }
  }

  function applyHeadlessRange(range, source) {
    var state = getState(range);
    var minInput = range.querySelector('[data-kk-headless-range-min-input]');
    var maxInput = range.querySelector('[data-kk-headless-range-max-input]');
    var lower = range.querySelector('[data-kk-headless-range-lower]');
    var upper = range.querySelector('[data-kk-headless-range-upper]');
    var min = toNumber(range.getAttribute('data-kk-headless-range-min'), 0);
    var max = toNumber(range.getAttribute('data-kk-headless-range-max'), 0);
    var facetKey = range.getAttribute('data-kk-headless-range-facet-key') || '';
    var activeMin;
    var activeMax;
    var selectedKeys = [];
    var filterLabel = '';
    var firstOption;
    var selection;

    if (!state) {
      return;
    }

    if (source === lower || source === minInput) {
      activeMin = toNumber(source.value, min);
      activeMax = toNumber((maxInput && maxInput.value) || (upper && upper.value), max);
    } else if (source === upper || source === maxInput) {
      activeMin = toNumber((minInput && minInput.value) || (lower && lower.value), min);
      activeMax = toNumber(source.value, max);
    } else {
      activeMin = toNumber(minInput && minInput.value, min);
      activeMax = toNumber(maxInput && maxInput.value, max);
    }

    activeMin = Math.max(min, Math.min(activeMin, max));
    activeMax = Math.min(max, Math.max(activeMax, activeMin));

    if (minInput) minInput.value = activeMin;
    if (maxInput) maxInput.value = activeMax;
    if (lower) lower.value = activeMin;
    if (upper) upper.value = activeMax;

    // The contextual DOM contains only values that are possible with the
    // other active facets. Clear the whole facet from state first so values
    // retained outside a temporarily narrowed context cannot survive a new
    // explicit range selection.
    state.selected.forEach(function (item, key) {
      if (inputFacetKey(item.input) === facetKey) selectedKeys.push(key);
    });
    selectedKeys.forEach(function (key) {
      state.selected.delete(key);
    });

    firstOption = range.querySelector('[data-kk-headless-range-option]');
    filterLabel = firstOption ? firstOption.getAttribute('data-kk-headless-filter-label') || '' : '';

    if (activeMin === min && activeMax === max) {
      state.rangeSelections.delete(facetKey);
    } else {
      selection = normalizeRangeSelection(
        facetKey,
        activeMin,
        activeMax,
        filterLabel || getRangeSelectionFilterLabel(facetKey)
      );
      if (selection) state.rangeSelections.set(facetKey, selection);
      else state.rangeSelections.delete(facetKey);
    }

    updateRangeTooltips(range);
  }

  function applyPriceRange(range, source) {
    var state = getState(range);
    var minInput = range.querySelector('[data-kk-headless-price-min]');
    var maxInput = range.querySelector('[data-kk-headless-price-max]');
    var lower = range.querySelector('[data-kk-headless-price-lower]');
    var upper = range.querySelector('[data-kk-headless-price-upper]');
    var min = toNumber(range.getAttribute('data-kk-headless-range-min'), state ? state.priceBoundMin : 0);
    var max = toNumber(range.getAttribute('data-kk-headless-range-max'), state ? state.priceBoundMax : 0);
    var minValue;
    var maxValue;

    if (!state) {
      return;
    }

    if (source === lower || source === minInput) {
      minValue = toNumber(source.value, min);
      maxValue = toNumber((maxInput && maxInput.value) || (upper && upper.value), max);
    } else if (source === upper || source === maxInput) {
      minValue = toNumber((minInput && minInput.value) || (lower && lower.value), min);
      maxValue = toNumber(source.value, max);
    } else {
      minValue = toNumber(minInput && minInput.value, min);
      maxValue = toNumber(maxInput && maxInput.value, max);
    }

    minValue = Math.max(min, Math.min(minValue, max));
    maxValue = Math.min(max, Math.max(maxValue, minValue));

    if (minInput) minInput.value = minValue;
    if (maxInput) maxInput.value = maxValue;
    if (lower) lower.value = Math.floor(minValue);
    if (upper) upper.value = Math.ceil(maxValue);

    state.priceMin = minValue <= min ?
      (!state.indexLoaded && (source === lower || source === minInput) ? minValue : null) : minValue;
    state.priceMax = maxValue >= max ?
      (!state.indexLoaded && (source === upper || source === maxInput) ? maxValue : null) : maxValue;

    updateRangeTooltips(range);
  }

  function isMobileFilterModal(target) {
    return Boolean(target && target.closest && target.closest('.modal--productgrid-filters'));
  }

  function syncMobileModalControlsFromState(state, options) {
    var content = getOpenHeadlessModalContent();
    var preserveActiveRangeDraft = Boolean(options && options.preserveActiveRangeDraft);

    if (!content) return;

    content.querySelectorAll('[data-kk-headless-filter-input]').forEach(function (input) {
      var checked = state.selected.has(stableFilterKey(parseFilterInput(input.value)));
      var item = input.closest('.kk-facet__item');

      input.checked = checked;
      if (item) {
        item.classList.toggle('filter-item--active', checked);
        item.classList.toggle('filter-item--inactive', !checked);
      }
    });

    content.querySelectorAll('[data-kk-headless-native-range]').forEach(function (range) {
      var min = toNumber(range.getAttribute('data-kk-headless-range-min'), 0);
      var max = toNumber(range.getAttribute('data-kk-headless-range-max'), 0);
      var facetKey = range.getAttribute('data-kk-headless-range-facet-key') || '';
      var preserveValues = preserveActiveRangeDraft && range.contains(document.activeElement);
      var minInput = range.querySelector('[data-kk-headless-range-min-input]');
      var maxInput = range.querySelector('[data-kk-headless-range-max-input]');
      var lower = range.querySelector('[data-kk-headless-range-lower]');
      var upper = range.querySelector('[data-kk-headless-range-upper]');
      var active = getActiveDiscRangeBounds(state, facetKey, min, max);
      var activeMin = active.min;
      var activeMax = active.max;

      if (!preserveValues) {
        if (minInput) minInput.value = activeMin;
        if (maxInput) maxInput.value = activeMax;
        if (lower) lower.value = activeMin;
        if (upper) upper.value = activeMax;
      }
      updateRangeTooltips(range);
    });

    content.querySelectorAll('[data-kk-headless-price-range]').forEach(function (range) {
      var min = toNumber(range.getAttribute('data-kk-headless-range-min'), state.priceBoundMin || 0);
      var max = toNumber(range.getAttribute('data-kk-headless-range-max'), state.priceBoundMax || 0);
      var minValue = state.priceMin === null ? min : state.priceMin;
      var maxValue = state.priceMax === null ? max : state.priceMax;
      var preserveValues = preserveActiveRangeDraft && range.contains(document.activeElement);
      var minInput = range.querySelector('[data-kk-headless-price-min]');
      var maxInput = range.querySelector('[data-kk-headless-price-max]');
      var lower = range.querySelector('[data-kk-headless-price-lower]');
      var upper = range.querySelector('[data-kk-headless-price-upper]');

      if (!preserveValues) {
        if (minInput) minInput.value = minValue;
        if (maxInput) maxInput.value = maxValue;
        if (lower) lower.value = Math.floor(minValue);
        if (upper) upper.value = Math.ceil(maxValue);
      }
      updateRangeTooltips(range);
    });
  }

  function queueMobileModalPreview(state) {
    var workGeneration = state.filterWorkGeneration + 1;
    var previewGeneration = state.modalPreviewGeneration + 1;
    var refreshSequence = 0;
    var pendingIndexPromise = state.indexLoaded ? null : ensureIndex(state);

    state.filterWorkGeneration = workGeneration;
    state.modalPreviewGeneration = previewGeneration;
    state.modalDirty = true;
    updateMobileModalStagedUi(state);

    function refreshPreview() {
      var refreshGeneration = refreshSequence + 1;
      var indexWasLoaded = state.indexLoaded;
      var renderPromise;

      refreshSequence = refreshGeneration;
      prepareContextualFilterSnapshot(state, workGeneration, function () {
        return previewGeneration === state.modalPreviewGeneration &&
          refreshGeneration === refreshSequence &&
          state.indexLoaded === indexWasLoaded;
      }).then(function (contextualSnapshot) {
        if (
          state.destroyed ||
          workGeneration !== state.filterWorkGeneration ||
          previewGeneration !== state.modalPreviewGeneration ||
          refreshGeneration !== refreshSequence ||
          (!indexWasLoaded && state.indexLoaded) ||
          (state.root && !state.root.isConnected)
        ) return;

        buildFilters(state, { contextualSnapshot: contextualSnapshot });
        if (state.indexLoaded) {
          state.partialRendered = true;
          renderPromise = renderCompletedFiltersInSlices(state, { workGeneration: workGeneration });
        } else if (state.partialRendered) {
          renderPromise = Promise.resolve(updateFilterCountsInPlace(state));
        } else {
          state.partialRendered = true;
          renderFilters(state);
          renderPromise = Promise.resolve(true);
        }

        return renderPromise.then(function (completed) {
          if (!completed) return;
          if (
            state.destroyed ||
            workGeneration !== state.filterWorkGeneration ||
            previewGeneration !== state.modalPreviewGeneration ||
            refreshGeneration !== refreshSequence ||
            (state.root && !state.root.isConnected)
          ) return;

          syncMobileModalControlsFromState(state, { preserveActiveRangeDraft: true });
          updateMobileModalStagedUi(state);
        });
      }).catch(function (error) {
        console.warn('[KiekkoKingi] Staged filter preview failed:', error);
      });
    }

    window.clearTimeout(state.modalRefreshTimer);
    state.modalRefreshTimer = window.setTimeout(function () {
      state.modalRefreshTimer = null;
      refreshPreview();
    }, 200);

    if (pendingIndexPromise) {
      pendingIndexPromise.then(function () {
        if (
          state.destroyed ||
          workGeneration !== state.filterWorkGeneration ||
          previewGeneration !== state.modalPreviewGeneration ||
          !state.indexLoaded ||
          (state.root && !state.root.isConnected)
        ) return;

        refreshPreview();
      }).catch(function (error) {
        if (error && error.name !== 'AbortError') {
          console.warn('[KiekkoKingi] Final staged filter preview failed:', error);
        }
      });
    }
  }

  function queueApply(state, target) {
    if (isMobileFilterModal(target)) {
      queueMobileModalPreview(state);
      return;
    }

    state.visibleCount = state.perPage;
    applyCollection(state);
  }

  function getState(element) {
    var root = element && element.closest ? element.closest('[data-kk-headless-collection]') : null;

    if (root) {
      return states.get(root);
    }

    if (element && element.closest && element.closest('.modal--productgrid-filters')) {
      return activeState;
    }

    return null;
  }

  function handleInputChange(event) {
    var target = event.target;
    var state;
    var range;

    if (!target || !target.closest) {
      return;
    }

    state = getState(target);

    if (!state) {
      return;
    }

    // Handle sorting at the document capture phase. The collection utility
    // controls can be refreshed by the theme after filtering, which makes a
    // listener bound only to the original select unreliable. The select's
    // own listener still synchronizes the modal controls and stops the legacy
    // collection controller from starting a second request.
    if (target.matches('[data-productgrid-trigger-sort]')) {
      if (!target.value || state.sortBy === target.value) {
        return;
      }

      state.sortBy = target.value;
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.matches('[data-kk-headless-filter-input]')) {
      var filterItem = target.closest('.kk-facet__item');
      if (filterItem) {
        filterItem.classList.toggle('filter-item--active', target.checked);
        filterItem.classList.toggle('filter-item--inactive', !target.checked);
      }
      updateSelectedFromInput(state, target);
      queueApply(state, target);
      return;
    }

    range = target.closest('[data-kk-headless-native-range]');
    if (range) {
      applyHeadlessRange(range, target);
      queueApply(state, target);
      return;
    }

    range = target.closest('[data-kk-headless-price-range]');
    if (range) {
      applyPriceRange(range, target);
      queueApply(state, target);
    }
  }

  function handleClick(event) {
    var target = event.target;
    var state;
    var key;
    var toggle;
    var list;
    var hidden;

    if (!target || !target.closest) {
      return;
    }

    state = getState(target);
    if (!state) {
      return;
    }

    if (target.closest('[data-productgrid-trigger-filters]')) {
      var sidebarWrapper = state.root.querySelector('[data-kk-headless-filters-content]');
      primeIndex(state);
      // The mobile modal temporarily owns the filter wrapper's children. If an
      // AJAX/render race removes the returned wrapper altogether, Superstore's
      // bubble-phase modal handler has no target and the same click appears to
      // do nothing. Recreate a missing or empty wrapper synchronously here in
      // capture phase so this click can still open the filters.
      if ((!sidebarWrapper || sidebarWrapper.children.length === 0) && state.indexLoaded) {
        buildFilters(state);
        renderFilters(state);
      }
      window.setTimeout(function () {
        syncMobileModalControlsFromState(state);
        updateMobileModalStagedUi(state);
      }, 0);
      return;
    }

    if (target.closest('[data-kk-headless-load-more]')) {
      var loadMoreButton = target.closest('[data-kk-headless-load-more]');
      var previousVisibleCount;
      var focusOwned;

      event.preventDefault();

      if (state.loadMorePending) {
        return;
      }

      previousVisibleCount = Math.min(state.visibleCount, state.resultProducts.length);
      focusOwned = loadMoreButton === document.activeElement || loadMoreButton.contains(document.activeElement);
      state.loadMorePending = true;
      state.visibleCount = Math.min(previousVisibleCount + state.perPage, state.resultProducts.length);
      renderProducts(state, state.resultProducts.slice(0, state.visibleCount), {
        loadMore: {
          previousVisibleCount: previousVisibleCount,
          focusOwned: focusOwned
        }
      });
      return;
    }

    if (target.closest('[data-kk-headless-staged-remove-filter]')) {
      event.preventDefault();
      key = target.closest('[data-kk-headless-staged-remove-filter]').getAttribute('data-kk-headless-staged-remove-filter');
      state.selected.delete(key);
      syncMobileModalControlsFromState(state);
      queueMobileModalPreview(state);
      return;
    }

    if (target.closest('[data-kk-headless-staged-remove-range]')) {
      event.preventDefault();
      var stagedFacetKey = target.closest('[data-kk-headless-staged-remove-range]').getAttribute('data-kk-headless-staged-remove-range');
      var stagedRangeKeys = [];

      state.selected.forEach(function (item, itemKey) {
        if (inputFacetKey(item.input) === stagedFacetKey) {
          stagedRangeKeys.push(itemKey);
        }
      });
      stagedRangeKeys.forEach(function (itemKey) {
        state.selected.delete(itemKey);
      });
      state.rangeSelections.delete(stagedFacetKey);
      syncMobileModalControlsFromState(state);
      queueMobileModalPreview(state);
      return;
    }

    if (target.closest('[data-kk-headless-staged-remove-price]')) {
      event.preventDefault();
      state.priceMin = null;
      state.priceMax = null;
      syncMobileModalControlsFromState(state);
      queueMobileModalPreview(state);
      return;
    }

    if (target.closest('[data-kk-headless-filter-results]')) {
      var shouldApplyModalFilters = state.modalDirty;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (state.modalApplyPending) {
        return;
      }

      state.modalApplyPending = true;
      window.clearTimeout(state.modalRefreshTimer);
      state.modalRefreshTimer = null;
      state.modalDirty = false;

      // Ask the controller that owns the active modal to close it. A synthetic
      // click on the X control is ignored by the live Superstore modal path.
      document.dispatchEvent(new CustomEvent('kk:close-productgrid-filters'));

      if (!shouldApplyModalFilters) {
        state.modalApplyPending = false;
        return;
      }

      state.visibleCount = state.perPage;
      applyCollection(state).finally(function () {
        state.modalApplyPending = false;
      });
      return;
    }

    if (target.closest('.modal--productgrid-filters [data-modal-close]')) {
      if (state.modalDirty) {
        state.modalDirty = false;
        state.visibleCount = state.perPage;
        state.modalApplyPending = true;
        applyCollection(state).finally(function () {
          state.modalApplyPending = false;
        });
      } else {
        state.modalApplyPending = false;
      }
      return;
    }

    if (target.closest('[data-kk-headless-clear-all]')) {
      event.preventDefault();
      state.selected.clear();
      state.rangeSelections.clear();
      state.priceMin = null;
      state.priceMax = null;
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-price]')) {
      event.preventDefault();
      state.priceMin = null;
      state.priceMax = null;
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-filter]')) {
      event.preventDefault();
      key = target.closest('[data-kk-headless-remove-filter]').getAttribute('data-kk-headless-remove-filter');
      state.selected.delete(key);
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    if (target.closest('[data-kk-headless-remove-range-facet]')) {
      event.preventDefault();
      var facetKey = target.closest('[data-kk-headless-remove-range-facet]').getAttribute('data-kk-headless-remove-range-facet');
      var keysToRemove = [];
      state.selected.forEach(function (item, itemKey) {
        if (inputFacetKey(item.input) === facetKey) {
          keysToRemove.push(itemKey);
        }
      });
      keysToRemove.forEach(function (k) { state.selected.delete(k); });
      state.rangeSelections.delete(facetKey);
      state.visibleCount = state.perPage;
      applyCollection(state);
      return;
    }

    toggle = target.closest('[data-kk-headless-toggle-more]');
    if (toggle) {
      event.preventDefault();
      list = toggle.closest('[data-kk-headless-filter-list]');
      hidden = toggle.getAttribute('data-kk-headless-toggle-more') !== 'true';
      if (list) {
        list.querySelectorAll('[data-hidden-default]').forEach(function (item) {
          item.classList.toggle('filter-item--hidden', !hidden);
        });
        list.classList.toggle('kk-facet__list--expanded', hidden);
      }
      toggle.setAttribute('data-kk-headless-toggle-more', hidden ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', hidden ? 'true' : 'false');
      toggle.textContent = hidden
        ? (toggle.getAttribute('data-kk-headless-see-less-text') || t('see_less', 'See less'))
        : (toggle.getAttribute('data-kk-headless-see-more-text') || t('see_more', 'See more'));
    }
  }

  function handleFilterSearch(event) {
    var input = event.target;
    var list;
    var term;
    var expanded;
    var toggle;

    if (!input || !input.matches || !input.matches('[data-kk-headless-filter-search]')) {
      return;
    }

    list = input.closest('[data-kk-headless-facet]').querySelector('[data-kk-headless-filter-list]');
    term = input.value.trim().toLowerCase();

    if (!list) {
      return;
    }

    toggle = list.querySelector('[data-kk-headless-toggle-more]');
    expanded = toggle && toggle.getAttribute('data-kk-headless-toggle-more') === 'true';
    list.classList.toggle('kk-facet__list--expanded', Boolean(term) || Boolean(expanded));

    list.querySelectorAll('[data-kk-headless-filter-option]').forEach(function (item) {
      var text = (item.getAttribute('data-kk-headless-filter-search-text') || item.textContent || '').toLowerCase();
      var missing = item.hasAttribute('data-kk-headless-reconcile-missing');
      var matches = !missing && (!term || text.indexOf(term) !== -1);

      item.hidden = !matches;
      item.classList.toggle('kk-filter-option--search-hidden', !matches);

      if (term) {
        item.classList.toggle('filter-item--hidden', !matches);
      } else if (item.hasAttribute('data-hidden-default')) {
        item.classList.toggle('filter-item--hidden', !expanded);
      } else {
        item.classList.remove('filter-item--hidden');
      }
    });

    if (toggle) {
      var toggleItem = toggle.closest('.filter-item');

      if (toggleItem) {
        toggleItem.hidden = !!term || toggleItem.hasAttribute('data-kk-headless-no-overflow');
        toggleItem.classList.toggle('kk-filter-option--search-hidden', !!term);
      }
    }
  }

  function queueSearch(state) {
    window.clearTimeout(state.searchTimer);
    state.searchTimer = window.setTimeout(function () {
      state.visibleCount = state.perPage;
      applyCollection(state);
    }, 550);
  }

  function initSearch(state) {
    var root = state.root.querySelector('[data-kk-collection-search]');
    var input = root && root.querySelector('[data-kk-collection-search-input]');
    var submit = root && root.querySelector('[data-kk-collection-search-submit]');
    var clear = root && root.querySelector('[data-kk-collection-search-clear]');

    if (!root || !input) {
      return;
    }

    input.value = state.query;
    root.dataset.kkHeadlessCollectionSearchReady = 'true';

    input.addEventListener('input', function () {
      state.query = input.value.trim();
      if (clear) clear.hidden = !state.query;
      queueSearch(state);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        window.clearTimeout(state.searchTimer);
        state.query = input.value.trim();
        state.visibleCount = state.perPage;
        applyCollection(state);
      }
    });

    if (submit) {
      submit.addEventListener('click', function () {
        window.clearTimeout(state.searchTimer);
        state.query = input.value.trim();
        state.visibleCount = state.perPage;
        applyCollection(state);
      });
    }

    if (clear) {
      clear.hidden = !state.query;
      clear.addEventListener('click', function () {
        input.value = '';
        state.query = '';
        state.visibleCount = state.perPage;
        clear.hidden = true;
        applyCollection(state);
      });
    }
  }

  function initSort(state) {
    var sort = state.root.querySelector('[data-productgrid-trigger-sort]');
    var sortButtons = Array.prototype.slice.call(document.querySelectorAll('[data-productgrid-trigger-sort-button]'));

    function syncSortControls() {
      if (sort) {
        sort.value = state.sortBy || sort.value || '';
      }

      sortButtons.forEach(function (button) {
        var active = button.value === state.sortBy;

        button.disabled = active;
        button.classList.toggle('utils-sortby--modal-button--active', active);
      });
    }

    function applySort(value) {
      if (!value || state.sortBy === value) {
        syncSortControls();
        return;
      }

      state.sortBy = value;
      state.visibleCount = state.perPage;
      syncSortControls();
      applyCollection(state);
    }

    if (!sort) {
      return;
    }

    state.sortBy = state.sortBy || sort.value || '';
    syncSortControls();

    sort.addEventListener('change', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applySort(sort.value);
    }, true);

    sortButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applySort(button.value);
      }, true);
    });
  }

  function initRoot(root) {
    var state;
    var shouldRender;

    if (states.has(root)) {
      return;
    }

    state = {
      root: root,
      handle: root.getAttribute('data-kk-collection-handle') || '',
      collectionCount: parseInt(root.getAttribute('data-kk-collection-count'), 10) || 0,
      indexItems: parseInt(root.getAttribute('data-kk-index-items'), 10) || 0,
      indexPageSize: parseInt(root.getAttribute('data-kk-index-page-size'), 10) || INDEX_PAGE_SIZE,
      indexPages: parseInt(root.getAttribute('data-kk-index-pages'), 10) || 0,
      perPage: Math.min(250, Math.max(1, parseInt(root.getAttribute('data-kk-products-per-page'), 10) || 24)),
      tagLimit: Math.max(1, parseInt(root.getAttribute('data-kk-filter-limit'), 10) || 5),
      showProductCounts: root.getAttribute('data-kk-show-product-counts') === 'true',
      selected: new Map(),
      rangeSelections: new Map(),
      filters: [],
      priceMin: null,
      priceMax: null,
      priceBoundMax: 0,
      currencyCode: config.currencyCode || 'EUR',
      query: '',
      sortBy: '',
      loadedCount: 0,
      visibleCount: 0,
      resultProducts: [],
      indexProducts: [],
      indexFacetDefinitions: [],
      indexProductHandles: new Map(),
      indexFacetCounts: new Map(),
      indexPriceMin: null,
      indexPriceMax: 0,
      indexAccumulatorReady: false,
      indexLoaded: false,
      indexPromise: null,
      indexSortBy: root.getAttribute('data-kk-default-index-sort') || '',
      indexGeneration: 0,
      partialRendered: false,
      partialRenderTimer: null,
      partialFilterGeneration: 0,
      incrementalFiltersReady: false,
      contextualResultProducts: null,
      contextualResultCount: 0,
      contextualResultGeneration: -1,
      destroyed: false,
      indexAbortController: null,
      indexCacheWriteHandle: null,
      indexCacheWriteUsesIdle: false,
      sidebarRerenderTimer: null,
      modalDirty: false,
      modalRefreshTimer: null,
      modalApplyPending: false,
      modalApplyTimer: null,
      searchTimer: null,
      filterWorkGeneration: 0,
      filterRenderGeneration: 0,
      filterRenderPromise: null,
      activeApplyGeneration: 0,
      modalPreviewGeneration: 0,
      vendorLogos: new Map(),
      vendorLogoAliases: new Map(),
      vendorLogoPromise: null,
      vendorLogoTimer: null,
      resultsRenderGeneration: 0,
      loadMorePending: false,
      filterListPointerCount: 0,
      pendingFilterCountUpdate: false,
      pendingFilterReorder: false,
      pendingFilterRender: false,
      filterCountFlushTimer: null
    };

    resetIncrementalIndexData(state);
    states.set(root, state);
    activeState = state;
    window.KKHeadlessDebug = state;
    readUrlState(state);
    initSearch(state);
    initSort(state);
    watchSidebar(state);

    state.visibleCount = state.perPage;
    shouldRender = Boolean(
      state.query || state.selected.size || state.rangeSelections.size ||
      state.priceMin !== null || state.priceMax !== null
    );
    if (shouldRender) {
      applyCollection(state, { render: true });
    } else {
      primeIndex(state);
    }
    state.vendorLogoTimer = window.setTimeout(function () {
      state.vendorLogoTimer = null;
      primeVendorLogos(state);
    }, VENDOR_LOGO_START_DELAY);
  }

  function initAll() {
    document.querySelectorAll('[data-kk-headless-collection]').forEach(initRoot);
  }

  function destroySectionRoots(event) {
    var section = event && event.target;

    if (!section || !section.querySelectorAll) return;

    section.querySelectorAll('[data-kk-headless-collection]').forEach(function (root) {
      var state = states.get(root);

      if (!state) return;
      state.destroyed = true;
      state.filterRenderGeneration += 1;
      state.filterRenderPromise = null;
      if (state.indexAbortController) state.indexAbortController.abort();
      if (state.sidebarObserver) state.sidebarObserver.disconnect();
      window.clearTimeout(state.sidebarRerenderTimer);
      resetIndex(state);
      window.clearTimeout(state.modalRefreshTimer);
      window.clearTimeout(state.modalApplyTimer);
      window.clearTimeout(state.searchTimer);
      window.clearTimeout(state.vendorLogoTimer);
      window.clearTimeout(state.filterCountFlushTimer);
      activeFilterPointers.forEach(function (pointerState, pointerId) {
        if (pointerState === state) activeFilterPointers.delete(pointerId);
      });
      state.resultsRenderGeneration += 1;
      if (activeState === state) activeState = null;
      states.delete(root);
    });
  }

  function handleFilterViewportChange() {
    var state = activeState;

    if (!state) return;
    if (state.filterRenderPromise) {
      state.filterRenderPromise.then(function () {
        if (activeState === state && !state.destroyed) syncAllFilterOptionLimits(state);
      }).catch(function (error) {
        console.warn('[KiekkoKingi] Filter breakpoint sync failed:', error);
      });
      return;
    }
    syncAllFilterOptionLimits(state);
  }

  document.addEventListener('change', handleInputChange, true);
  document.addEventListener('pointerdown', handleFilterPointerDown, true);
  document.addEventListener('pointerup', handleFilterPointerEnd, true);
  document.addEventListener('pointercancel', handleFilterPointerEnd, true);
  document.addEventListener('focusout', handleFilterFocusOut, true);
  window.addEventListener('blur', releaseAllFilterPointers);
  document.addEventListener('input', function (event) {
    handleFilterSearch(event);

    var target = event.target;
    if (!target || !target.closest) return;
    var range = target.closest('[data-kk-headless-price-range], [data-kk-headless-native-range]');
    if (range) {
      updateRangeTooltips(range);
    }
  }, true);
  document.addEventListener('click', handleClick, true);
  document.addEventListener('error', function (event) {
    var target = event.target;

    if (target && target.classList && (target.classList.contains('kk-facet__vendor-logo') || target.classList.contains('kk-facet__profile-image'))) {
      target.remove();
    }
  }, true);

  initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', destroySectionRoots);
  window.addEventListener('popstate', function () {
    var state = activeState;

    if (!state || state.destroyed || (state.root && !state.root.isConnected)) return;
    readUrlState(state);
    state.visibleCount = state.perPage;
    applyCollection(state);
  });

  if (window.matchMedia) {
    var filterViewportQuery = window.matchMedia('(max-width: 859px)');
    if (filterViewportQuery.addEventListener) {
      filterViewportQuery.addEventListener('change', handleFilterViewportChange);
    } else if (filterViewportQuery.addListener) {
      filterViewportQuery.addListener(handleFilterViewportChange);
    }
  }
}());

/* Headless mobile filter dialog accessibility lifecycle. */
(function () {
  var MOBILE_FILTER_QUERY = '(max-width: 859px)';
  var DIALOG_ID = 'kk-headless-mobile-filter-dialog';
  var DIALOG_TITLE_ID = DIALOG_ID + '-title';
  var observedModal = null;
  var modalObserver = null;
  var opener = null;
  var openerRoot = null;
  var openerCollectionHandle = '';
  var dialogOpen = false;
  var previousDialogAttributes = null;
  var focusTimer = null;
  var focusGeneration = 0;
  var focusRestorePending = false;
  var triggerRootObservers = new Map();
  var triggerSyncTimer = null;

  function isMobileFilterViewport() {
    return !window.matchMedia || window.matchMedia(MOBILE_FILTER_QUERY).matches;
  }

  function getModal() {
    return document.querySelector('[data-modal-container]');
  }

  function isHeadlessFilterTrigger(element) {
    return Boolean(
      element &&
      element.matches &&
      element.matches('[data-productgrid-trigger-filters]') &&
      element.closest('[data-kk-headless-collection]')
    );
  }

  function getHeadlessFilterTriggers() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '[data-kk-headless-collection] [data-productgrid-trigger-filters]'
    ));
  }

  function ensureDialogId() {
    var modal = getModal();

    if (!modal) return '';
    if (!modal.id) modal.id = DIALOG_ID;

    return modal.id;
  }

  function syncTriggerAttributes(expandedTrigger) {
    var dialogId = ensureDialogId();

    if (!dialogId) return;

    getHeadlessFilterTriggers().forEach(function (trigger) {
      trigger.setAttribute('aria-controls', dialogId);
      trigger.setAttribute('aria-expanded', trigger === expandedTrigger ? 'true' : 'false');
    });
  }

  function nodeContainsFilterTrigger(node) {
    return Boolean(
      node &&
      node.nodeType === 1 &&
      (
        (node.matches && node.matches('[data-productgrid-trigger-filters]')) ||
        (node.querySelector && node.querySelector('[data-productgrid-trigger-filters]'))
      )
    );
  }

  function queueTriggerAttributeSync() {
    if (triggerSyncTimer !== null) return;

    triggerSyncTimer = window.setTimeout(function () {
      triggerSyncTimer = null;
      syncTriggerAttributes(dialogOpen ? findCurrentOpener() : null);
    }, 0);
  }

  function observeTriggerRoot(root) {
    var observer;
    var trigger;
    var observerRoot;

    if (!window.MutationObserver || !root || triggerRootObservers.has(root)) return;

    trigger = root.querySelector('[data-productgrid-trigger-filters]');
    observerRoot = trigger && trigger.parentElement;
    if (!observerRoot) return;

    observer = new MutationObserver(function (mutations) {
      var triggerChanged = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, nodeContainsFilterTrigger) ||
          Array.prototype.some.call(mutation.removedNodes, nodeContainsFilterTrigger);
      });

      if (triggerChanged) queueTriggerAttributeSync();
    });
    // The trigger lives in a tiny utility wrapper. Facet/result mutations do
    // not replace that wrapper, so observing the complete collection subtree
    // only multiplied callbacks during progressive index rendering.
    observer.observe(observerRoot, { childList: true, subtree: true });
    triggerRootObservers.set(root, observer);
  }

  function disconnectTriggerRoot(root) {
    var observer = triggerRootObservers.get(root);

    if (observer) observer.disconnect();
    triggerRootObservers.delete(root);
  }

  function observeHeadlessTriggerRoots() {
    document.querySelectorAll('[data-kk-headless-collection]').forEach(observeTriggerRoot);
  }

  function rememberOpener(trigger) {
    opener = trigger;
    openerRoot = trigger.closest('[data-kk-headless-collection]');
    openerCollectionHandle = openerRoot ? (openerRoot.getAttribute('data-kk-collection-handle') || '') : '';
  }

  function findCurrentOpener() {
    var replacementRoot;

    if (opener && opener.isConnected) return opener;

    if (openerRoot && openerRoot.isConnected) {
      opener = openerRoot.querySelector('[data-productgrid-trigger-filters]');
      if (opener) return opener;
    }

    if (openerCollectionHandle) {
      getHeadlessFilterTriggers().some(function (trigger) {
        var root = trigger.closest('[data-kk-headless-collection]');

        if (root && root.getAttribute('data-kk-collection-handle') === openerCollectionHandle) {
          openerRoot = root;
          opener = trigger;
          return true;
        }

        return false;
      });
    }

    if (!opener || !opener.isConnected) {
      opener = getHeadlessFilterTriggers()[0] || null;
      openerRoot = opener ? opener.closest('[data-kk-headless-collection]') : null;
    }

    return opener;
  }

  function readDialogAttributes(modal) {
    return {
      role: modal.getAttribute('role'),
      ariaModal: modal.getAttribute('aria-modal'),
      ariaLabel: modal.getAttribute('aria-label'),
      ariaLabelledby: modal.getAttribute('aria-labelledby')
    };
  }

  function restoreAttribute(element, name, value) {
    if (value === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  }

  function getDialogHeading(modal) {
    var heading = modal.querySelector('[data-modal-content] .productgrid--sidebar-title');

    if (heading && !heading.id) heading.id = DIALOG_TITLE_ID;

    return heading;
  }

  function getDialogFallbackLabel(trigger) {
    var label = trigger && (trigger.getAttribute('aria-label') || trigger.textContent);

    return String(label || 'Filters').replace(/\s+/g, ' ').trim();
  }

  function hasDifferentModalType(modal) {
    if (!modal || !modal.classList) return false;

    return Array.prototype.some.call(modal.classList, function (className) {
      return className.indexOf('modal--') === 0 && className !== 'modal--productgrid-filters';
    });
  }

  function isVisibleMobileOpener(trigger) {
    var style;

    if (
      !isMobileFilterViewport() ||
      !trigger ||
      !trigger.isConnected ||
      trigger.hidden ||
      trigger.disabled ||
      trigger.closest('[hidden], [aria-hidden="true"], [inert]')
    ) {
      return false;
    }

    if (window.getComputedStyle) {
      style = window.getComputedStyle(trigger);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }

    return !trigger.getClientRects || trigger.getClientRects().length > 0;
  }

  function cancelFocusRestore() {
    focusRestorePending = false;
    focusGeneration += 1;
    window.clearTimeout(focusTimer);
    focusTimer = null;
  }

  function focusDialogIfNeeded(modal) {
    var generation = focusGeneration;

    window.clearTimeout(focusTimer);
    focusTimer = window.setTimeout(function () {
      var focusTarget;

      focusTimer = null;

      if (
        generation !== focusGeneration ||
        !dialogOpen ||
        !modal.isConnected ||
        !modal.classList.contains('modal--productgrid-filters') ||
        modal.contains(document.activeElement)
      ) {
        return;
      }

      focusTarget = modal.querySelector(
        '[data-modal-close], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
      );

      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      }
    }, 0);
  }

  function activateDialog(modal) {
    var currentOpener = findCurrentOpener();
    var heading;

    window.clearTimeout(focusTimer);
    focusTimer = null;
    focusGeneration += 1;
    focusRestorePending = false;

    if (!dialogOpen) {
      previousDialogAttributes = readDialogAttributes(modal);
      dialogOpen = true;
    }

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');

    heading = getDialogHeading(modal);
    if (heading) {
      modal.setAttribute('aria-labelledby', heading.id);
      modal.removeAttribute('aria-label');
    } else {
      modal.removeAttribute('aria-labelledby');
      modal.setAttribute('aria-label', getDialogFallbackLabel(currentOpener));
    }

    syncTriggerAttributes(currentOpener);
    focusDialogIfNeeded(modal);
  }

  function restoreFocusToOpener() {
    var generation = ++focusGeneration;

    window.clearTimeout(focusTimer);
    focusTimer = window.setTimeout(function () {
      var trigger;
      var modal = getModal();

      focusTimer = null;

      if (
        generation !== focusGeneration ||
        dialogOpen
      ) {
        return;
      }

      if (!isMobileFilterViewport() || hasDifferentModalType(modal)) {
        cancelFocusRestore();
        return;
      }

      if (
        (modal && modal.classList.contains('modal--productgrid-filters')) ||
        (document.body && document.body.classList.contains('modal-visible'))
      ) {
        return;
      }

      trigger = findCurrentOpener();
      if (!isVisibleMobileOpener(trigger) || typeof trigger.focus !== 'function') {
        cancelFocusRestore();
        return;
      }

      focusRestorePending = false;

      try {
        trigger.focus({ preventScroll: true });
      } catch (error) {
        trigger.focus();
      }
    }, 0);
  }

  function deactivateDialog(modal, restoreFocus) {
    var previous = previousDialogAttributes;
    var wasOpen = dialogOpen;

    dialogOpen = false;
    previousDialogAttributes = null;
    syncTriggerAttributes(null);

    if (previous) {
      restoreAttribute(modal, 'role', previous.role);
      restoreAttribute(modal, 'aria-modal', previous.ariaModal);
      restoreAttribute(modal, 'aria-label', previous.ariaLabel);
      restoreAttribute(modal, 'aria-labelledby', previous.ariaLabelledby);
    }

    if (wasOpen && restoreFocus) {
      focusRestorePending = true;
      restoreFocusToOpener();
    } else if (wasOpen) {
      focusRestorePending = false;
    }
  }

  function syncDialogState(options) {
    var modal = getModal();
    var differentModalOpen = hasDifferentModalType(modal);
    var filterModalOpen = Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body &&
      document.body.classList.contains('modal-visible')
    );

    if (differentModalOpen) {
      if (dialogOpen && modal) deactivateDialog(modal, false);
      cancelFocusRestore();
      syncTriggerAttributes(null);
      return;
    }

    if (filterModalOpen && isMobileFilterViewport()) {
      activateDialog(modal);
      return;
    }

    if (dialogOpen && modal) {
      deactivateDialog(modal, !options || options.restoreFocus !== false);
    } else {
      syncTriggerAttributes(null);
      if (
        focusRestorePending &&
        (!isMobileFilterViewport() || hasDifferentModalType(modal))
      ) {
        cancelFocusRestore();
        return;
      }
      if (
        focusRestorePending &&
        modal &&
        !modal.classList.contains('modal--productgrid-filters') &&
        (!document.body || !document.body.classList.contains('modal-visible'))
      ) {
        restoreFocusToOpener();
      }
    }
  }

  function observeModal() {
    var modal = getModal();
    var modalContent;

    if (!window.MutationObserver || !modal || modal === observedModal) return;

    if (modalObserver) modalObserver.disconnect();
    observedModal = modal;
    modalContent = modal.querySelector('[data-modal-content]');
    modalObserver = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        return mutation.type === 'childList' ||
          (mutation.type === 'attributes' && (
            mutation.target === modal || mutation.target === document.body
          ));
      });

      if (shouldSync) syncDialogState();
    });
    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
    if (modalContent) modalObserver.observe(modalContent, { childList: true });
    if (document.body) {
      modalObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  function initDialogAccessibility() {
    observeModal();
    observeHeadlessTriggerRoots();
    syncTriggerAttributes(dialogOpen ? findCurrentOpener() : null);
    syncDialogState({ restoreFocus: false });
  }

  function destroyDialogAccessibilityForSection(event) {
    var section = event && event.target;
    var roots = [];
    var remainingRoot;

    if (!section || !section.querySelectorAll) return;
    if (section.matches && section.matches('[data-kk-headless-collection]')) roots.push(section);
    section.querySelectorAll('[data-kk-headless-collection]').forEach(function (root) {
      roots.push(root);
    });

    roots.forEach(function (root) {
      disconnectTriggerRoot(root);
      if (openerRoot === root) {
        opener = null;
        openerRoot = null;
        openerCollectionHandle = '';
      }
    });

    window.clearTimeout(triggerSyncTimer);
    triggerSyncTimer = null;

    remainingRoot = Array.prototype.some.call(
      document.querySelectorAll('[data-kk-headless-collection]'),
      function (root) {
        return root.isConnected && roots.indexOf(root) === -1;
      }
    );

    if (!remainingRoot) {
      cancelFocusRestore();
      if (modalObserver) modalObserver.disconnect();
      modalObserver = null;
      observedModal = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest ?
      event.target.closest('[data-productgrid-trigger-filters]') :
      null;

    if (!isMobileFilterViewport() || !isHeadlessFilterTrigger(trigger)) return;

    rememberOpener(trigger);
    observeModal();

    // The Superstore controller adds its modal class after delegated capture
    // listeners have run. Synchronise once more after that open path finishes.
    window.setTimeout(syncDialogState, 0);
  }, true);

  if (window.matchMedia) {
    var mobileFilterMedia = window.matchMedia(MOBILE_FILTER_QUERY);
    var handleViewportChange = function () {
      syncDialogState({ restoreFocus: false });
    };

    if (mobileFilterMedia.addEventListener) {
      mobileFilterMedia.addEventListener('change', handleViewportChange);
    } else if (mobileFilterMedia.addListener) {
      mobileFilterMedia.addListener(handleViewportChange);
    }
  }

  document.addEventListener('shopify:section:load', initDialogAccessibility);
  document.addEventListener('shopify:section:unload', destroyDialogAccessibilityForSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDialogAccessibility);
  } else {
    initDialogAccessibility();
  }
}());
